export const translation = {
  "Footer_Copyright": "由迅維公司提供技術支持",
  "Table_RowsPerPage": "每頁行數:",
  "MainMenu_Language": "語言",
  "MainMenu_CandidateLogin": "求職者登錄",
  "MainMenu_RecruiterLogin": "僱主登錄",
  "Recruiter_Menu_Dashboard": "求職者",
  "Recruiter_Menu_Statistics": "統計",
  "Recruiter_Menu_Settings": "職位及評核",
  "Recruiter_Menu_Settings_old": "職位和視像面試",
  "Recruiter_Menu_Review": "審核面試",
  "Recruiter_Menu_Greeting": "你好, {name}",
  "Recruiter_Menu_Logout": "登出帳戶",
  "Recruiter_Menu_AccountSetting": "帳戶設定",
  "Recruiter_Menu_LogoutInProgress": "登出中...",
  "Recruiter_Menu_Greeting_Acting": "你好, {name} (代理)",
  "Recruiter_Menu_Interview_Monitor": "面試監測",
  "Login_HiEmployer": "僱主， 你好",
  "Login_HiCandidate": "求職者， 你好",
  "Login_welcomeMessage": '歡迎來到 AIA Elite Academy 的視像面試',
  "Login_WelcomeBack": "歡迎使用我們的視像面試及評核",
  "Login_EnterYourDetailsBelow": "請輸入以下資料",
  "Login_Email": "電郵",
  "Login_ID": "使用者 ID",
  "Login_Password": "密碼",
  "Login_AccessCode": "訪問代碼",
  "Login_ForgotPassword": "忘記密碼？",
  "Login_RememberMe": "下次自動登入",
  "Login_Login": "登入",
  "Login_Terms_Prefix": "點擊\"登入\"，即表示你同意接受我們的 ",
  "Login_Terms_Suffix": ".",
  "Login_Terms_Conditions": "條款和條件",
  "Login_Terms_Conditions_Close": "關閉",
  "Login_Terms_Conditions_Content": ["<h2>迅維服務條款</h2>",
  "<h3>1. 條款</h3>",
  "<p>通過訪問網站 <a href='http://www.neufast.com'>http://www.neufast.com</a>, 你同意受這些服務條款，所有適用法律和法規的約束，並同意你有責任遵守任何適用的當地法律。 如果你不同意其中任何一項條款，你將被禁止適用或訪問該網站。 本網站所含材料受適用的版權法和商標法保護。</p>",
  "<h3>2. 使用許可證</h3>",
  "<ol type='a'>",
  "<li>允許在迅維網站上臨時下載一份材料（信息或軟件）供個人使用，僅限非商業性臨時觀看。 這是許可證的授予，不是所有權的轉移，在這個許可下你不能:",
  "<ol type='i'>",
  "<li>修改或複製材料;</li>",
  "<li>將材料用於任何商業目的或任何公開展示（商業或非商業）;</li>",
  "<li>嘗試對迅維網站上包含的任何軟件進行反編譯或反向工程;</li>",
  "<li>刪除材料中的任何版權或其他專有標記; 或</li>",
  "<li>將材料轉移給其他人或\"鏡像\"任何其他服務器上的材料。</li>",
  "</ol>",
  "</li>",
  "<li>如果你違反上述任何限制，本許可證將自動終止，迅維可隨時終止此許可證。一旦終止查看這些材料或本許可證終止時，你必需销毁所有電子或印刷材料的已下載資料。</li>",
  "</ol>",
  "<h3>3. 免責聲明</h3>",
  "<ol type='a'>",
  "<li>迅維網站上的資料按\"原樣\"提供。迅維不做任何明示或暗示的保證，並在此否認所有其他保證，包括但不限於對某個特殊目的的適用性或不侵犯知識產權或其他侵犯權利行為的保證或使用條件。</li>",
  "<li>此外, 迅維不保證或就其在互聯網網站上使用這些材料的準確性,可能的結果或可靠性或與此類材料或與本網站鏈接的任何網站有關的任何陳述。</li>",
  "</ol>",
  "<h3>4. 限制</h3>",
  "<p>在任何情況下，迅維或其他供應商均將不會因在迅維網站上使用或無法使用的這些材料產生任何損害（包括但不限於，因數據或利潤損失或由於業務中斷造成的損害）而承擔責任。即使迅維已經口頭或書面通知會發生此類損害。由于某些司法管辖区不允许限制默示担保或对间接损失或附带损失的责任限制，以上排除条款可能不适用于你。</p>",
  "<h3>5. 材料準確性</h3>",
  "<p>出現在迅維網站上的材料可能包括技術，字型設計或照片錯誤。迅維不保證網站上任何材料的準確性，完整度或更新狀態。迅維可隨時更改其網站上的資料，恕不另行通知。但是，迅維不承諾更新材料。</p>",
  "<h3>6. 連接</h3>",
  "<p>迅維尚未審查與其互聯網網站鏈接的所有網站，並且不對任何連結網站的內容負責。包含該連結並不表示迅維對該網站的認可。使用任何此類連結的風險由用戶自行承擔。</p>",
  "<h3>7. 修訂</h3>",
  "<p>迅維可能會隨時修訂網站上的服務條款，恕不另行通知。使用本網站即表示你同意遵守當前版本的服務條款。</p>",
  "<h3>8. 適用法律</h3>",
  "<p>這些使用條款和條件受香港法律管轄並依據香港法律進行解釋。你將不可撤銷地服從該地區法院的專屬管轄權。</p>",
  "<h3>9. 一般</h3>",
  "<p>儘管我們一直在嘗試執行嚴格的隱私政策和控制，但此網站尚未經過審核並確認我們完全遵守歐盟的《通用數據保護條例》（GDPR）。歐洲公民和居民的用戶在使用我們的服務之前，應了解並同意這一點。</p>",
  "<h3>10. 刪除個人資料</h3>",
  "<p>在你關閉用戶帳戶三個月後，你賬戶内的姓名，電子郵件地址和登錄信息將從我們的系統中刪除。非個人信息：例如瀏覽信息，工作信息，面試問題，視頻，分數和評論，將被匯總並存儲在我們的系統中，以提高評核和服務質量。</p>",
  "<h3>11. 無權利限制</h3>",
  "<p>本聲明中的任何內容均不會限制根據《個人數據（隱私）條例》（PDPO）對數據主體的任何權利</p>",

  ],
  "Login_Privacy_Policy" : "私隱政策聲明",
  "Login_Privacy_Policy_Close": "關閉",
  "Login_Privacy_Policy_Content":[
    "<h2>私隱政策聲明 （PPS）</h2>",
    "<p>Neufast Limited （\"本公司\"）致力尊重及保障消費者的個人資料，並承諾遵守個人資料私隱專員公署（私隱專員公署）發出的《個人資料（私隱）條例》（\"條例\"）的保障資料原則及所有相關條文。數據由公司的網站服務 Neufast.com（\"網站\"）收集。本公司的繳費靈是關於與其處理的個人數據有關的隱私政策和慣例的一般聲明.</p>",
    "<h3>1。實踐聲明</h3>",
    "<ol type='a'>",
    "<li>收集以下個人數據：",
    "<ol type='i'>",
    "<li>人事記錄，包括使用者的姓名、電子郵件、電話號碼和簡歷</li>",
    "<li>評估記錄，包括用戶的表現，包括文本、音訊和視頻格式的視頻和答案</li>",
    "<li>操作參數，包括IP地址，設備類型，瀏覽器，操作系統，國家，操作記錄和日誌.</li>",
    "</ol>",
    "</li>",
    "<li>在使用本網站的過程中，使用者可能會披露或被要求提供個人資訊和/或數據。為了享受本網站提供的各種服務，使用者可能需要向公司提供其個人資訊和/或數據。雖然使用者沒有義務按照網站上的要求提供資訊和/或數據，但如果使用者未能提供某些服務，公司將無法在網站上提供某些服務</li>",
    "<li>使用者特此同意，使用者向公司提供的任何資訊都是自願的，並且是準確，真實，最新和完整的。如果不是這種情況或公司有合理的理由懷疑，公司有權取消和/或拒絕向使用者提供服務</li>",
    "</ol>",
    "<h3>2。收集目的</h3>",
    "<ol>",
    "<li>",
    "本公司收集和使用本網站上的資訊和數據的目的包括但不限於以下內容：",
    "<>",
    "<li>用於向使用者提供服務的日常運營;</li>",
    "<li>協助雇主評估候選人是否適合各種工作和行業的職位空缺;</li>",
    "<li>幫助使用者提升面試技巧</li>",
    "<li>處理和跟進用戶的查詢、要求和投訴;</li>",
    "<li>就與使用者使用本網站有關的行政通知和通信與用戶聯繫，並回應使用者的 詢問或請求;</li>",
    "<li>協助公司為未來的營銷和推廣目的或其他內部目的進行開發;</li>",
    "<li>為方便本公司及/或關聯公司將使用者的 個人資料用於與提供本公司提供的服務有關的目的;</li>",
    "<li>獲取有關用戶的統計數據,以分析本網站的使用方式，以説明其進一步發展以供內部使用;和</li>",
    "<li>説明改進網站為所述相關目的提供的服務.</li>",
    "</ul>",
    "</li>",
    "<li>如果使用者未滿18歲，公司強烈建議他/她事先徵得對他/她負有父母責任的人的同意，例如父母或監護人，他們可以聯繫負責的客戶支援主管，其聯繫方式列在標題為\"查詢\"的部分，以將使用者註冊為網站會員.</li>",
    "<li>本公司努力只收集與上述目的有關的必要和充分但不過度的個人數據.</li>",
    "<li>如果公司要求將您的個人數據用於上述目的以外的目的，我們將徵求您的指定同意。如果您是未成年人，則應由您的父母或監護人給予規定的同意.</li>",
    "</ol>",
    "<h3>3。數據保護原則</h3>",
    "所有個人數據的處理均應根據以下數據保護原則進行：",
    "<ul>",
    "<li>個人數據必須合法、公平和透明地處理</li>",
    "<li>個人數據只能用於特定、明確和合法的目的</li>",
    "<li>個人數據必須相關且僅限於處理所需的內容</li>",
    "<li>個人數據必須準確並保持最新狀態，盡一切努力刪除或更正.</li>",
    "<li>個人數據必須以以下形式保存：只有在處理需要時才可以識別數據主體</li>",
    "<li>個人數據的處理方式必須確保適當的安全性</li>",
    "</ul>",
    "<h3>4。數據清單</h3>",
    "<ol>",
    "<li>",
    "我們還保留了數據清單和數據流流程，以確定我們數據處理的各個方面，包括：",
    "<ul>",
    "<li>使用個人數據的業務流程.</li>",
    "<li>收集和/或使用個人數據的目的.</li>",
    "<li>個人數據來源.</li>",
    "<li>處理活動.</li>",
    "<li>任何數據傳輸，以及向誰傳輸</li>",
    "<li>任何數據訪問、更正或退出宣告請求。這種數據清單將促進.</li>",
    "</ul>",
    "</li>",
    "<li>Neufast Limited跟蹤其數據和相關處理活動，並使我們能夠更好地遵守相關隱私和其他法律法規.</li>",
    "</ol>",
    "<h3>5。安全性</h3>",
    "<p>用戶個人資訊和數據的安全性對Neufast Limited非常重要。我們將始終努力確保使用者的個人資訊和數據受到保護，防止未經授權的訪問。我們已實施適當的電子和管理措施，以維護，保護和保護使用者的個人資訊和數據.</p>",
    "<p>使用者提供的所有個人資訊和數據只能由公司的授權人員或其授權的第三方訪問，並且應指示此類人員在訪問此類個人資訊和數據時遵守本隱私聲明的條款。使用者可以放心，他們的個人資訊和數據只會在實現收集目的所需的時間內保留。註冊用戶應通過保密來保護他/她的唯一使用者名和密碼，切勿與任何人分享這些詳細資訊.</p>",
    "<p>公司使用第三方服務提供者來促進網站上的電子支付交易.</p>",
    "<p>公司遵循普遍接受的行業標準來保護使用者在傳輸過程中和收到后提交給本網站的個人資訊和數據。但是，沒有任何一種互聯網傳輸方法或電子存儲方法是100%安全的。因此，雖然我們努力保護使用者的個人資訊 和數據免受未經授權的訪問，但公司不能保證其絕對安全</p>",
    "<h3>6。數據處理的法律依據</h3>",
    "<p>我們確保我們處理個人數據有法律依據。此類法律依據包括：（i）Neufast Limited在處理個人數據方面的合法商業利益;（ii） 如果適用法律或法規要求，尋求您的明確同意以處理此類個人數據;和/或 （iii） 適用法律和法規下的任何其他相關依據.</p>",
    "<h4>合法權益</h4>",
    "<p>Neufast Limited根據\"合法利益\"法律依據處理個人數據，這意味著處理個人數據對於Neufast Limited追求的合法利益是必要的，除非這些利益被需要保護個人數據的數據主體的利益或基本權利和自由所覆蓋</p>",
    "<h4>合法利益評估</h4>",
    "<p>在每一種相關情況下，我們評估：（一） 這些合法利益是什麼;（二） 這些合法利益是什麼;（三） 這些合法利益是什麼。（ii） 是否需要處理該等數據以達致目標;以及 （iii） 數據主體的相關權利;並在我們得出結論認為Neufast有限公司可以根據合法利益處理個人數據之前，平衡這些權利與我們的利益，並確保這些權利不會淩駕於Neufast有限公司的合法利益之上</p>",
    "<h4>與數據主體溝通</h4>",
    "<p>所有數據主體都將被告知我們正在收集他們的個人數據、相關個人數據的類別和處理目的。這是為了確保數據主體清楚我們對個人數據的收集和處理，並且此類收集和處理在數據主體的 合理預期範圍內。請注意，所有數據主體都可以隨時反對我們收集和處理其個人數據，以及他們有權要求訪問和/或更正我們擁有的個人數據.</p>",
    "<h4>數據安全機制</h4>",
    "<p>我們還實施了適當的機制、政策和程式來保護我們收集和處理的個人數據的機密性和安全性,因為我們尊重數據主體與此類個人數據相關的隱私和相關權利,降低處理的風險或潛在負面影響,包括但不限於數據最小化, 去標識化、加密、限制訪問和所有其他技術安全方法和保護個人數據的努力。對數據主體的隱私和相關權利的這種保護將使Neufast Limited能夠在合法利益法律基礎上處理個人數據。在徹底進行上述評估后,Neufast Limited得出結論，其正在根據以下合法利益收集和處理個人數據：</p>",
    "<ol type='a'>",
    "<li>",
    "<p>滿足客戶和運營需求 處理個人數據類別的主要目的已在上文</p>",
    "<p>Neufast Limited有合法利益處理相同的內容，因為所有這些目的對於Neufast Limited作為公司和技術組織為其客戶提供服務及其運營需求至關重要</p>",
    "<p>像Neufast Limited這樣的公司需要員工為其業務（以及人事記錄）和服務提供者工作，以保持其運行（因此需要其他運營記錄)</p>",
    "<p>像Neufast這樣的技術組織需要開發技術，以進一步增強服務所需的技術，以服務於人力資源和教育領域的客戶.</p>",
    "</li>",
    "<li>",
    "<p>通知公眾</p>",
    "<p>作為一個招聘組織，Neufast Limited尊重公眾瞭解我們社區和世界正在發生的事情的權利。Neufast Limited根據法律和新聞道德都有責任告知公眾此類事件（\"告知義務\"）</p>",
    "<p>這些建議並不禁止或限制任何人查看他們可以隨時訪問的此類網站上的所有其他文章或內容.</p>",
    "</li>",
    "<li>",
    "<p>同意</p>",
    "<p>如果適用的法律要求要求在處理個人數據（包括進行直接行銷）之前必須獲得特定同意，我們將確保獲得以下特定同意：</p>",
    "<ol type='a'>",
    "<li>同意必須清楚、明確和具體;</li>",
    "<li>數據主體完全了解我們打算使用的個人數據類型;以及該等使用的目的（例如改善我們對資料當事人的服務或直接促銷）;和</li>",
    "<li>受讓人的姓名/身份（如果我們打算轉移您的數據）以及受讓人應如何使用您的個人數據.</li>",
    "</ol>",
    "</li>",
    "</ol>",
    "<h3>7。數據主體的權利</h3>",
    "<p>Neufast Limited尊重數據主體對數據處理以及記錄的有關他們的數據擁有以下權利：</p>",
    "<ol>",
    "<li>請求查閱所持有資料的性質和向誰披露資料</li>",
    "<li>防止可能造成損害或痛苦的處理</li>",
    "<li>防止為直接行銷目的進行處理.</li>",
    "<li>瞭解將對它們產生重大影響的自動化決策過程（如果有的話）的機制</li>",
    "<li>不讓影響他們的重大決定完全通過自動化流程</li>",
    "<li>採取行動糾正、阻止和刪除，包括被遺忘或銷毀不準確數據的權利.</li>",
    "<li>請求監督機構（例如隱私專員或數據保護官），以評估是否違反了相關隱私和其他法律的任何規定.</li>",
    "<li>以結構化、常用和機器可讀的格式向他們提供個人數據，並有權將此類數據傳輸給另一個數據控制者</p>",
    "<li>反對正在發生的任何自動分析</li>",
    "</ol>",
    "<h3>8。個人數據的傳輸</h3>",
    "<p>我們將對我們持有的個人數據保密，這些數據可能會出於上述目的轉移給以下各方.</p>",
    "<ol>",
    "<li>雲服務提供者、承包商或第三方，他們/他們為Neufast Limited的運營提供行政、技術或其他服務;</li>",
    "<li>向任何†主管執法機構、監管機構、政府機構、法院或其他第三方†如果我們認為有必要披露（i）作為適用法律或法規的問題，（ii）行使、建立或捍衛我們的合法權利，或（iii）保護您或任何其他人的切身利益;</li>",
    "<li>與我們業務任何部分的任何擬議購買、重組、合併或收購有關，前提是我們告知買方其必須僅將您的個人資訊用於本隱私聲明中披露的目的;</li>",
    "<li>Neufast Limited.</li>的任何關聯公司",
    "</ol>",
    "<p>在發生此類轉移的情況下，Neufast Limited應使用合同或其他方式確保數據傳輸的個人數據保密，並遵守所有相關的個人數據隱私法律法規。</p>",
    "<p>如上所述，如果您是候選人、員工或實習生，並且我們通過服務收集您的個人資訊，我們將根據我們與客戶簽訂的協定代表客戶收集這些資訊。有關如何與第三方共用您的個人資訊的更多資訊，您應該聯繫相關潛在僱主或參考該潛在僱主的隱私政策/隱私聲明.</p>",
    "<p>關於上文第（iv）分款所述情況 - 如果Neufast Limited關聯公司之間的此類集團內部傳輸涉及跨境數據傳輸，Neufast Limited可能會採用具有約束力的公司規則來保護此類個人數據的安全;並確保所有相關關聯公司均遵守相關隱私和其他法律.</p>",
    "<h3>9。個人數據的保留</h3>",
    "<p>一旦Neufast Limited獲得用戶的個人資訊和/或數據，它將在公司系統中安全地維護，以實現\"實踐聲明\"一節中規定的收集數據的目的.註冊后，用戶可以通過聯繫數據控制者（即使用者使用我們網站的僱主/培訓師）從網站中刪除其個人資訊或終止他/她的網站會員資格。即使在使用者關閉其帳戶后，如果保留對於遵守我們的法律義務、滿足監管要求、解決使用者之間的爭議、防止欺詐和濫用或執行本隱私聲明和條款和條件是合理必要的，公司也可以保留使用者的個人資訊。</p>",
    "<h3>10。本隱私聲明的變更</h3>",
    "<p>公司保留在公司認為必要時隨時更新、修訂、修改或修訂本隱私聲明的權利，因此強烈建議使用者經常查看本隱私聲明。如果公司決定更新，修訂，修改或修訂本隱私聲明，公司將把這些更改發佈到網站和/或公司認為適當的其他地方，以便使用者瞭解公司收集哪些資訊，我們如何使用這些資訊，以及在什麼情況下（如果有的話），公司會披露這些資訊。</p>",
    "<p>如果公司對本隱私聲明進行重大更改，我們將通過本網頁、電子郵件或網站主頁上的通知通知使用者。對本隱私聲明的此類更改應自公司在網站上發佈時起適用。用戶 繼續使用本網站和本網站上的服務即表示接受本隱私聲明的更改</p>",
    "<h3>11。Cookies 的使用</h3>",
    "<p>Cookie是網站在網站上傳輸到個人硬碟的資訊項，用於保存記錄。Cookie 通過為您保存密碼、購買和偏好等方式，使網上衝浪更加輕鬆。Cookie 的使用是行業標準，您可以在大多數主要網站上找到 Cookie.</p>",
    "<p>cookie本身不包含任何個人識別資訊，儘管它可以使公司將使用者對服務的使用與使用者先前提交的個人識別資訊（如果有）聯繫起來。</p>",
    "<p>大多數瀏覽器最初都設置為接受cookie。如果您不希望披露上述資訊，則應將您的資訊設置為拒絕cookie。但是，如果您這樣做，網站的大多數區域可能無法正常運行.</p>",
    "<h3>12。外包安排</h3>",
    "<p>公司一直在利用其內部資源來開發和維護其IT系統。當公司聘請第三方供應商提供與其IT系統相關的某些服務時，供應商在通常情況下無法訪問存儲在IT系統中的個人數據</p>",
    "<p>在此類供應商具有此類訪問許可權的特殊情況下，公司採取合理措施確保：（i）該供應商受合同約束對此類個人數據保密，並採取適當手段防止任何未經授權的訪問，使用，丟失，保留，修改，轉移或其他方式。</p>",
    "<h3>13。查詢、撤回同意、查閱資料要求及查閱資料更正</h3>",
    "<p>任何個人都有權撤回同意我們處理他們的數據，進行查詢，要求訪問和更正我們持有的他或她的個人數據。請聯繫僱主或培訓師以訪問和更正數據。</p>",
    "如閣下欲查詢、查閱或更正我們所持有的閣下的個人資料，請將閣下的要求發送至：",
    "<p>數據隱私官</p>",
    "<p>Dr. Dennis Lee</p>",
    "<p>Neufast Limited</p>",
    "<p>位址：香港新界沙田科學園大道西2號2W大廈3樓2室</>",
    "<電話>電話： （+852）59876904</人>",
    "<p>電子郵件： customer-service@neufast.com</p>",
    "<h3>14。國際數據傳輸</h3>",
    "<p>用戶的個人資訊可能會被轉移到使用者居住國以外的國家/地區並在這些國家進行處理。這些國家/地區的數據保護法律可能與使用者所在國家/地區的法律不同。具體而言，除非當地法律另有要求，否則我們的網站、系統和提供的第三方服務均在歐洲經濟區、新加坡和香港特別行政區進行處理.</p>",
    "<p>但是，我們已採取適當的保護措施，要求使用者的個人資訊將根據本隱私聲明和適用法律繼續受到保護。如果使用者來自歐洲經濟區或英國，這些措施包括實施歐盟委員會的標準合同條款，以便在我們的集團公司之間以及與我們的第三方服務提供者和合作夥伴之間傳輸個人資訊。標準合同條款要求非歐洲經濟區公司根據歐洲經濟區數據保護法保護其處理的歐洲經濟區和英國個人資訊</p>",
    "<h3>15。刪除個人數據</h3>",
    "<p>雇主或培訓師充當數據控制者，控制系統上的個人數據。姓名、電子郵件、電話號碼、簡歷、圖像、原始視頻、音訊等個人數據可由僱主或培訓師在平臺上刪除。如果您是提供您的資料的使用者，請聯繫您使用我們平臺的公司以刪除您的個人資訊。此外，用戶的個人資訊將在您的使用者帳戶關閉三個月後從我們的系統中刪除。非個人資訊，如工作資訊、面試問題、編輯視頻、分數和答案，將匯總並存儲在我們的系統中，僅用於提高評估和服務品質。根據我們的同意，當僱主/培訓師通過電子郵件通知我們時，也可以刪除編輯的視頻和其他資訊 customer-service@neufast.com.</p>",
  ],
  "And": "和",
  "Login_Personal_Information_Collection" : "Personal Information Collection Statement",
  "Login_Personal_Information_Collection_Close": "關閉",
  "Login_Personal_Information_Collection_Content": [
    "<h2>Personal Information Collection Statement</h2>",
    "<p>Neufast Limited ('Company') is committed to protecting the respects personal data and is committed to protect compliance with the data protection principles and all relevant provisions of the Personal Data (Privacy) Ordinance ('Ordinance').</p>",
    "<h3>Purpose of Collection</h3>",
    "<ol>",
    "<li>The personal data collected from you will be used for the purpose of artificial intelligence (AI) video interview.</li>",
    "<li>",
    "<p>Personal data marked with (*) in this Personal Information Collection Statement is regarded as voluntary for purpose as stated in paragraphs 1 above. Failure to provide this data may affect the processing and outcome of your application. We will use data for the following purposes or any of them (which may vary depending on the nature of your relationship with us):</p>",
    "<ol type='a'>",
    "<li>to assist employers to assess the suitability of candidates for job vacancy for a wide spectrum of jobs and industries; and</li>",
    "<li>to help users to enhance their interview and presentation skills; and</li>",
    "<li>Any other purposes relating to the purposes listed above.</li>",
    "</ol>",
    "</li>",
    "<li>Your enquiry may also be used for the compilation of statistics on the number and nature of enquiries received by us. The outcome of the resulting statistics will not be in a form that will identify your enquiry and any of your personal data.</li>",
    "</ol>",
    "<h3>Statement of Possible Transferees</h3>",
    "<ol start='4'>",
    "<li>",
    "We will keep confidential the personal data that we hold, which may be transferred to the following parties for the purposes as stated above.",
    "<ol type='i'>",
    "<li>Cloud service providers, contractors or third parties which/who provide administrative, technology or other services to Neufast Limited for its operations; Microsoft is our service provider. No data storage is allowed for Microsoft. AWS and MongoDB Atlas is our data storage service provider.</li>",
    "<li>To any competent law enforcement body, regulatory, government agency, court or other third party where we believe disclosure is necessary (i) as a matter of applicable law or regulation, (ii) to exercise, establish or defend our legal rights, or (iii) to protect your vital interests or those of any other person;</li>",
    "</ol>",
    "</li>",
    "</ol>",
    "<h3>Direct Marketing</h3>",
    "<ol start='5'>",
    "<li>We may use your personal data in direct marketing, but we will not so use your personal data unless we have received your consent (which includes an indication of no objection to the intended use).</li>",
    "<li>You may, at any time without charge, choose to opt-out from us using your personal data for direct marketing by writing to our Data Privacy Officer stated in Statement 9.</li>",
    "<li>When you visit this website, we may use cookie files to store and track information about your preferences, purchases and saving passwords for the purposes of providing our services to you stated in ‘Purpose of Collection’ section.</li>",
    "</ol>",
    "<h3>Rights of Enquiries, Access and Correction to Personal Data</h3>",
    "<ol start='8'>",
    "<li>Under the PDPO, any individual has the right to make enquiries, request access to and correction of his or her personal data held by us. In accordance with the terms of the POPO, we have the right to charge a reasonable fee for the processing of any data access request.</li>",
    "</ol>",
    "<h3>Notice of Contact Person to Request Access of Correction:</h3>",
    "<ol start='9'>",
    "<li>",
    "<p>Please contact our following staff to request access or correction of your data.</p>",
    "<p>Data Privacy Officer</p>",
    "<p>Dr. Dennis Lee</p>",
    "<p>Neufast Limited</p>",
    "<p>Address: Unit 2, 3/F, Building 2W, No.2 Science Park Avenue West, Shatin, N.T., Hong Kong</p>",
    "<p>Email: customer-service@neufast.com</p>",
    "</li>",
    "</ol>",
    "<h3>Security Measures</h3>",
    "<ol start='10'>",
    "<li>All data in our system is encrypted during transit and storage. We have applied significant safety measures in a technical and organizational level to ensure the data is stored in a secure manner. However, please be aware that no physical or technical system is completely secure or immune from outages, losses, attacks, circumvention, design or implementation flaws, and human error. Therefore, we cannot and do not ensure or warrant that information you transmit to Neufast will not be lost or compromised, either during or after transmission.</li>",
    "<li>You are responsible for maintaining the secrecy of your unique password and account information at all times, to the extent your access includes an account and password (Candidates do not have an account and password when using the Services).</li>",
    "</ol>"
  ],
  // "Login_Terms": "隱私政策和條款及條件",
  // "Login_Terms_Close": "關閉",
  // "Login_Terms_Content": ["<h2>迅維服務條款</h2>",
  //   "<h3>1. 條款</h3>",
  //   "<p>通過訪問網站 <a href='http://www.neufast.com'>http://www.neufast.com</a>, 你同意受這些服務條款，所有適用法律和法規的約束，並同意你有責任遵守任何適用的當地法律。 如果你不同意其中任何一項條款，你將被禁止適用或訪問該網站。 本網站所含材料受適用的版權法和商標法保護。</p>",
  //   "<h3>2. 使用許可證</h3>",
  //   "<ol type='a'>",
  //   "<li>允許在迅維網站上臨時下載一份材料（信息或軟件）供個人使用，僅限非商業性臨時觀看。 這是許可證的授予，不是所有權的轉移，在這個許可下你不能:",
  //   "<ol type='i'>",
  //   "<li>修改或複製材料;</li>",
  //   "<li>將材料用於任何商業目的或任何公開展示（商業或非商業）;</li>",
  //   "<li>嘗試對迅維網站上包含的任何軟件進行反編譯或反向工程;</li>",
  //   "<li>刪除材料中的任何版權或其他專有標記; 或</li>",
  //   "<li>將材料轉移給其他人或"鏡像"任何其他服務器上的材料。</li>",
  //   "</ol>",
  //   "</li>",
  //   "<li>如果你違反上述任何限制，本許可證將自動終止，迅維可隨時終止此許可證。一旦終止查看這些材料或本許可證終止時，你必需销毁所有電子或印刷材料的已下載資料。</li>",
  //   "</ol>",
  //   "<h3>3. 免責聲明</h3>",
  //   "<ol type='a'>",
  //   "<li>迅維網站上的資料按"原樣"提供。迅維不做任何明示或暗示的保證，並在此否認所有其他保證，包括但不限於對某個特殊目的的適用性或不侵犯知識產權或其他侵犯權利行為的保證或使用條件。</li>",
  //   "<li>此外, 迅維不保證或就其在互聯網網站上使用這些材料的準確性,可能的結果或可靠性或與此類材料或與本網站鏈接的任何網站有關的任何陳述。</li>",
  //   "</ol>",
  //   "<h3>4. 限制</h3>",
  //   "<p>在任何情況下，迅維或其他供應商均將不會因在迅維網站上使用或無法使用的這些材料產生任何損害（包括但不限於，因數據或利潤損失或由於業務中斷造成的損害）而承擔責任。即使迅維已經口頭或書面通知會發生此類損害。由于某些司法管辖区不允许限制默示担保或对间接损失或附带损失的责任限制，以上排除条款可能不适用于你。</p>",
  //   "<h3>5. 材料準確性</h3>",
  //   "<p>出現在迅維網站上的材料可能包括技術，字型設計或照片錯誤。迅維不保證網站上任何材料的準確性，完整度或更新狀態。迅維可隨時更改其網站上的資料，恕不另行通知。但是，迅維不承諾更新材料。</p>",
  //   "<h3>6. 連接</h3>",
  //   "<p>迅維尚未審查與其互聯網網站鏈接的所有網站，並且不對任何連結網站的內容負責。包含該連結並不表示迅維對該網站的認可。使用任何此類連結的風險由用戶自行承擔。</p>",
  //   "<h3>7. 修訂</h3>",
  //   "<p>迅維可能會隨時修訂網站上的服務條款，恕不另行通知。使用本網站即表示你同意遵守當前版本的服務條款。</p>",
  //   "<h3>8. 適用法律</h3>",
  //   "<p>這些使用條款和條件受香港法律管轄並依據香港法律進行解釋。你將不可撤銷地服從該地區法院的專屬管轄權。</p>",
  //   "<h3>9. 一般</h3>",
  //   "<p>儘管我們一直在嘗試執行嚴格的隱私政策和控制，但此網站尚未經過審核並確認我們完全遵守歐盟的《通用數據保護條例》（GDPR）。歐洲公民和居民的用戶在使用我們的服務之前，應了解並同意這一點。</p>",
  //   "<h3>10. 刪除個人資料</h3>",
  //   "<p>在你關閉用戶帳戶三個月後，你賬戶内的姓名，電子郵件地址和登錄信息將從我們的系統中刪除。非個人信息：例如瀏覽信息，工作信息，面試問題，視頻，分數和評論，將被匯總並存儲在我們的系統中，以提高評核和服務質量。</p>",
  //   "<h3>11. 無權利限制</h3>",
  //   "<p>本聲明中的任何內容均不會限制根據《個人數據（隱私）條例》（PDPO）對數據主體的任何權利</p>",
  
  // ],
  "Forget_Password_Title": "忘記密碼",
  "Forget_Password_Subtitle": "請輸入你的登錄的電子郵件信箱，系統將於數分鐘內寄出重設密碼的電郵。",
  "Forget_Password_Success_Message": '重設密碼的電郵已寄到 {email}. 請檢查你的電子郵件信箱並按照電郵的指示重設密碼。',
  "Forget_Password_Email_Not_Found_Message": '你輸入的電子郵件地址尚未註冊。請確保輸入的資料正確。',
  "Reset_Password_Title": "重設密碼",
  "Reset_Password_Sutitle": "為了保護你的帳戶，請確保新的密碼： ",
  "Reset_Password_Sutitle_List": [
    '多於 7 個字符。',
    '與你的電子郵件地址並不相近。'
  ],
  "Reset_Password_Success_Message": "成功重設密碼。",
  "Reset_Password_Failed_Message_Token_expired": "重設密碼失敗。",
  "Reset_Password_Failed_Message": "重設密碼失敗。",
  "Reset_Password_Back_Button": "返回主頁",
  "InterviewLanguage_en": "英語",
  "InterviewLanguage_tc": "粵語",
  "InterviewLanguage_sc": "普通話",
  "InterviewLanguage_th": "泰文",
  "InterviewLanguage_ja": "日語",
  "InterviewLanguage_id":"印尼語",
  "InterviewLanguage_ms":"馬來語",
  "InterviewLanguage_vi":"越南語",
  "InterviewLanguage_km":"高棉語",
  "InterviewLanguage_kr":"韓語",
  "InterviewLanguage_bu":"緬甸語",
  "InterviewLanguage_ta":"菲律賓語",
  "InterviewLanguage_hi":"印地語",
  "InterviewLanguage_de": "德語",
  "InterviewLanguage_fr": "法語",
  
  "LayoutSettings_QuestionSubType_TaskPerformance": "處事表現",
  "LayoutSettings_QuestionSubType_InterpersonalRelationshipCommunication": "人際關係與溝通",
  "LayoutSettings_QuestionSubType_Adaptability": "適應能力",
  
  "Recruiter_Layout_Title": "評核介面佈局",
  "Recruiter_Layout_Title_old": "視像面試介面佈局",
  "Recruiter_Layout_Instruction": "請設定求職者的評核介面佈局並按 '{action}'",
  "Recruiter_Layout_Instruction_old": "請設定求職者的視像面試介面佈局並按 '{action}'",
  "Recruiter_Layout_CompanyName": "公司名稱",
  "Recruiter_Layout_CompanyMessage": "面試完結信息",
  "Recruiter_Layout_CV_Upload_Enable" : "Enable Candidate to upload CV",
  "Recruiter_Layout_CV_Upload_Enable_Message" : "If you enable this function, candidate can upload their cv from their side.",
  "Recruiter_Layout_Timezone": "時區",
  "Recruiter_Layout_InterviewLanguage": "評核介面語言",
  "Recruiter_Layout_InterviewLanguage_old": "視像面試語言",
  "Recruiter_Layout_InterviewStart": "面試開始於",
  "Recruiter_Layout_InterviewStartDate": "日期",
  "Recruiter_Layout_InterviewStartTime": "時間",
  "Recruiter_Layout_InterviewEnd": "面試結束於",
  "Recruiter_Layout_InterviewEndDate": "日期",
  "Recruiter_Layout_InterviewEndTime": "時間",
  "Recruiter_Layout_ShowAvatar": "在面試中使用虛擬面試官:",
  "Recruiter_Layout_CompanyVideo": "公司簡介錄像",
  "Recruiter_Layout_CompanyVideo_Instruction": "將影片放到此處或點擊以選擇文件",
  "Recruiter_Layout_CompanyVideo_Format": "影片大小 < 200MB，影片文件格式: AVI, MP4, Mov",
  "Recruiter_Layout_CompanyLogo": "公司徽標",
  "Recruiter_Layout_CompanyWebsite": "公司網頁",
  "Recruiter_Layout_CompanyLogo_Instruction": "將圖片放到此處或點擊以選擇文件",
  "Recruiter_Layout_CompanyLogo_Format": "推薦大小 300px x 300px",
  "Recruiter_Layout_ColorScheme": "介面主色",
  "Recruiter_Layout_Question": "問題設定",
  "Recruiter_Layout_QuestionSet": "問題組合{no}",
  "Recruiter_Layout_QuestionType": "問題類型",
  "Recruiter_Layout_QuestionSubType": "問題子類型",
  "Recruiter_Layout_PleaseSelect": "請選擇",
  "Recruiter_Layout_PleaseSelectQuestion": "問題",
  "Recruiter_Layout_Answer": "答案",
  "Recruiter_Layout_QuestionRemove": "移除",
  "Recruiter_Layout_AddQuestion": "增加問題",
  "Recruiter_Layout_UploadVideo": "上傳影片",
  "Recruiter_Layout_uploading": "正在上傳...",
  "Recruiter_Layout_AddQuestionSet": "增加問題組合",
  "Recruiter_Layout_Action_Save": "保存",
  "Recruiter_Layout_Action_Confirm": "確定",
  "Recruiter_Layout_Action_Save_MsgSuccess": "保存成功",
  "Recruiter_Layout_Action_Save_MsgFailed": "保存失敗",
  "Recruiter_Layout_Goback": "上一頁",
  "Recruiter_Layout_Next": "繼續",
  "Recruiter_Layout_Submit": "提交",
  "Recruiter_Layout_QuestionLength": "每題的回答時間",
  "Recruiter_Layout_Attempt_Number_Question": "每個問題的嘗試次數",
  "Recruiter_Layout_Minutes": "分鐘",
  'Recruiter_Layout_Action_Finish': '完成',
  'Recruiter_Layout_Action_Finish_MsgSuccess': '面試設定完成',
  'Recruiter_Layout_Step': '第 {step} 步 - ',
  'Recruiter_Layout_No_Preparation_Time': '沒有準備時間',
  'Recruiter_Layout_CompanyName_Tooltip': '這是在面試介面中顯示的公司名字',
  'Recruiter_Layout_CompanyWebsite_Tooltip': '這是在面試介面中顯示的公司網頁',
  "Recruiter_Layout_InterviewLanguage_Tooltip": "這是評核介面的顯示語言",
  "Recruiter_Layout_InterviewLanguage_Tooltip_old": "這是面試介面的顯示語言",
  "Recruiter_Layout_Timezone_Tooltip": "這時區用於設定面試開始與結束時間",
  'Recruiter_Layout_ShowAvatarIdentity': '加入虛擬面試官的身份',
  'Recruiter_Layout_AvatarIdentity': '虛擬面試官身份',
  "Recruiter_Layout_FirstName": "名字",
  "Recruiter_Layout_LastName": "姓氏",
  "Recruiter_Layout_JobTitle": "職位名稱",
  'Recruiter_Layout_AvatarIdentity_Tooltip': '這是顯示給求職者知道的虛擬面試官身份',
  "Recruiter_Layout_ShowAvatar_Tooltip": "這按鈕開動虛擬面試官影像，用以發問面試題目",
  "Recruiter_Layout_ShowAvatarIdentity_Tooltip": "這按鈕加入虛擬面試官身份並在面試界面中開動介紹的頁面",
  "Recruiter_Layout_CompanyVideo_Tooltip": "這介紹錄像在面試開始前顯示，幫助吸引求職者工作職位",
  "Recruiter_Layout_VideoReduction": "在處理公司錄像中。請繼續設定...",
  "Recruiter_Layout_CompanyLogo_Tooltip": "這是面試介面顯示的徽標",
  "Recruiter_Layout_ColorScheme_Tooltip": "這是面試介面的主色調",
  "Recruiter_Layout_PreparationTime": "每題的準備時間",
  "Recruiter_Layout_Totaltime": "本次測試的總答題時間",
  'Recruiter_Layout_PreparationLength_Tooltip': "這是每條面試題目的準備時間",
  "Recruiter_Layout_QuestionLength_Tooltip": "這是每條面試題目的答題時間",
  "Recruiter_Layout_CompanyMessage_Tooltip": "這訊息是在面試結束時給求職者的資訊或提示",
  "Recruiter_Layout_AdvancedSetting": "進階設定",
  "Recruiter_Layout_ScreenLayout": "面試官/求職者屏幕佈置",
  'Recruiter_Layout_Arrangement_Tooltip': "這是面試畫面排版的方式，適合用於不同形式的面試",
  "Recruiter_Layout_TwoScreens": "兩一樣屏幕對照",
  "Recruiter_Layout_BigSmallScreen": "一大一小屏幕",
  "Recruiter_Layout_AddQuestionSet_Tooltip": "系統把其中一個面試問題之組合給候選人以增加問題的隨機度",
  "Recruiter_Layout_Pronunciation": "口音",
  "Recruiter_Layout_Pronunciation_None": "無",
  "Recruiter_Layout_Pronunciation_Philipplines": "菲律賓",
  "Recruiter_Question_Title": "評核問題設定",
  "Recruiter_Test_Setting_Title": "評核設定",
  "Recruiter_Question_Title_old": "視像面試問題設定",
  "Recruiter_Settings_Test_Settings_Video_Interview": "視像面試",
  "Recruiter_Settings_Test_Settings_Multiple_Choices": "多項選擇題",
  "Recruiter_Settings_Test_Settings_Short_Questions": "短答題",
  "Recruiter_Settings_Test_Settings_Test_Name": "測試名稱 (非必需)",
  "Recruiter_Settings_Test_Settings_Add_Choice": "添加選擇",
  "Recruiter_Settings_Test_Settings_Choice": "選擇 {number}",
  "Recruiter_Settings_Test_Settings_Single_Answer": "單一答案",
  "Recruiter_Settings_Test_Settings_Multiple_Answers": "多項答案",
  "Recruiter_Settings_Test_Settings_Required_Field": "必填項目",
  "Recruiter_Settings_Test_Settings_Test_Duaration": "測試時間",
  "Recruiter_Settings_Test_Settings_Copy": "複製",
  "Recruiter_Settings_Test_Settings_Delete": "刪除",
  "Recruiter_Layout_QuestionLanguage": "語言",
  "Recruiter_Question_Instruction": "請為評核測試添加問題並按 '{action}'。 可以通過點擊\"增加問題組合\"添加額外的問題組，以便隨機呈現其中一個問題組合給求職者。",
  "Recruiter_Question_Instruction_old": "請在視像面試中添加問題並按 '{action}'. 可以通過按\"增加問題組合\"添加額外的問題組 ，以便隨機呈現其中一個問題組合給求職者。",
  "Recruiter_Multiple_Choices_Question_Instruction": "請在多項選擇題中添加問題。你可以單擊選項旁邊的圓圈將其設定為標準答案。可以設定多於一個選項作為多項選擇題的標準答案。",
  "Recruiter_Short_Question_Instruction": "請在短答題中添加問題。",
  "Recruiter_Question_CustomizeVirtualInterviewer": "定製虛擬面試官 (影片/圖片):",
  "Recruiter_Question_VirtualInterviewer_Tips": "若沒有提供虛擬面試官，系統會自動提供預設面試官",
  "Recruiter_Question_File_Format": "檔案大小 < 20MB，格式: AVI, MP4, Mov, JPG, PNG",
  "Recruiter_Question_Voice_Tooltip": "開/關面試題目朗讀聲音",
  "Recruiter_Question_Contain": "這問題包含:",
  "Recruiter_Email_Title": "給求職者的電子郵件和短信",
  "Recruiter_Email_CompanyLogo": "公司徽標",
  "Recruiter_Email_DropFile_Title": "將圖片放到此處或點擊以選擇文件",
  "Recruiter_Email_DropFile_Message": "推薦大小 300px x 300px",
  "Recruiter_Email_EmailDomain": "郵件域名",
  "Recruiter_Email_Invitation": "邀請",
  "Recruiter_Email_Invitation_Title": "評核邀請",
  "Recruiter_Email_HighScoreContent_Title": "評核邀請",
  "Recruiter_Email_MediumScoreContent_Title": "評核邀請",
  "Recruiter_Email_LowScoreContent_Title": "評核邀請",
  "Recruiter_Email_Invitation_Title_old": "邀請進行視像面試",
  "Recruiter_Email_Reminder": "提醒",
  "Recruiter_Email_Reminder_Title": "評核提醒",
  "Recruiter_Email_Reminder_Title_old": "提醒進行視像面試",
  "Recruiter_Email_Extension": "更改截止日",
  "Recruiter_Email_Extension_Title": "修改評核截止日期",
  "Recruiter_Email_Extension_Title_old": "更改視像面試的截止日期",
  "Recruiter_Email_Confirmation": "確認",
  "Recruiter_Email_Confirmation_Title": "評核完成",
  "Recruiter_Email_Confirmation_Title_old": "完成視像面試",
  "Recruiter_Email_AdvancedSettings": "進階設定",
  "Recruiter_Email_Section_Title": "標題",
  "Recruiter_Email_Section_Message": "信息",
  "Recruiter_Email_Section_Add_Attachment_Title": "添加附件",
  "Recruiter_Email_Section_Add_Attachment_Message": "點擊此處或拖動文件以附加（僅一個文件<20MB）",
  "Recruiter_Email_Section_AddCompanyLogo": "增加公司徽標",
  "Recruiter_Email_High_Score_Heading": "高總分（7-10）的求職者報告",
  "Recruiter_Email_Medium_Score_Heading": "中總分（4-6）的求職者報告",
  "Recruiter_Email_Low_Score_Heading": "低總分（0-3）的求職者報告",
  "Recruiter_Email_Section_AddSMS": "使用短訊",
  "Recruiter_Email_Section_AddComment": "添加評論",
  "Recruiter_Email_Save": "保存",
  "Recruiter_Email_Intoduction": "點擊以下按鈕以開動電郵和短訊傳送功能，然後按‘{action}’。",
  "Recruiter_Email_Invitation_Tips": "邀請電郵要求求職者進行評核",
  "Recruiter_Email_Invitation_Tips_old": "邀請電郵要求求職者進行評核",
  "Recruiter_Email_Reminder_Tips": "提醒信息將在截止前24小時發出",
  "Recruiter_Email_Extension_Tips": "當評核的截止日期被修改時，這封電郵將發送給求職者",
  "Recruiter_Email_Extension_Tips_old": "當視像面試的截止日期被修改時，這封電郵將發送給求職者",
  "Recruiter_Email_Confirmation_Tips": "求職者完成評核後會自動發送確認信",
  "Recruiter_Email_Redo": "重做面試題目",
  "Recruiter_Email_Redo_Tips": "這電郵邀請求職者重做選定的面試題目",
  "Recruiter_Email_Report_Tips": "此電郵會將報告發送給求職者",
  "Recruiter_Email_Redo_Title": "重做面試題目",
  "Recruiter_Email_Report_Title": "視像面試發展報告",
  "Recruiter_Email_Report_Section_Title": "給求職者報告",
  "Recruiter_Scoring_Title": "自動評分準則設定",
  "Recruiter_Scoring_ImpressionScore": "印象分數",
  "Recruiter_Scoring_PerformanceScore": "表現分數",
  "Recruiter_Scoring_Weighting": "權重 (%)",
  "Recruiter_Scoring_Total": "總共:",
  "Recruiter_Scoring_Save": "儲存",
  "Recruiter_Scoring_MsgNotSumTo100": "在上傳前請使和為100",
  "Recruiter_Scoring_MsgNotSumTo0": "請為至少一項分數設定成\"重要\"、\"需要\"或\"可有\"",
  "Recruiter_Scoring_Save_MsgSuccess": "保存成功",
  "Recruiter_Scoring_Save_MsgFailed": "保存失敗",
  "Recruiter_Scoring_Critical": "重要",
  "Recruiter_Scoring_Required": "需要",
  "Recruiter_Scoring_Bonus": "可有",
  "Recruiter_Scoring_Irrelevant": "無關",
  "Recruiter_Scoring_Introduction": "請選擇對這項工作重要的能力的比重。 面試分數是根據這些能力的比重從答案中計算出來的。",
  'Recruiter_Scoring_Impression': '印象分數',
  'Recruiter_Scoring_TaskPerformance': '處事表現',
  
  "Recruiter_Scoring_PotentialWorkPerformance": "潛在工作表現評分",
  "Recruiter_AIRating_PotentialWorkPerformance": "潛在工作表現評分",
  
  'Recruiter_Scoring_ContextualPerformance': '關係表現',
  'Recruiter_Scoring_AdaptivePerformance': '適應性表現',
  "Recruiter_Scoring_Leadership_Definition": "在領導和影響他人時表現出自信，在驅動自我和他人成功方面充滿動力和活力，並激勵他人表現",
  "Recruiter_Scoring_DevelopingPeople_Definition": "以能力為本的用人方式，認為每個人都有潛力在個人和專業方面成長。並通過提供反饋和指導，發展機會和經驗分享等方式支持",
  "Recruiter_Scoring_GoalAndAchievementStriving_Definition": "勤奮地追求目標，組織計劃和管理資源及項目進度，以確保有效執行和實現目標",
  "Recruiter_Scoring_Responsibility_Definition": "承擔個人責任專注於完成任務，並利用自己的能力獨立滿足工作要求",
  "Recruiter_Scoring_ManagingExecution_Definition": "按照指導和程序，對需利用資源的任務和活動進行有組織和協調的計劃，以確保按執行時間表和順利完成任務或項目",
  "Recruiter_Scoring_AnalyticalAndLogicalThinking_Definition": "能好奇地探索問題，研究，收集和綜合資訊和思想。從對事情的觀察和資料作批判性的分析和評核以得出結論",
  "Recruiter_Scoring_ComplexProblemSolving_Definition": "能夠復核大量資訊並弄清問題的本質，能夠靈活地思考以識別行動，並評核各備選方案的利弊以確定最能實現目標的選項",
  "Recruiter_Scoring_Communication_Definition": "自信地進行對話交流，並以流暢，清晰，簡潔，有條理和有說服力的方式表達思想和信息",
  "Recruiter_Scoring_CaringAndEmpathy_Definition": "表現出對他人的關心和關懷，對他人的需求敏感。並能夠通過積極傾聽和表現出同理心以個人方式與別他人互動",
  "Recruiter_Scoring_EnglishOralCommunication_Definition": "具有以流利的英語清晰表達的能力",
  "Recruiter_Scoring_CantoneseOralCommunication_Definition": "具有以流利的廣東話清晰表達的能力",
  "Recruiter_Scoring_MandarinOralCommunication_Definition": "具有以流利的普通話清晰表達的能力",
  "Recruiter_Scoring_InterpersonalRelationship_Definition": "在團隊合作和協作中有效互動並與他人建立並維持聯繫，在組織內部和之間建立積極的關係",
  "Recruiter_Scoring_TeamCollaborationAndInclusion_Definition": "與來自不同背景，文化和組織的人一起工作時，能相互合作並樂於助人。通過表現出尊重和對文化的敏感性，可以輕鬆地與他人建立信任",
  "Recruiter_Scoring_BuildingRelationshipsAndNetwork_Definition": "具有人際交往，與廣泛的人互動的能力，可以在部門，職能和/或組織內部和之間建立積極的關係和網絡",
  "Recruiter_Scoring_FlexibilityAndAdaptability_Definition": "根據新情況適應行為，能夠在含糊不清的情況下有效地工作，並在與他人互動時靈活運用自己的方法以實現目標",
  "Recruiter_Scoring_LearningAgility_Definition": "具有好奇心和反思能力，具有持續的學習態度和敏捷性以獲取新知識",
  "Recruiter_Scoring_CreativityAndInnovation_Definition": "富有想像力，能產生新想法並推進新發明/方法以解決問題，或提高服務或產品質量",
  "Recruiter_Scoring_EmotionalIntelligence_Definition": "保持情緒控制和樂觀，堅持不懈，在遇到困難或逆境時保持韌性",
  "Recruiter_Scoring_Enthusiasm_Definition": "對生活中的人與事表現出熱情，樂觀和充滿活力的興趣",
  "Recruiter_Scoring_Composure_Definition": "保持鎮定，沒有或幾乎沒有緊張感，在壓力下不感到擔心或沮喪",
  "Recruiter_Scoring_SelfConfidence_Definition": "不論在任何情況下，都能表現出自信和處理問題和實現目標的能力",
  'Recruiter_Scoring_VisionAndEntrepreneurialMindset_Definition': '能夠發現問題，創建願景並以企業家的思維方式實施。發現商機並創造未來遠景，然後在評核風險后系統地，持續地執行，以創新和發明新方式以解決問題',
  'Recruiter_Scoring_TechnologyExpertiseAndBusinessSense_Definition': '能夠運用技術專長來滿足市場需求。擁有技術方面的技能和知識，緊跟最新技術，能夠將這些知識與對關鍵業務問題的理解相結合來滿足市場需求',
  'Recruiter_Scoring_EffectiveCommunicationAndTeambuilding_Definition': '能夠清楚表達想法，建立並引領一個成功的團隊。以流暢，簡潔和有說服力的方式進行溝通，並能夠通過制定共同的目標，分享知識，經驗和成功並尊重個體差異來影響他人，從而促進更好的團隊合作',
  'Recruiter_Scoring_GritAndPassion_Definition': '能夠堅持不懈，從失敗中恢復過來，並專注於激情和紀律。儘管在此過程中面臨挑戰或逆境，但我們有勇氣和決心取得成功，有紀律嚴明的努力加上真誠的興趣和熱情，實現了長期目標',
  
  "Recruiter_Scoring_TaskPerformance_Definition": "計劃、組織、管理日常工作和履行工作職責的能力",
  "Recruiter_Scoring_InterpersonalRelationshipCommunication_Definition": "在團隊合作和協作中有效地與人互動和聯繫的能力，在部門和/或組織內部和跨部門建立積極的關係",
  "Recruiter_Scoring_Adaptability_Definition": "根據新情況調整行為的敏捷性，能夠在模棱兩可的情況下有效地工作，並在與他人的互動中靈活運用自己的方法以實現目標",
  
  "Recruiter_Evaluation_Title": "評核員計分準則設定",
  "Recruiter_Evaluation_Instruction": "請在下面修改評核員的評分準則。請注意，更改將應用於該職位的所有求職者。若刪除準則，其已有的評分數據都將會刪除。",
  "Recruiter_Evaluation_AddCategory": "+ 按此添加類別",
  "Recruiter_Evaluation_AddCriterion": "+ 按此添加準則",
  "Recruiter_Evaluation_AddCategoryButton": "+ 添加類別",
  "LayoutSettings_QuestionType_General": "一般人力資源與就業",
  "LayoutSettings_QuestionType_SoftSkills": "能力軟技能",
  "LayoutSettings_QuestionSubType_Intro": "介紹",
  "LayoutSettings_QuestionSubType_Motivation": "動機及職業計劃",
  "LayoutSettings_QuestionSubType_Strenth": "優勢、成就和弱點",
  "LayoutSettings_QuestionSubType_Attitude": "態度、興趣和價值",
  "LayoutSettings_QuestionSubType_Understanding": "角色/公司理解",
  "LayoutSettings_QuestionSubType_WorkPlan": "工作計畫",
  "LayoutSettings_QuestionSubType_Salary": "薪水",
  "LayoutSettings_QuestionSubType_Others": "其他",
  "LayoutSettings_QuestionSubType_Leadership": "領導力和管理",
  "LayoutSettings_QuestionSubType_Teamwork": "團隊合作和服務意識",
  "LayoutSettings_QuestionSubType_Communication": "溝通和關係建設",
  "LayoutSettings_QuestionSubType_ProblemAnalysis": "理解能力和問題分析能力",
  "LayoutSettings_QuestionSubType_Strategy": "戰略和創新",
  "LayoutSettings_QuestionSubType_Process": "管理流程和執行",
  "LayoutSettings_QuestionSubType_Change": "改變和適應能力",
  "LayoutSettings_QuestionSubType_Venturing": "創業和成就導向",
  "Recruiter_Settings_Title": "評核設定職位及評核設定",
  "Recruiter_Settings_Title)old": "視像面試設定職位及視像面試設定",
  "Recruiter_Settings_BulkAction": "批量操作",
  "Recruiter_Settings_AddJob": "新增職位",
  "Recruiter_Settings_Edit": "更新",
  "Recruiter_Settings_Action_Import": "輸入",
  "Recruiter_Settings_Action_Export": "輸出",
  "Recruiter_Settings_Action_Remove": "移除",
  "Recruiter_Settings_JobCount": "{count} 職位",
  "Recruiter_Settings_TableColumn_Department": "部門",
  "Recruiter_Settings_TableColumn_JobTitle": "職位名稱",
  "Recruiter_Settings_TableColumn_Created_At": "創建於",
  "Recruiter_Settings_TableColumn_NoOfQuestion": "問題數量",
  "Recruiter_Settings_TableColumn_NoOfCandidates": "求職者數量",
  "Recruiter_Settings_TableColumn_Deadline": "截止時間",
  "Recruiter_Settings_TableColumn_CompletionRate": "完成率",
  "Recruiter_Settings_Import_Title": "選擇文件以上傳求職者信息",
  "Recruiter_Settings_Import_FileDropTitle": "將文件放到此處或點擊以選擇文件",
  "Recruiter_Settings_Import_FileDropFormat": "支持文件格式: .csv and .xls and .xlsx",
  "Recruiter_Settings_Import_UploadNote": "* 上傳的文件必須包括求職者姓名 (name)，電郵(email)【強制輸入】，和國家代碼(country code)，電話(phone number)，畢業院校(univeristy)及學歷(degree)【非強制輸入】. 所有數據應以特定各式用英語標題列出 (參考示範).",
  "Recruiter_Settings_Import_UploadTemplate": "下載",
  "Recruiter_Settings_Export_TopPercentile": "最高百分比",
  "Recruiter_Settings_Export_Title": "導出資料",
  "Recruiter_Settings_Export_Description": "請從以下選擇權要導出的資料",
  "Recruiter_Settings_Export_ItemCount": "{count} 項",
  "Recruiter_Settings_Export_TickBox": "勾選框以選擇",
  "Recruiter_Settings_Export_Select_All": "全選",
  "Recruiter_Settings_Export_Column_CandidateName": "求職者姓名",
  "Recruiter_Settings_Export_Column_University": "學校",
  "Recruiter_Settings_Export_Column_DegreeTitle": "學歷",
  "Recruiter_Settings_Export_Column_TelephoneNumber": "電話號碼",
  "Recruiter_Settings_Export_Column_EmailAddress": "電子郵件",
  "Recruiter_Settings_Export_Column_RecruiterProgram": "招聘計畫",
  "Recruiter_Settings_Export_Column_OverallScore": "總共得分",
  "Recruiter_Settings_Export_Column_ImpressionScore": "印象分數",
  "Recruiter_Settings_Export_Column_PotentialWorkPerformanceScore": "潛在工作表現分數",
  "Recruiter_Settings_Export_Column_Personal_Information": "個人資料",
  "Recruiter_Settings_Export_Column_Interview_Information": "面試資料",
  "Recruiter_Settings_Export_Column_Interview_Result": "面試结果",
  "Recruiter_Settings_Export_Column_Programme_Statistics": "職位統計",
  "Recruiter_Settings_Export_Column_Programme_Setting": "職位設定",
  "Recruiter_Settings_Export_Column_Candidate_Answer": "候選人的回答",
  "Recruiter_Settings_Export_help_0": "這將導出候選人的全名、電子郵件、大學、學位和電話號碼.",
  "Recruiter_Settings_Export_help_1": "這將導出每個求職者的招聘人員電子郵件、職位 ID、面試開始和結束日期、評核狀態和密碼。",
  "Recruiter_Settings_Export_help_2": "這將導出求職者在所選評核中的個人分數。",
  "Recruiter_Settings_Export_help_3": "這將導出所選評核中求職者的統計數據。",
  "Recruiter_Settings_Export_help_4": "這將導出所選評核的設置。",
  "Recruiter_Settings_Export_help_5": "這將導出所選評核中求職者的答案",
  "Recruiter_Settings_Action_Edit_ErrorInterviewInProgress": "面試正在進行中，不能更改此部分設定。",
  "Recruiter_Settings_Action_Export_ErrorNoCompletedCandidate": "輸出失敗！只有在至少一位求職者完成面試後才能輸出求職者結果",
  "Recruiter_Settings_Action_Export_MsgSuccess": "文件輸出成功。",
  "Recruiter_Settings_Action_Import_MsgSuccess": "求職者成功導入。 你可以邀請他們參加評核。",
  "Recruiter_Settings_Action_Import_MsgSuccess_old": "求職者成功導入。 你可以邀請他們參加視像面試。",
  "Recruiter_Settings_Action_Import_Error": "不支持上傳的文件。",
  "Recruiter_Settings_Action_Import_Error_Column_Not_Match": "提交的 Excel/CSV 檔案內的標題不符合格式要求，請參考示範作更新。",
  "Recruiter_Settings_Action_Import_Error_Column_duplicate": "多個求職者擁有相同的電子郵件地址，請刪除並重新上傳",
  "Recruiter_Settings_Action_Import_Error_Miss_Information": "部分求職者的強制資料不齊全，請覆核。",
  "Recruiter_Settings_Action_Delete_MsgSuccess": "職位刪除成功!",
  "Recruiter_Settings_Action_Delete_Error": "職位刪除失敗",
  "Recruiter_Setting_Msg_Delete_title": "刪除職位",
  "Recruiter_Setting_Msg_Delete_content": "即將刪除選定的職位，並不能複原。你確認進行嗎?",
  "Recruiter_Setting_Msg_VideoWithAudio_title": "儲存面試題目",
  "Recruiter_Setting_Msg_VideoWithAudio_content": "注意！ 有部分面試題目的虛擬面試官和自動問題發音同時開動。這會導致兩個聲音重疊。你確認要這樣的設定嗎？",
  "Recruiter_Settings_Instruction_1": "你好! {user},",
  "Recruiter_Settings_Instruction_2": "此頁面顯示評核列表，",
  "Recruiter_Settings_Instruction_3": "請按右上方的[新增職位]按鈕以開始設定面試。",
  "Recruiter_Settings_Add_Title": "新增職位",
  "Recruiter_Settings_Add_RecentDepartment": "請從近期部門選擇",
  "Recruiter_Settings_Add_CreateNewDepartment": "創建新部門",
  "Recruiter_Settings_Add_JobName": "新職位名稱",
  "Recruiter_Settings_Add_Confirm": "確認",
  "Recruiter_Settings_Special_Character_Error": '含禁止使用符號 (;/?:@=&)',
  "Recruiter_Settings_Test": "測試 {number}",
  "Recruiter_Settings_Test_Video_Interview": "視像面試",
  "Recruiter_Settings_Test_Multiple_Choices": "多項選擇題",
  "Recruiter_Settings_Test_Short_Question": "短答題",
  "Recruiter_Settings_Test_Test_Name": "測試名稱",
  "Recruiter_Settings_Test_Add_Test": "添加測試",
  "Recruiter_Settings_Duplicate_Department": "重覆的部門名稱",
  "Recruiter_Settings_Add_Copy_title": "從其他職位複製設定",
  "Recruiter_Settings_SideMenu_InterviewLayout": "評核佈局",
  "Recruiter_Settings_SideMenu_InterviewQuestion": "面試問題",
  "Recruiter_Settings_SideMenu_InterviewEmail": "電郵和短信",
  "Recruiter_Settings_SideMenu_Scoring": "自動評分準則",
  "Recruiter_Settings_SideMenu_Evaluation": "評核員評分準則",
  "Recruiter_Settings_SideMenu_TestSetting": "評核設定",
  'Recruiter_Settings_Addjob_disable': '由於你的配額已用完，你不能添加新的職位。請聯繫你的管理員以獲取更多面試名額.',
  "Recruiter_Stat_Title": "統計",
  "Recruiter_Stat_Filter": "選項",
  "Recruiter_Stat_Filter_OverallScore": "總分",
  "Recruiter_Stat_Filter_ImpressionScore": "印象分",
  "Recruiter_Stat_Filter_Potential_Work_Performance": "潛在工作表現",
  "Recruiter_Stat_Filter_Pace": "口才",
  "Recruiter_Stat_Filter_Enthusiasm": "熱情",
  "Recruiter_Stat_Filter_SelfConfidence": "自信",
  "Recruiter_Stat_Filter_Composure": "沈著",
  "Recruiter_Stat_Filter_Leadership": "領導力",
  "Recruiter_Stat_Filter_Learning_Agility": "學習敏銳度",
  "Recruiter_Stat_Filter_Creativity_And_Innovation": "創造與創新",
  "Recruiter_Stat_Filter_Emotional_Intelligence": "情商",
  "Recruiter_Stat_Filter_Communication": "溝通",
  "Recruiter_Stat_Filter_Interpersonal_Relationship": "人際關係",
  "Recruiter_Stat_Filter_Goal_And_Achievement_Striving": "目標與成就",
  'Recruiter_Stat_Filter_Impression': '印象分數',
  'Recruiter_Stat_Filter_TaskPerformance': '處事表現',
  'Recruiter_Stat_Filter_ContextualPerformance': '關係表現',
  'Recruiter_Stat_Filter_AdaptivePerformance': '適應性表現',
  
  "Recruiter_Stat_Action_Export": "輸出",
  "Recruiter_Stat_Section_CompletedCandidates": "完整求職者",
  "Recruiter_Stat_Section_NoOfDaysLeft": "剩餘天數",
  "Recruiter_Stat_Section_NoOfQuestion": "問題數量",
  "Recruiter_Stat_Section_NoOfCandidate": "求職者數量",
  "Recruiter_Stat_Section_Deadline": "截止日期",
  "Recruiter_Stat_Section_Trackers": "追蹤器",
  "Recruiter_Stat_Section_Trackers_Invitation": "邀請",
  "Recruiter_Stat_Section_Trackers_Reminder": "提醒",
  "Recruiter_Stat_Section_Trackers_Confirmation": "確認",
  "Recruiter_Stat_Section_OverallScore": "總分",
  "Recruiter_Stat_Section_OverallScore_Average": "平均",
  "Recruiter_Stat_Section_OverallScore_StandardDeviation": "標準差",
  "Recruiter_Stat_Section_OverallScore_Skewness": "偏度",
  "Recruiter_Stat_Section_CandidateVideoScoreDist": "求職者分數分佈",
  "Recruiter_Stat_Section_NormalizedScore": "標準化分數",
  "Recruiter_Stat_Deadline_Expired": "已過期",
  "Recruiter_JobSelection_Title": "請選擇職位: ",
  "Recruiter_ProgrammeSelection_Title": "請選擇部門: ",
  "Recruiter_ProgrammeSelection_Cancel": "取消",
  "Recruiter_ProgrammeSelection_Go_Back": "返回",
  "Recruiter_Dashboard_Title": "求職者",
  "Recruiter_Dashboard_CandidateCount": "{count} 求職者",
  "Recruiter_Dashboard_InterviewDeadline": "面試截止時間:",
  "Recruiter_Dashboard_Search": "搜索",
  "Recruiter_Dashboard_FilterByTop": "按頂部篩選",
  "Recruiter_Dashboard_Add_Candiadte": "新增求職者",
  "Recruiter_Dashboard_BulkInvite": "邀請",
  "Recruiter_Dashboard_BulkReport": "給求職者的發送報告",
  "Recruiter_Dashboard_BulkExport": "輸出",
  "Recruiter_Dashboard_BulkModify": "更改截止日",
  "Recruiter_Dashboard_BulkAction": "操作",
  "Recruiter_Dashboard_BulkDelete": "刪除",
  "Recruiter_Dashboard_BulkRedo": "重設",
  "Recruiter_Dashboard_BulkDownloadPDF":"下載 PDF 報告",
  "Recruiter_Dashboard_Filter_Auto_Score": "自動評分",
  "Recruiter_Dashboard_Filter_Recruiter_Score": "招聘人員評分",
  "Recruiter_Dashboard_Action_View": "瀏覽",
  "Recruiter_Dashboard_Action_Invite": "邀請",
  'Recruiter_Dashboard_Action_Redo': "重來",
  "Recruiter_Dashboard_TableColumn_Name": "姓名",
  "Recruiter_Dashboard_TableColumn_University": "學校",
  "Recruiter_Dashboard_TableColumn_Status": "狀態",
  "Recruiter_Dashboard_TableColumn_Status_Pending": "待發邀請...",
  "Recruiter_Dashboard_TableColumn_Status_Wait_Invite": "已發送邀請，待評核",
  "Recruiter_Dashboard_TableColumn_Status_Processing": "處理影像中...",
  "Recruiter_Dashboard_TableColumn_Status_Complete": "完成",
  'Recruiter_Dashboard_TableColumn_Status_Partial_Complete': "部分完成",
  "Recruiter_Dashboard_TableColumn_AutoScoring": "自動評分",
  "Recruiter_Dashboard_TableColumn_RecruiterScoring": "招聘人員評分",
  "Recruiter_Dashboard_TableColumn_TestScores": "測試分數",
  "Recruiter_Dashboard_TableColumn_TotalScore": "總分",
  "Recruiter_Dashboard_TableColumn_Video": "視頻",
  "Recruiter_Dashboard_TableColumn_AIReport": "AI報告",
  "Recruiter_Dashboard_TableColumn_RecruiterEvaluation": "招聘人員評核",
  "Recruiter_Dashboard_TableColumn_Start_Date": "評核開始",
  "Recruiter_Dashboard_TableColumn_End_Date": "評核截止日期",
  "Recruiter_Dashboard_TableColumn_Action": "操作",
  "Recruiter_Dashboard_TableColumn_Delete": "刪除",
  "Recruiter_Dashboard_TableColumn_Tooltip_Invite": "邀請評核",
  "Recruiter_Dashboard_TableColumn_Tooltip_Report": "發送報告",
  "Recruiter_Dashboard_TableColumn_Tooltip_Report_Sent": "求職者報告已發送",
  "Recruiter_Dashboard_TableColumn_Tooltip_Redo": "重設面試",
  "Recruiter_Dashboard_TableColumn_Tooltip_Delete": "刪除求職者",
  "Recruiter_Dashboard_TableColumn_Pending": "待評核",
  "Recruiter_Dashboard_TableColumn_Tooltip_Shortlist": "入圍",
  "Recruiter_Dashboard_TableColumn_Tooltip_Reject": "不錄用",
  "Recruiter_Dashboard_TableColumn_Tooltip_WaitingList": "加入候補名單",
  "Recruiter_Dashboard_TableColumn_Tooltip_Edit": "更新求職者資料",
  "Recruiter_Dashboard_TableColumn_Tooltip_change_deadline": "更改截止日",
  "Recruiter_Dashboard_TableColumn_Tooltip_Share": "分享結果",
  "Recruiter_Dashboard_TableColumn_Tooltip_CV_Uploaded": "簡歷上傳",
  "Recruiter_Dashboard_TableColumn_Tooltip_Download": "下載求職者的錄像",
  "Recruiter_Dashboard_Dialog_Invitation_Title": "邀請",
  "Recruiter_Dashboard_Dialog_Report_Title": "報告",
  "Recruiter_Dashboard_Dialog_Invitation": "你想向選定的求職者發送評核邀請嗎？",
  "Recruiter_Dashboard_Dialog_Report": "你想將求職者報告發送給選定的求職者嗎？",
  "Recruiter_Dashboard_Dialog_Wrong_CV_Filetype": "簡歷上傳失敗。 請檢查檔案格式。",
  "Recruiter_ShareDialog_Title": "分享結果",
  "Recruiter_ShareDialog_Subtitle_1": "已選擇的候選人",
  "Recruiter_ShareDialog_Caption_1": "這是你選擇分享的候選人。你可以按電子郵件旁邊的叉號將其刪除。",
  "Recruiter_ShareDialog_ReviewerInfo": "評核員資料",
  "Recruiter_ShareDialog_Caption_2": "你可以通過按\"添加\"按鈕將邀請電子郵件發送給多個評核員。",
  "Recruiter_ShareDialog_Add": '添加',
  "Recruiter_ShareDialog_Name": "姓名",
  "Recruiter_ShareDialog_Email": "電郵",
  "Recruiter_ShareDialog_Message": "邀請信息(非必填)",
  "Recruiter_ShareDialog_Caption_3": "此邀請信息將附加到電子郵件中。",
  "Recruiter_ShareDialog_Confirm": "確定",
  "Recruiter_ShareDialog_Cancel": "取消",
  "Recruiter_ShareDialog_Success": "已成功發送邀請電郵。",
  "Recruiter_ShareDialog_Fail": "發送邀請電郵失敗。",
  "Recruiter_Dashboard_Msg_Invite_Duplicate_title": "重發電子郵件",
  "Recruiter_Dashboard_Msg_Report_Duplicate_title": "重新發送報告",
  "Recruiter_Dashboard_Msg_Invite_Duplicate_content": "你已經向該求職者發送了邀請。 你想再次發送嗎？",
  "Recruiter_Dashboard_Msg_Report_Duplicate_content": "你已經向該求職者發送了求職者報告。 你要再次發送嗎？",
  "Recruiter_Dashboard_InviteDuplicate_No": "否",
  "Recruiter_Dashboard_InviteDuplicate_Yes": "是",
  "Recruiter_Dashboard_InviteSuccess": "已成功發送電郵。",
  "Recruiter_Dashboard_InviteFail": "電郵發送失敗。請複核這職位的電郵設定。",
  "Recruiter_Dashboard_ReportSuccess": "報告已成功發送。",
  "Recruiter_Dashboard_ReportFail": "無法發送報告。 請檢查此作業的電郵設定。",
  "Recruiter_Dashboard_DeleteFail": "發生錯誤（刪除）",
  "Recruiter_Dashboard_ExportSuccess": "已成功輸出求職者的資料!",
  "Recruiter_Dashboard_ExportFail": "導出失敗！ 被選中的求職者尚未完成評核。",
  "Recruiter_Dashboard_BulkDuplicateInvite": "以下的求職者已被邀請過。你要重新邀請嗎?",
  "Recruiter_Dashboard_Sending_Invitation": "正在發送邀請 ...",
  "Recruiter_Dashboard_Sending_Report": "發送報告...",
  "Recruiter_Dashboard_Msg_Redo_title": "重設求職者資料",
  "Recruiter_Dashboard_Msg_Redo_content": "此操作將重置你選擇的求職者數據（包括視頻和AI分數），並允許這些求職者重新進行在線評核。 你確定這樣做嗎？",
  "Recruiter_Dashboard_Msg_Delete_title": "刪除求職者",
  "Recruiter_Dashboard_Msg_Delete_content": "即將刪除選定的後選人，並不能複原。你確認進行嗎?",
  "Recruiter_Dashboard_Import_Dialog_Title": "新增求職者",
  "Recruiter_Dashboard_Import_Dialog_Form_Label": "表格輸入",
  "Recruiter_Dashboard_Import_Dialog_Excel_Label": "Excel 輸入",
  "Recruiter_Dashboard_Import_Dialog_Field_Name": "全名",
  "Recruiter_Dashboard_Import_Dialog_Field_Email": "電郵",
  "Recruiter_Dashboard_Import_Dialog_Field_Country_Code": "國家代碼",
  "Recruiter_Dashboard_Import_Dialog_Field_Phone_Number": "電話",
  "Recruiter_Dashboard_Import_Dialog_Field_Degree": "最高學歷",
  "Recruiter_Dashboard_Import_Dialog_Field_University": "學校",
  "Recruiter_Dashboard_Import_Dialog_Instruction": "選擇這些求職者的評核開始和截止日期",
  "Recruiter_Dashboard_Import_Dialog_Column_Name": "名字",
  "Recruiter_Dashboard_Import_Dialog_Column_Email": "電郵",
  "Recruiter_Dashboard_Import_Dialog_Column_Status": "狀態",
  "Recruiter_Dashboard_Import_Duplicate_Dialog_Title": "發現重複電郵",
  "Recruiter_Dashboard_Import_Duplicate_Dialog_Content": "部分求職者的名字/電郵已在列表上。你確認要覆蓋這些資料嗎？",
  "Recruiter_Dashboard_Import_Duplicate_In_Excel_Dialog_Title": "成功導入!",
  "Recruiter_Dashboard_Import_Duplicate_In_Excel_Dialog_Content": "檢測到一些電子郵件在 excel/csv 文件中重複出現。只有第一個出現的行將被導入，其他行將被放棄。",
  "Recruiter_Dashboard_Import_Duplicate_In_Excel_Dialog_Repeat_Tag": "重複出現",
  "Recruiter_Dashboard_Change_Deadline_Dialog_Title": "更改截止日",
  "Recruiter_Dashboard_Change_Deadline_Dialog_Subtitle": '更改面試截止日為:',
  "Recruiter_Dashboard_Change_Deadline_Dialog_SendEmail": "發電郵/短訊給求職者",
  "Recruiter_Dashboard_Change_Deadline_Dialog_Msg": '成功更新截止日',
  'Recruiter_Dashboard_Msg_Invite_After_Modify_title': '現在發出邀請嗎?',
  'Recruiter_Dashboard_Msg_Invite_After_Modify_content': '我們注意到你還沒有邀請一些求職者。你想立即向他們發送更新截止日期的邀請嗎？',
  'Recruiter_Dashboard_Msg_Invite_After_Modify_Button_Yes': '現在發出',
  'Recruiter_Dashboard_Msg_Invite_After_Modify_Button_No': "不需發出",
  'Recruiter_Dashboard_Modify_Deadline_Msg': '成功更新截止日期',
  "Recruiter_Dashboard_Add_New_Candiadte": "新增求職者",
  "Recruiter_Dashboard_Status_Results": "查看面試結果",
  "Recruiter_Dashboard_Status_Pending": "等待面試結果",
  'Recruiter_Dashboard_TableColumn_Status_Shortlisted': "已入圍",
  "Recruiter_Dashboard_TableColumn_Status_WaitingListed": "在候補名單",
  'Recruiter_Dashboard_TableColumn_Status_Rejected': "不錄用",
  "Recruiter_Dashboard_Instruction_1": "這頁列出當前職位的求職者名單",
  "Recruiter_Dashboard_Instruction_2": "按右上角的 [ +新增求職者 ] 按鈕將求職者添加到評核並設置評核日期。",
  "Recruiter_Dashboard_Edit_Dialog_Failed": "求職者資料更新失敗 ",
  "Recruiter_Dashboard_Edit_Dialog_Email_Change_Reminder": "你已更新求職者的電郵。 如果你之前邀請過求職者進行評核，請注意重新邀請求職者。",
  'Recruiter_Dashboard_Status_Filter_Caption': "搜索:",
  'Recruiter_Dashboard_Status_Filter_Title': "搜索面試狀態",
  'Recruiter_Dashboard_Status_Filter_All': "所有",
  'Recruiter_Dashboard_Addcandidate_disable': '因為你已經用完面試限額，你不能再增加新的求職者。請聯絡你的系統管理人以購買更多面試額度。',
  'Recruiter_Dashboard_Redo_Questions_Dialog_Title': '重做面試題目',
  'Recruiter_Dashboard_Redo_Questions_Dialog_Instruction': '請選擇需要重做的題目',
  'Recruiter_Dashboard_Redo_Questions_Dialog_SendEmail': '發電郵給求職者',
  'Recruiter_Dashboard_TableColumn_Tooltip_RedoQuestions': '重做面試題目',
  "Recruiter_Dashboard_BulkSharing_Tooltip": "未入選求職者或部分入選求職者未完成評核無法審核",
  "Recruiter_Evaluation_Norating": "沒有評核員評分",
  "Recruiter_ReportSideBar_VideoInterview": "視像面試",
  "Recruiter_ReportSideBar_FullInterview": "完整面試",
  "Recruiter_ReportSideBar_GeneralHR": "一般人力資源",
  "Recruiter_ReportSideBar_Competency": "勝任力",
  "Recruiter_ReportSideBar_Technical": "技能",
  "Recruiter_ReportSideBar_AutoScoring": "自動評分",
  "Recruiter_ReportSideBar_OverallScore": "總共得分",
  "Recruiter_ReportSideBar_AIReport": "AI 報告",
  "Recruiter_ReportSideBar_RecruiterEvaluation": "招聘人員評核",
  "Recruiter_VideoInterview_BackToDashboard": "返回求職者列表",
  "Recruiter_VideoInterview_Title": "視像面試",
  "Recruiter_VideoInterview_QuestionSet": "問題組合 {no}",
  "Recruiter_VideoInterview_Question": "問題 {no}: {question}",
  "Recruiter_VideoInterview_Back": "返回",
  "Recruiter_VideoInterview_Next": "下一個",
  "Recruiter_VideoInterview_NoQuestion": "此類別中沒有問題",
  "Recruiter_VideoInterview_NoVideoSubmitted": "求職者尚未完成此問題",
  "Recruiter_Multiple_Choices_QuestionSet": "問題集 {no}",
  "Recruiter_Short_Question_QuestionSet": "問題集 (no}",
  'Recruiter_CandidateResult_Title': "面試分析",
  "Recruiter_CandidateResult_Multiple_Choices_Title": "多項選擇題分析",
  "Recruiter_CandidateResult_Short_Questions_Title": "短答題分析",
  "Recruiter_CandidateResult_AnswerList": "求職者答案列表",
  'Recruiter_CandidateResult_Name': "姓名:",
  'Recruiter_CandidateResult_Email': "電郵:",
  "Recruiter_Dashboard_Import_Dialog_Field_1st_Preference": "第一偏好",
  "Recruiter_Dashboard_Import_Dialog_Field_2nd_Preference": "第二偏好",
  "Recruiter_CandidateResult_University": "大學:",
  "Recruiter_CandidateResult_Degree": "學歷:",
  "Recruiter_CandidateResult_1st_Preference": "第一偏好:",
  "Recruiter_CandidateResult_2nd_Preference": "第二偏好:",
  'Recruiter_CandidateResult_NextCandidate': "下一位求職者",
  'Recruiter_CandidateResult_LastCandidate': "上一位求職者",
  'Recruiter_CandidateResult_FacialExpression': '面部表情標籤',
  'Recruiter_CandidateResult_MyComment': "我的評語:",
  'Recruiter_CandidateResult_MyScoring': "我的評分",
  'Recruiter_CandidateResult_Transcribe': '文本轉換',
  'Recruiter_CandidateResult_AutoScoring': "自動評分",
  'Recruiter_CandidateResult_ReviewerScoring': "評核員評分",
  "Recruiter_CandidateResult_Resume": "簡歷",
  'Recruiter_CandidateResult_Report': "下載PDF報告",
  "Recruiter_CandidateResult_Save": "儲存",
  'Recruiter_CandidateResult_Indicator': '感情指標',
  'Recruiter_CandidateResult_Emotion': '情緒比率',
  'Recruiter_CandidateResult_Time': '時間',
  'Recruiter_CandidateResult_PositiveEmotions': '積極情緒',
  'Recruiter_CandidateResult_NeutralEmotions': '中性情緒',
  'Recruiter_CandidateResult_NegativeEmotions': '消極情緒',
  'Recruiter_CandidateResult_Translation_title': '求職者的答案文本如下:',
  'Recruiter_CandidateResult_Tooltip_City': '城市',
  'Recruiter_CandidateResult_Tooltip_Country': '國家',
  'Recruiter_CandidateResult_Tooltip_IP': 'IP 地址',
  'Recruiter_CandidateResult_Tooltip_Complete': '完成時日',
  "Recruiter_CandidateResult_Tooltip_Download_Resume": "下載簡歷",
  
  
  
  "Recruiter_CandidateResult_Total_Score": "總分: {score}",
  "Recruiter_CandidateResult_Correct": "{logo} 正確",
  "Recruiter_CandidateResult_Wrong": "{logo} 錯誤",
  "Recruiter_CandidateResult_Model_Answer": "標準答案:",
  "Recruiter_CandidateResult_Candidate_Answer": "求職者答案:",
  "Recruiter_CandidateResult_Action": "操作",
  "Recruiter_CandidateResult_ErrorViewingShortQuestions": "該求職者尚未完成短答題評核",
  "Recruiter_CandidateResult_ErrorViewingMultipleChoicesQuestions": "該求職者尚未完成短答題評核",
  "Recruiter_AIReport_BackToDashboard": "返回求職者列表",
  "Recruiter_AIReport_Title": "AI報告",
  "Recruiter_AIReport_OverallScore": "總共得分",
  "Recruiter_AIReport_Percentile": "百分位",
  "Recruiter_AIReport_Passed": "通過",
  "Recruiter_AIReport_Failed": "失敗",
  "Recruiter_AIReport_Impression": "印象",
  "Recruiter_AIReport_PotentialWorkPerformance": "潛在工作表現",
  'Recruiter_AIReport_TaskPerformance': '處事表現',
  'Recruiter_AIReport_ContextualPerformance': '關係表現',
  'Recruiter_AIReport_AdaptivePerformance': '適應性表現',
  "Recruiter_AIReport_Rating": "評分",
  "Recruiter_AIReport_Weighting": "權重",
  "Recruiter_AIReport_QualitativeAnalysis": "定性分析",
  'Recruiter_AIReport_NoReportAnnounce': "這求職者沒有按指示完成面試，故此不能產生只能報告。",
  "Recruiter_AIReport_ReportInProgress": "面試分析仍在進行中， 請稍候…",
  
  
  
  "Recruiter_AIReport_task_performance_high": "表現出高度的計劃、組織、管理日常工作的能力，並能履行大部分的職責",
  "Recruiter_AIReport_interpersonal_relationship_communication_high": "表現出與他人有效互動並與部門/組織建立積極關係的能力",
  "Recruiter_AIReport_adaptability_high": "表現出較強靈活應變能力和適應新環境的能力，能夠立即調整常規，在與他人的互動中非常靈活地擁有自己的方法",
  
  "Recruiter_AIReport_task_performance_medium": "表現出計劃、組織、管理日常工作的能力較低，並能履行部分工作職責",
  "Recruiter_AIReport_interpersonal_relationship_communication_medium": "表現出與他人有效互動並與部門/組織建立積極關係的中等能力",
  "Recruiter_AIReport_adaptability_medium": "表現出適度靈活性和適應變化，通常願意在與他人互動時調整常規或自己的方法",
  
  "Recruiter_AIReport_task_performance_low": "表現出缺乏計劃、組織、管理日常工作的能力，不能履行工作職責",
  "Recruiter_AIReport_interpersonal_relationship_communication_low": "表現出較差與他人有效互動和與部門/組織建立積極關係的能力",
  "Recruiter_AIReport_adaptability_low": "表現出相當不靈活或不適應變化，在與他人互動時很少嘗試調整常規或自己的方法",
  
  "Recruiter_AIReport_task_performance_0": "無法確定這能力的分數。 這通常是因為求職者沒有回答相應的面試問題或提供面試影片。",
  "Recruiter_AIReport_interpersonal_relationship_communication_0": "無法確定這能力的分數。 這通常是因為求職者沒有回答相應的面試問題或提供面試影片。",
  "Recruiter_AIReport_adaptability_0": "無法確定這能力的分數。 這通常是因為求職者沒有回答相應的面試問題或提供面試影片。",
  
  
  'Recruiter_AIReport_pace_high': ' 以接近理想的速度說話並在速度和節奏上能清晰表達自己，表現出較系統性的思想。',
  'Recruiter_AIReport_leadership_high': ' 的分數較高，表示具備領導力品質，能自信地領導和指導他人，並致力於使他們表現出色。',
  'Recruiter_AIReport_learning_agility_high': ' 的分數較高，表示持續的學習態度，渴望獲得新技能和新知識，並運用它們帶來改變。',
  'Recruiter_AIReport_creativity_innovation_high': ' 的分數較高，表示對新思想的傾向，富有想像力和冒險精神去創造新思想，而不是墨守常規或傳統。',
  
  'Recruiter_AIReport_interpersonal_relationship_high': ' 的分數較高，表示與人交往時非常友好、開朗、善於交際，能有效地建立融洽和諧的人際關係。',
  'Recruiter_AIReport_goal_and_achievement_striving_high': ' 的分數較高，表示著他/她努力工作和雄心勃勃，並有動力實現更高的目標和成就。',
  'Recruiter_AIReport_developing_people_high': '展現出強烈的基於能力用人的思維方式和主動性，以支持對方的個人和職業發展',
  'Recruiter_AIReport_responsibility_high': '有責任心，有實現目標和結果的動力，知道如何最好地利用自己的能力來完成工作要求和獨立完成任務',
  'Recruiter_AIReport_managing_execution_high': '在規劃和管理資源、任務和/或項目方面有良好的組織和協調；以謹慎和認真的管道工作，知道如何根據交付的目標和時間安排任務的優先次序',
  'Recruiter_AIReport_analytical_and_logical_thinking_high': '善於探索思想和研究資訊，系統地收集和綜合資訊和思想以進行分析，並從世代觀察和特定事實中得出邏輯結論',
  'Recruiter_AIReport_complex_problem_solving_high': '能够闡明問題的性質，在評核替代方案，提出可行的解決方案以及做出合理的判斷和决定時靈活而開放',
  'Recruiter_AIReport_communication_high': '能够以清晰、簡潔的管道口頭表達資訊和想法，語氣和聲音平靜、確定',
  'Recruiter_AIReport_caring_and_empathy_high': '表現出對他人的關懷、同情和關心，練習積極的傾聽技巧，在人際關係工作中表現出耐心和正直',
  'Recruiter_AIReport_english_oral_communication_high': '說話得很流利，而且思想和觀念也很清晰',
  'Recruiter_AIReport_cantonese_oral_communication_high': '說話得很流利，而且思想和觀念也很清晰',
  'Recruiter_AIReport_mandarin_oral_communication_high': '說話得很流利，而且思想和觀念也很清晰',
  'Recruiter_AIReport_team_collaboration_and_inclusion_high': '對他人和藹可親、體貼他人，具有團隊合作精神和支持性，能够與不同背景的同事和同事一起工作，性格隨和，文化敏感',
  'Recruiter_AIReport_building_relationships_and_network_high': '善於交際，具有良好的人際交往能力，能够與各種人成功互動，並且懂得如何解釋和使用身體；以力量為基礎的思維方式，支持他人的個人發展',
  'Recruiter_AIReport_flexibility_and_adaptability_high': '靈活並願意根據新情况適應行為；樂於調整做法或與他人互動的方法',
  'Recruiter_AIReport_creativity_and_innovation_high': '思想開明，善於探究，能够創造性地思考，產生新的甚至是顛覆性的想法；運用新方法解决問題，並推動新發明創造新事物或設計',
  'Recruiter_AIReport_emotional_intelligence_high': '在面對挑戰時表現出冷靜，和/或有耐心處理不同背景的客戶（殘疾人、老人或兒童）',
  'Recruiter_AIReport_enthusiasm_high': '表現出愉快，傳達積極情緒和能量的感覺',
  'Recruiter_AIReport_composure_high': '表現出沉著冷靜，在壓力下不易受到壓力的影響',
  'Recruiter_AIReport_self_confidence_high': '展現自己時表現出自信並與人相處時感到自在',
  'Recruiter_AIReport_vision_and_entrepreneurial_mindset_high': ' 表現出發現問題和創造願景的能力不足，並且缺乏企業家的心態。不能有效抓住機會並採取行動以帶來創新和發明',
  'Recruiter_AIReport_technology_expertise_and_business_sense_high': ' 表現出很少的技能或知識，並且缺乏認識市場生態和需求的商業意識',
  'Recruiter_AIReport_effective_communication_and_teambuilding_high': ' 不能以清晰，簡潔的方式傳達思想，也無法影響和吸引他人來建立成功的團隊',
  'Recruiter_AIReport_grit_and_passion_high': ' 在面對挑戰和逆境時，很少表現出成功的勇氣或決心，也沒有表現出實現長期目標的毅力或熱情',
  
  
  'Recruiter_AIReport_pace_medium': ' 說話既不會太快也不會太慢',
  'Recruiter_AIReport_leadership_medium': ' 的分數中等，表示具有中等程度的領導才能，可以領導和影響他人，並在這些領域具有較高的績效和改進餘地。',
  'Recruiter_AIReport_learning_agility_medium': ' 的分數中等，表示對獲取新知識和經驗有中等程度的興趣的態度，能夠意識到他們能夠帶來改變。',
  'Recruiter_AIReport_creativity_innovation_medium': ' 的分數中等，表示對產生新的想法有中等程度的偏好，富有想像力，並且有可能打破推陳出新。',
  
  'Recruiter_AIReport_interpersonal_relationship_medium': ' 的分數中等，表示在與他人打交道，或能够與他人建立關係時，表現出適度的友好、熱情和社交能力。',
  'Recruiter_AIReport_goal_and_achievement_striving_medium': ' 的分數中等，表示中等程度的努力工作、雄心勃勃或有動力達到更高的目標和成就。',
  'Recruiter_AIReport_developing_people_medium': ' 表現出適度的基於能力用人的思維和主動性，以支持對方的個人和職業發展',
  'Recruiter_AIReport_responsibility_medium': ' 適度可靠，專注於實現目標和結果，滿足工作要求所需的事宜',
  'Recruiter_AIReport_managing_execution_medium': ' 在資源、任務和/或項目的規劃和協調方面有適度的組織和責任心，根據目標和交付時間安排任務的優先次序',
  'Recruiter_AIReport_analytical_and_logical_thinking_medium': ' 適度地研究思想或主動研究資訊，適度系統地收集和綜合資訊和思想以進行分析，得出合理的結論',
  'Recruiter_AIReport_complex_problem_solving_medium': ' 能够適當地利用資訊來嘗試評核備選方案，使用合理的邏輯和判斷力進行決策',
  'Recruiter_AIReport_communication_medium': ' 能以清晰簡潔的管道口頭表達資訊和想法，語氣和聲音適度冷靜和確定',
  'Recruiter_AIReport_caring_and_empathy_medium': ' 表現出適度的關心，對他人有同情心，有一定的耐心，通常願意傾聽他人的需求，在人際關係工作中保持足够的正直',
  'Recruiter_AIReport_english_oral_communication_medium': ' 說話基本流利，或對思想和觀念的表達基本清晰',
  'Recruiter_AIReport_cantonese_oral_communication_medium': ' 說話基本流利，或對思想和觀念的表達基本清晰',
  'Recruiter_AIReport_mandarin_oral_communication_medium': ' 說話基本流利，或對思想和觀念的表達基本清晰',
  'Recruiter_AIReport_team_collaboration_and_inclusion_medium': ' 既不體貼也不冷漠，與他人合作時通常會合作並樂於助人，與不同背景的同事合作時會表現出適度的同意和文化敏感性',
  'Recruiter_AIReport_building_relationships_and_network_medium': ' 與人相處融洽，偶爾也能享受私人時間，具備良好的人際交往能力，能够與不同類型的人成功互動或具有基於力量的思維方式，專注於他人的個人發展',
  'Recruiter_AIReport_flexibility_and_adaptability_medium': ' 面對新情況時具有適度的靈活性和適應性，在可行情況下嘗試調整做法或與他人互動的方法',
  'Recruiter_AIReport_creativity_and_innovation_medium': ' 有一定的開放性或好奇心，能產生新的想法；通常採用臨時解決方案來解决老問題，並能改變一些既定的做法，但可能不是獨創性的設計或解決方案',
  'Recruiter_AIReport_emotional_intelligence_medium': ' 在面對挑戰時，有意識地控制自己的情緒；通常有耐心，能够容忍不同背景的客戶（殘疾人、老人或兒童）',
  'Recruiter_AIReport_enthusiasm_medium': ' 表現出適度開朗，傳達適度的積極情緒和能量',
  'Recruiter_AIReport_composure_medium': ' 在壓力下表現出適度的鎮定和鎮定的傾向，並容易受到壓力',
  'Recruiter_AIReport_self_confidence_medium': ' 表現出自我展示時的適度自信和與人相處的適度自在',
  'Recruiter_AIReport_vision_and_entrepreneurial_mindset_medium': ' 具有適度的發現問題和創造遠見的能力，並具有適度的企業家心態，可以抓住機遇並採取行動，以帶來具有深思熟慮風險的創新和發明',
  'Recruiter_AIReport_technology_expertise_and_business_sense_medium': ' 表現出中等水平的技能和知識，具有中等商業意識，能夠理解市場生態及需求',
  'Recruiter_AIReport_effective_communication_and_teambuilding_medium': ' 表現出適度的能力，能夠以簡潔明了的方式交流思想，並能夠影響和吸引其他人來建立一個成功的團隊',
  'Recruiter_AIReport_grit_and_passion_medium': ' 在面對挑戰和逆境時表現出適度的勇氣和成功的決心，以及對實現長期目標的適度的毅力和熱情',
  
  
  'Recruiter_AIReport_pace_low': ' 說話的速度太快或太慢，無法為聽眾調整速度和節奏',
  'Recruiter_AIReport_leadership_low': ' 的分數較低，表示不具備的領導才能，沒有足夠的自信來領導和指導他人，並使他們表現出色。',
  'Recruiter_AIReport_learning_agility_low': ' 的分數較低，表示對獲取新知識和經驗幾乎沒有興趣，並且意識不到需要做出改變。',
  'Recruiter_AIReport_creativity_innovation_low': ' 的分數較低，表示不太傾向於偏離現行做法和傳統，希望保持穩定感。',
  
  'Recruiter_AIReport_interpersonal_relationship_low': ' 的分數較低，意味著在與他人打交道時更加保守，不那麼熱情和善於交際，並且更加獨立，而不是團隊精神。',
  'Recruiter_AIReport_goal_and_achievement_striving_low': ' 的分數較低，表示他/她無憂無慮，沒有野心，更容易滿足於成就。',
  'Recruiter_AIReport_developing_people_low': ' 較少表現出基於能力用人的思維和主動性，以支持對方的個人和職業發展',
  'Recruiter_AIReport_responsibility_low': ' 對實現目標和結果感到不太有義務感或責任感；輕鬆悠閒地完成任務',
  'Recruiter_AIReport_managing_execution_low': ' 缺乏系統性和謹慎性，不注重對資源、任務和項目進行詳細的規劃和協調，不按照交付的目標和時間表進行',
  'Recruiter_AIReport_analytical_and_logical_thinking_low': ' 對探索想法不感興趣或不好奇，不主動研究、收集或綜合正確而充分的資訊進行分析和作出邏輯結論',
  'Recruiter_AIReport_complex_problem_solving_low': ' 無法闡明問題的性質以評核或提出選擇方案，也無法基於合理的邏輯或判斷做出决定',
  'Recruiter_AIReport_communication_low': ' 表現出以清晰簡潔的管道表達資訊和想法的能力較弱，並且在語氣和聲音上表現出一些緊張和懷疑',
  'Recruiter_AIReport_caring_and_empathy_low': ' 對他人表現出很少的同理心或同情心，缺乏耐心或意願去聽取他人的需求或在人際交往中堅持正直原則',
  'Recruiter_AIReport_english_oral_communication_low': ' 說話不太流利，或對思想和觀念的表達不够清晰',
  'Recruiter_AIReport_cantonese_oral_communication_low': ' 說話不太流利，或對思想和觀念的表達不够清晰',
  'Recruiter_AIReport_mandarin_oral_communication_low': ' 說話不太流利，或對思想和觀念的表達不够清晰',
  'Recruiter_AIReport_team_collaboration_and_inclusion_low': ' 以自我為中心，不太關心他人，喜歡單獨工作而不是團隊合作，不太討人喜歡，可能會與他人發生衝突，在與同事或同事合作時文化敏感度較低',
  'Recruiter_AIReport_building_relationships_and_network_low': ' 內向且不積極尋求建立人際關係，缺乏良好的人際交往技能，無法成功地與他人互動；不接受支持他人個人發展的基於力量的心態',
  'Recruiter_AIReport_flexibility_and_adaptability_low': ' 對處理變化比較死板並比難適應，很少嘗試調整做法或與他人互動的方法',
  'Recruiter_AIReport_creativity_and_innovation_low': ' 傳統和墨守陳規的，對產生新想法的好奇心較小；堅持解决問題的舊方法，並且不能偏離當前的實踐來創造原創的設計或解決方案',
  'Recruiter_AIReport_emotional_intelligence_low': ' 在面對挑戰時表現出緊張和缺乏自信；在與不同背景的客戶（殘疾人、老人或兒童）打交道時，可能缺乏耐心和寬容',
  'Recruiter_AIReport_enthusiasm_low': ' 表現出相當冷漠和超然的傾向，很少傳達積極的情緒和能量',
  'Recruiter_AIReport_composure_low': ' 表現出緊張或挫敗感，在壓力下容易受到壓力',
  'Recruiter_AIReport_self_confidence_low': ' 表現出自我介紹時缺乏自信，與人相處不太自在',
  'Recruiter_AIReport_vision_and_entrepreneurial_mindset_low': ' 表現出發現問題和創造願景的獨特能力，並具有強大的企業家思維，積極抓住機遇並採取行動，以帶來具有深思熟慮風險的創新和發明',
  'Recruiter_AIReport_technology_expertise_and_business_sense_low': ' 展示技能和知識的專長，具有良好的商業意識，能夠充分理解市場生態和需求',
  'Recruiter_AIReport_effective_communication_and_teambuilding_low': ' 表現出很強的能力以清晰簡潔的方式傳達思想，並能夠非常有效地影響和吸引他人，以建立一個成功的團隊',
  'Recruiter_AIReport_grit_and_passion_low': ' 在面對挑戰和逆境時表現出強烈的勇氣和成功的決心，並具有毅力和對實現長期目標的熱情',
  
  'Recruiter_AIReport_0': '無法確定此能力。這通常是因為求職者未回答相應的面試問題或未提供面試視像。',
  
  "Recruiter_AIRating_Comment": "評論",
  "Recruiter_AIRating_BackToDashboard": "返回求職者列表",
  "Recruiter_AIRating_Title": "AI評分",
  "Recruiter_AIRating_OverallScore": "總共得分",
  "Recruiter_AIRating_Percentile": "百分位",
  "Recruiter_AIRating_Passed": "通過",
  "Recruiter_AIRating_Failed": "失敗",
  "Recruiter_AIRating_ImpressionScore": "印象分數:",
  "Recruiter_AIRating_Impression": "印象分數:",
  "Recruiter_AIRating_PotentialWorkPerformanceScore": "潛在工作表現分數:",
  "Recruiter_AIRating_FullMark": "總分100分",
  "Recruiter_AIRating_HighScore": "高分: 70及以上",
  "Recruiter_AIRating_LowScore": "低分: 50及以下",
  "Recruiter_AIRating_RadarLabel": ['目標與成就', '領導力', '創造與創新', '學習敏銳度', '溝通', '人際關係', '情商'],
  "Recruiter_AIRating_Big5Score": "Big 5 性格特質分數:",
  "Recruiter_AIRating_TotalScore": "總分:",
  'Recruiter_AIRating_TaskPerformance': '處事表現分數:',
  'Recruiter_AIRating_ContextualPerformance': '關係表現分數:',
  'Recruiter_AIRating_AdaptivePerformance': '適應性表現分數:',
  "Recruiter_Comment_BackToDashboard": "返回求職者列表",
  "Recruiter_Comment_Title": "招聘人員評論",
  "Recruiter_Comment_Impression": "印象",
  "Recruiter_Comment_PotentialWorkPerformance": "潛在工作表現",
  "Recruiter_Comment_Rating": "評分",
  "Recruiter_Comment_Comments": "評論",
  "Recruiter_Comment_OverallScore": "總共得分:",
  "Recruiter_Comment_OverallComments": "總體評論",
  "Recruiter_Comment_Submit": "提交",
  "Recruiter_Comment_Submit_SuccessMsg": "保存成功",
  "Recruiter_Comment_Submit_FailedMsg": "保存失敗",
  
  "Recruiter_Candidate_Result_No_Criteria": '評分準則及權重尚未設定，請先前往職位及面試定頁面的完成相關設定。',
  "Recruiter_Candidate_Result_Go_Setting": '前往設定頁面',
  "Recruiter_Candidate_Result_Criteria_Setting": '編輯評分準則  ',
  "Recruiter_Guest_Review_No_Criteria": '尚未設定評分準則和權重，請與你正在查看的求職者的管理人員聯繫。',
  "Recruiter_CandidateProfile_Title": "求職者簡介",
  "Candidate_CandidateProfile_Upload_Title" : "Before the interview, please upload your resume",
  "Recruiter_CandidateProfile_CV": "簡歷",
  "Recruiter_CandidateProfile_CV_Instruction": "將簡歷放在此處或選擇",
  "Recruiter_CandidateProfile_CV_Extension": "推薦文件格式: PDF, Doc or JPG",
  "Recruiter_CandidateProfile_BasicInformation_Title": "基本信息",
  "Recruiter_CandidateProfile_BasicInformation_FullName": "全名",
  "Recruiter_CandidateProfile_BasicInformation_PhoneNumber": "電話號碼",
  "Recruiter_CandidateProfile_BasicInformation_Email": "電子郵件",
  "Recruiter_CandidateProfile_BasicInformation_Address": "地址",
  "Recruiter_CandidateProfile_WorkExp_Title": "工作經驗",
  "Recruiter_CandidateProfile_WorkExp_Institute": "公司/ 機構.",
  "Recruiter_CandidateProfile_WorkExp_JobFunction": "工作職能",
  "Recruiter_CandidateProfile_WorkExp_JobTitle": "職位名稱",
  "Recruiter_CandidateProfile_WorkExp_Location": "地點",
  "Recruiter_CandidateProfile_WorkExp_Active": "有效期",
  "Recruiter_CandidateProfile_WorkExp_StartDate_Year": "開始日期 - 年",
  "Recruiter_CandidateProfile_WorkExp_StartDate_Month": "開始日期 - 月",
  "Recruiter_CandidateProfile_WorkExp_EndDate_Year": "結束日期 - 年",
  "Recruiter_CandidateProfile_WorkExp_EndDate_Month": "結束日期 - 月",
  "Recruiter_CandidateProfile_Education_Title": "教育",
  "Recruiter_CandidateProfile_Education_Institute": "研究",
  "Recruiter_CandidateProfile_Education_Major": "專業",
  "Recruiter_CandidateProfile_Education_Award": "獎項",
  "Recruiter_CandidateProfile_Education_Location": "地點",
  "Recruiter_CandidateProfile_Education_Active": "有效期",
  "Recruiter_CandidateProfile_Education_StartDate_Year": "開始日期 - 年",
  "Recruiter_CandidateProfile_Education_StartDate_Month": "開始日期 - 月",
  "Recruiter_CandidateProfile_Education_EndDate_Year": "結束日期 - 年",
  "Recruiter_CandidateProfile_Education_EndDate_Month": "結束日期 - 月",
  "Recruiter_CandidateProfile_Cert_Title": "證書和獎項",
  "Recruiter_CandidateProfile_Cert_Cert": "證書/獎項",
  "Recruiter_CandidateProfile_Cert_Year": "年",
  "Recruiter_CandidateProfile_Skills_Title": "技能",
  "Recruiter_CandidateProfile_Skills_Skill": "特殊技能",
  "Recruiter_CandidateProfile_Action_Add": "增加",
  "Recruiter_CandidateProfile_Action_Remove": "移除",
  "Recruiter_CandidateProfile_Action_Upload": "上傳",
  "Candidate_CandidateProfile_Confirm_Title" : "Resume Upload Confirmation",
  "Candidate_CandidateProfile_Confirm_Content" : "Please make sure all filled information is correct, you will not be allowed to modify once you click the CONFIRM button below.", 
  "Recruiter_CandidateProfile_Upload_MsgSuccess": "簡歷上傳成功",
  "Recruiter_CandidateProfile_Upload_MsgFailed": "簡歷上傳失敗",
  "Recruiter_Candidate_Invite_Result_Title": "邀請面試錯誤信息",
  "Recruiter_Candidate_Invite_Result_Content": "以下求職者在邀請時發生錯誤信息:",
  "Recruiter_Candidate_Invite_Result_Code0": "-",
  "Recruiter_Candidate_Invite_Result_Code1": "不能發送電郵",
  "Recruiter_Candidate_Invite_Result_Code2": "面試電郵已經發送。 \n但由於沒有提供電話號碼此短信發送失敗",
  "Recruiter_Candidate_Invite_Result_Code3": "面試限額用完",
  "Recruiter_Candidate_Invite_Result_Code4": "面試已完成",
  "Recruiter_Candidate_Invite_Result_Table_Name": "名字",
  "Recruiter_Candidate_Invite_Result_Table_Email": "電郵",
  "Recruiter_Candidate_Invite_Result_Table_Result": "邀請狀態",
  "Recruiter_Candidate_Invite_Result_Table_Message": "原因",
  "Recruiter_Candidate_Invite_Result_Success": "已發出邀请",
  "Recruiter_Candidate_Invite_Result_Fail": "發送邀请失敗",
  "Recruiter_Skills_Attractiveness": "外觀",
  "Recruiter_Skills_Wear_Glasses": "戴眼鏡",
  "Recruiter_Skills_Wear_Glasses_yes": "是",
  "Recruiter_Skills_Wear_Glasses_no": "否",
  "Recruiter_Skills_Enthusiasm": "熱情",
  "Recruiter_Skills_SelfConfidence": "自信",
  'Recruiter_Skills_Composure': '鎮定',
  "Recruiter_Skills_Pace": "口才",
  "Recruiter_Skills_Leadership": "領導力",
  'Recruiter_Skills_LearningAgility': '學習能力',
  "Recruiter_Skills_CreativityAndInnovation": "創造與創新",
  "Recruiter_Skills_EmotionalIntelligence": "情商",
  'Recruiter_Skills_Communication': ' 有影響力的溝通',
  'Recruiter_Skills_InterpersonalRelationship': '人際交往關係',
  
  'Recruiter_Skills_GoalAndAchievementStriving': '目標和成就導向',
  "Recruiter_Skills_Pleasantness": "Pleasantness",
  "Recruiter_Skills_Patience": "Patience",
  "Recruiter_Skills_ComposureS4m": "Composure",
  "Recruiter_Skills_Independence": "Independence",
  "Recruiter_Skills_AdaptabilityAndSupporting": "Adaptability And Supporting",
  "Recruiter_Skills_CaringAndSensitivity": "Caring And Sensitivity",
  "Recruiter_Skills_ResponsibleWithOwnership": "Responsible With Ownership",
  'Recruiter_Skills_DevelopingPeople': '發展人才',
  'Recruiter_Skills_Responsibility': '責任心',
  'Recruiter_Skills_ManagingExecution': '管理執行',
  'Recruiter_Skills_AnalyticalAndLogicalThinking': '分析與邏輯思維',
  'Recruiter_Skills_ComplexProblemSolving': '複雜問題解决',
  'Recruiter_Skills_CaringAndEmpathy': '關懷與同理心',
  'Recruiter_Skills_EnglishOralCommunication': '英語口語交流',
  'Recruiter_Skills_CantoneseOralCommunication': '廣東話口語交流',
  'Recruiter_Skills_MandarinOralCommunication': '普通話口語交流',
  'Recruiter_Skills_TeamCollaborationAndInclusion': '團隊合作和包容',
  'Recruiter_Skills_BuildingRelationshipsAndNetwork': '建立人際關係和網絡',
  'Recruiter_Skills_FlexibilityAndAdaptability': '靈活性和適應力',
  'Recruiter_Skills_VisionAndEntrepreneurialMindset': '遠見及創業精神',
  'Recruiter_Skills_TechnologyExpertiseAndBusinessSense': '科技專業及商業觸角',
  'Recruiter_Skills_EffectiveCommunicationAndTeambuilding': '有效溝通及團體建立',
  'Recruiter_Skills_GritAndPassion': '堅毅及熱情',
  
  "Recruiter_Skills_EnglishOralCommunicationOngrad": "English Oral Communication",
  "Recruiter_Skills_MotivationOngrad": "Concern of Health/Environment/Aesthetics/Technology (Job 1)",
  "Recruiter_Skills_MotivationOngradB": "Concern of Health/Environment/Aesthetics/Technology (Job 2)",
  "Recruiter_Skills_CommunicationWithImpactOngrad": "Communication with Impact",
  "Recruiter_Skills_TeamworkAndCollaborationOngrad": "Teamwork and collaboration",
  "Recruiter_Skills_CaringAndEmpathyOngrad": "Caring and Empathy",
  "Recruiter_Skills_BuildingRelationshipAndPeopleOngrad": "Building relationship and People",
  "Recruiter_Skills_ResponsibilityAndGoalAchievementOngrad": "Responsibility and Goal Achievement",
  "Recruiter_Skills_EmotionalIntelligenceOngrad": "Emotion Intelligence",
  "Recruiter_Skills_ManagingExecutionOngrad": "Managing execution",
  "Recruiter_Skills_FlexibilityAndActiveLearningOngrad": "Flexibility and Active Learning",
  "Recruiter_Skills_ComplexProblemSolvingOngrad": "Complex problem solving",
  "Recruiter_Skills_AnalyticalAndLogicalThinkingOngrad": "Analytical and logical thinking",
  "Recruiter_Skills_CreativityAndInnovationOngrad": "Creativity and Innovation",
  "Recruiter_Skills_ConfidenceOngrad": "Self-Confidence",
  "Recruiter_Skills_ComposureOngrad": "Composure",
  "Recruiter_Skills_EnthusiasmOngrad": "Enthusiasm",
  
  "Recruiter_Skills_TaskPerformance": "處事表現",
  "Recruiter_Skills_InterpersonalRelationshipCommunication": "人際關係與溝通",
  "Recruiter_Skills_Adaptability": "適應能力",
  
  
  "LayoutSettings_QuestionSubType_Leadership": "領導力",
  "LayoutSettings_QuestionSubType_DevelopingPeople": "發展人才",
  "LayoutSettings_QuestionSubType_GoalAndAchievementStriving": "目標和成就導向",
  
  
  "LayoutSettings_QuestionSubType_TechnologyExpertiseAndBusiness Sense": "科技專業及商業觸角",
  "LayoutSettings_QuestionSubType_Responsibility": "責任心",
  "LayoutSettings_QuestionSubType_ManagingExecution": "管理執行",
  "LayoutSettings_QuestionSubType_AnalyticalAndLogicalThinking": "分析與邏輯思維",
  "LayoutSettings_QuestionSubType_ComplexProblemSolving": "複雜問題解决",
  "LayoutSettings_QuestionSubType_VisionAndEntrepreneurialMindset": "遠見及創業精神",
  
  "LayoutSettings_QuestionSubType_CommunicationWithImpact": "有影響力的溝通",
  "LayoutSettings_QuestionSubType_CaringAndEmpathy": "關懷與同理心",
  "LayoutSettings_QuestionSubType_InterpersonalRelationship": "人際交往關係",
  "LayoutSettings_QuestionSubType_Team CollaborationAndInclusion": "團隊合作和包容",
  "LayoutSettings_QuestionSubType_Building RelationshipsAndNetwork": "建立人際關係和網絡",
  "LayoutSettings_QuestionSubType_Effective CommunicationAndTeambuilding": "有效溝通及團體建立",
  "LayoutSettings_QuestionSubType_FlexibilityAndAdaptability": "靈活性和適應力",
  "LayoutSettings_QuestionSubType_LearningAgility": "學習能力",
  "LayoutSettings_QuestionSubType_CreativityAndInnovation": "創造與創新",
  "LayoutSettings_QuestionSubType_EmotionalIntelligence": "情商",
  "LayoutSettings_QuestionSubType_GritAndPassion": "堅毅及熱情",
  
  
  "Recruiter_Email_Invitation_Default": "<p>你好 {{Candidate’s name, don’t change}},</p><p></p><p>感謝申請我們公司!</p><p>我們將邀請你參加迅維評核。 這是一個簡單的三十分鐘的評核，請你使用登陸信息在開始日期和結束日期之間進行評核。</p><p></p><p> 登錄詳情：</p><ul><li style='font-size: 14px; line-height: 1.2; mso-line-height-alt: 17px;'>網站: <a href='apisit.neufast.com/candidate' rel='noopener' style='text-decoration: underline; color: #0068A5;' target='_blank'>apisit.neufast.com/candidate</a></li><li style='font-size: 14px; line-height: 1.2; mso-line-height-alt: 17px;'>用戶名: {{Candidate’s login, don’t change}}</li><li style='font-size: 14px; line-height: 1.2; mso-line-height-alt: 17px;'>密碼: {{Candidate’s password, don’t change}}</li><li style='font-size: 14px; line-height: 1.2; mso-line-height-alt: 17px;'>開始: {{Start date and time, don’t change}}</li><li style='font-size: 14px; line-height: 1.2; mso-line-height-alt: 17px;'>結束: {{End date and time, don’t change}}</li><li style='font-size: 14px; line-height: 1.2; mso-line-height-alt: 17px;'>時區: {{Timezone, don’t change}}</li></ul><span style=\"font-size: 14px;\"><p></p><p></p><ins>系統要求:</ins></span><p>座檯電腦/手提電腦: 使用安裝了最新的 Chrome/Firefox/Safari(MacOS) 及有互聯網連接，攝像機和麥克風的座檯電腦/手提電腦;</p><p>手機: 使用安裝了Chrome的安卓手機 / Safari的蘋果手機 (SE2/XS or above)。建議使用良好的 Wi-Fi連接。 </p><p style=\"margin-left:0px;\"></p><p>感謝你參與我們的評核。 我們期待你的圓滿完成，下一輪再見。</p><p></p><p>祝好，</p><p>人才經理</p>",
  "Recruiter_Email_Invitation_Default_old": "<p>你好 {{Candidate’s name, don’t change}},</p><p></p><p>感謝申請我們公司!</p><p>我們將邀請你參加迅維視像面試。 這是一個簡單的三十分鐘虛擬面試，請你使用登陸詳細信息在開始日期和結束日期之間進行面試。</p><p></p><p>登錄詳情： </p><ul><li style='font-size: 14px; line-height: 1.2; mso-line-height-alt: 17px;'>網站: <a href='apisit.neufast.com/candidate' rel='noopener' style='text-decoration: underline; color: #0068A5;' target='_blank'>apisit.neufast.com/candidate</a></li><li style='font-size: 14px; line-height: 1.2; mso-line-height-alt: 17px;'>用戶名: {{Candidate’s login, don’t change}}</li><li style='font-size: 14px; line-height: 1.2; mso-line-height-alt: 17px;'>密碼: {{Candidate’s password, don’t change}}</li><li style='font-size: 14px; line-height: 1.2; mso-line-height-alt: 17px;'>開始: {{Start date and time, don’t change}}</li><li style='font-size: 14px; line-height: 1.2; mso-line-height-alt: 17px;'>結束: {{End date and time, don’t change}}</li><li style='font-size: 14px; line-height: 1.2; mso-line-height-alt: 17px;'>時區: {{Timezone, don’t change}}</li></ul><span style=\"font-size: 14px;\"><p></p><p></p><ins>系統要求:</ins></span><p>座檯電腦/手提電腦: 使用安裝了最新的 Chrome/Firefox/Safari(MacOS) 及有互聯網連接，攝像機和麥克風的座檯電腦/手提電腦;</p><p>手機: 使用安裝了Chrome的安卓手機 / Safari的蘋果手機 (SE2/XS or above)。建議使用良好的 Wi-Fi連接。 </p><p style=\"margin-left:0px;\"></p><p>感謝你參與我們的視像面試。 我們期待你的圓滿完成，下一輪再見。</p><p></p><p>祝好,</p><p>人才經理</p>",
  "Recruiter_Email_Reminder_Default": "<p>你好 {{Candidate’s name, don’t change}},</p><p>關於你申請 {{Company’s name, don’t change}} 的 {{Job Title, don’t change}}, 提醒你在此日期之前完成評核 {{End date and time, don’t change}}.  再次提供登陸方式:</p><ul> <li>網站: <a href='apisit.neufast.com/candidate' rel='noopener' style='text-decoration: underline; color: #0068A5;' target='_blank'>apisit.neufast.com/candidate</a></li> <li>用戶名: <strong>{{Candidate’s login, don’t change}}</strong></li><li>密碼: <strong>{{Candidate’s password, don’t change}}</strong></li> <li>開始: <strong>{{Start date and time, don’t change}}</strong></li><li>限期: <strong>{{End date and time, don’t change}}</strong></li> <li>時區: <strong>{{Timezone, don’t change}}</strong></li></ul><p></p><p>感謝參加我們的評核，我們期待你能圓滿完成並在下一輪見。</p><p></p><p>祝好，</p><p>人事經理</p>",
  "Recruiter_Email_Reminder_Default_old": "<p>你好 {{Candidate’s name, don’t change}},</p><p>關於你申請 {{Company’s name, don’t change}} 的 {{Job Title, don’t change}}, 提醒你在此日期之前完成面試 {{End date and time, don’t change}}.  再次提供面試的登陸方式:</p><ul> <li>面試網站: <a href='apisit.neufast.com/candidate' rel='noopener' style='text-decoration: underline; color: #0068A5;' target='_blank'>apisit.neufast.com/candidate</a></li> <li>用戶名: <strong>{{Candidate’s login, don’t change}}</strong></li><li>密碼: <strong>{{Candidate’s password, don’t change}}</strong></li> <li>開始: <strong>{{Start date and time, don’t change}}</strong></li><li>限期: <strong>{{End date and time, don’t change}}</strong></li> <li>時區: <strong>{{Timezone, don’t change}}</strong></li></ul><p></p><p>感謝參加我們的面試，我們期待你能圓滿完成並在下一輪見。</p><p></p><p>祝好，</p><p>人事經理</p>",
  "Recruiter_Email_Confirmation_Default": "<p>你好 {{Candidate’s name, don’t change}},</p><p>感謝完成我們的視像評核. 你的評核正被分析中，若你成功進入下一輪，我們將立即與你聯繫.</p><p></p><p>祝好, </p><p>人事經理</p>",
  "Recruiter_Email_Confirmation_Default_old": "<p>你好 {{Candidate’s name, don’t change}},</p><p>感謝完成我們的視像面試. 你的面試正被審核中，若你成功進入下一輪，我們將立即與你聯繫.</p><p></p><p>祝好, </p><p>人事經理</p>",
  "Recruiter_Email_Extension_Default": "<p>你好 {{Candidate’s name, don’t change}},</p><p>關於你申請 {{Company’s name, don’t change}} 的 {{Job Title, don’t change}}, 評核的截止日改為 {{End date and time, don’t change}}. 再次提供評核的登陸方式:</p><ul> <li>網站: <a href='apisit.neufast.com/candidate' rel='noopener' style='text-decoration: underline; color: #0068A5;' target='_blank'>apisit.neufast.com/candidate</a></li> <li>用戶名: <strong>{{Candidate’s login, don’t change}}</strong></li><li>密碼: <strong>{{Candidate’s password, don’t change}}</strong></li> <li>開始: <strong>{{Start date and time, don’t change}}</strong></li><li>限期: <strong>{{End date and time, don’t change}}</strong></li> <li>時區: <strong>{{Timezone, don’t change}}</strong></li></ul><p></p><p>感謝參加我們的評核，我們期待你能圓滿完成並在下一輪見。</p><p></p><p>祝好，</p><p>人事經理</p>",
  "Recruiter_Email_Extension_Default_old": "<p>你好 {{Candidate’s name, don’t change}},</p><p>關於你申請 {{Company’s name, don’t change}} 的 {{Job Title, don’t change}}, 視像面試的截止日改為 {{End date and time, don’t change}}. 再次提供面試的登陸方式:</p><ul> <li>面試網站: <a href='apisit.neufast.com/candidate' rel='noopener' style='text-decoration: underline; color: #0068A5;' target='_blank'>apisit.neufast.com/candidate</a></li> <li>用戶名: <strong>{{Candidate’s login, don’t change}}</strong></li><li>密碼: <strong>{{Candidate’s password, don’t change}}</strong></li> <li>開始: <strong>{{Start date and time, don’t change}}</strong></li><li>限期: <strong>{{End date and time, don’t change}}</strong></li> <li>時區: <strong>{{Timezone, don’t change}}</strong></li></ul><p></p><p>感謝參加我們的面試，我們期待你能圓滿完成並在下一輪見。</p><p></p><p>祝好，</p><p>人事經理</p>",
  "Recruiter_SMS_Invitation_Default": "請注意你申請 {{company name}} 之 {{job title}}職位需要進行評核. 詳情請參看你的電郵 {{Candidate’s login, don’t change}}. 謝謝!!",
  "Recruiter_SMS_HighScoreContent_Default": "請注意你申請 {{company name}} 之 {{job title}}職位需要進行視像面試. 詳情請參看你的電郵 {{Candidate’s login, don’t change}}. 謝謝!!",
  "Recruiter_SMS_MediumScoreContent_Default": "請注意你申請 {{company name}} 之 {{job title}}職位需要進行視像面試. 詳情請參看你的電郵 {{Candidate’s login, don’t change}}. 謝謝!!",
  "Recruiter_SMS_LowScoreContent_Default": "請注意你申請 {{company name}} 之 {{job title}}職位需要進行視像面試. 詳情請參看你的電郵 {{Candidate’s login, don’t change}}. 謝謝!!",
  "Recruiter_SMS_Reminder_Default": "請注意你申請 {{company name}} 之 {{job title}} 職位的評核將於24小時內截止，請儘快完成. 詳情請參看你的電郵: {{Candidate’s login, don’t change}}. 謝謝!",
  "Recruiter_SMS_Extension_Default": "請注意你申請 {{company name}} 之 {{job title}} 職位的評核截止日將改為 {{End date and time, don’t change}}. 請儘快完成。詳情請參看你的電郵: {{Candidate’s login, don’t change}}. 謝謝!",
  "Recruiter_SMS_Invitation_Default_old": "請注意你申請 {{company name}} 之 {{job title}}職位需要進行視像面試. 詳情請參看你的電郵 {{Candidate’s login, don’t change}}. 謝謝!!",
  "Recruiter_SMS_Reminder_Default_old": "請注意你申請 {{company name}} 之 {{job title}} 職位的視像面試將於24小時內截止，請儘快完成. 詳情請參看你的電郵: {{Candidate’s login, don’t change}}. 謝謝!",
  "Recruiter_SMS_Extension_Default_old": "請注意你申請 {{company name}} 之 {{job title}} 職位的視像面試截止日將改為 {{End date and time, don’t change}}. 請儘快完成。詳情請參看你的電郵: {{Candidate’s login, don’t change}}. 謝謝!",
  "Recruiter_Email_Redo_Default": "<p>你好 {{Candidate’s name, don’t change}},</p><p>感謝你參與我們對 {{Company’s name, don’t change}} 的 {{Job Title, don’t change}} 職位的評核。 不幸的是，我們發現 {{Number of retaking questions, don’t change}} 題的視像沒成功錄影。請在限期之前使用下面的鏈接重新回答這些題目。</p><p></p><p>下面提供了登錄信息。請在安裝了網絡攝像頭的手機或手提電腦上使用最新的 Chrome/Firefox/Safari 瀏覽器進行面試。</p><ul> <li>面試網站: <a href='apisit.neufast.com/candidate' rel='noopener' style='text-decoration: underline; color: #0068A5;' target='_blank'>apisit.neufast.com/candidate</a></li> <li>用戶名: <strong>{{Candidate’s login, don’t change}}</strong></li><li>密碼: <strong>{{Candidate’s password, don’t change}}</strong></li> <li>開始: <strong>{{Start date and time, don’t change}}</strong></li><li>限期: <strong>{{End date and time, don’t change}}</strong></li> <li>時區: <strong>{{Timezone, don’t change}}</strong></li></ul><p></p><p>我們期待你成功完成，下一輪再見。</p><p></p><p>祝好,</p><p>人才經理</p>",
  "Recruiter_Email_Redo_Default_old": "<p>你好 {{Candidate’s name, don’t change}},</p><p>感謝你參加我們對 {{Company’s name, don’t change}} 的 {{Job Title, don’t change}} 職位的視像面試。不幸的是，我們發現 {{Number of retaking questions, don’t change}} 題的視像沒成功錄影。請在限期之前使用下面的鏈接重新回答這些題目。</p><p></p><p>下面提供了登錄信息。請在安裝了網絡攝像頭的手機或手提電腦上使用最新的 Chrome/Firefox/Safari 瀏覽器進行面試。</p><ul> <li>面試網站: <a href='apisit.neufast.com/candidate' rel='noopener' style='text-decoration: underline; color: #0068A5;' target='_blank'>apisit.neufast.com/candidate</a></li> <li>用戶名: <strong>{{Candidate’s login, don’t change}}</strong></li><li>密碼: <strong>{{Candidate’s password, don’t change}}</strong></li> <li>開始: <strong>{{Start date and time, don’t change}}</strong></li><li>限期: <strong>{{End date and time, don’t change}}</strong></li> <li>時區: <strong>{{Timezone, don’t change}}</strong></li></ul><p></p><p>我們期待你成功完成，下一輪再見。</p><p></p><p>祝好,</p><p>人才經理</p>",
  "Recruiter_Email_Report_Default": "<p>你好 {{Candidate’s name, don’t change}},</p><p>感謝完成我們的視像面試。 你的面試影片之分析已完成。 以下是你的整體分數和評價:</p><p></p><p>分數: {{Score, don’t change}}/10</p><p>評價: {{Comment, don’t change}}</p><p></p><p>隨郵件附上一份能力發展報告，協助你確認自身的發展需要。</p><p></p><p>祝好,</p><p>人事經理</p>",
  "Recruiter_Email_WithoutScore_Report_Default": "<p>你好 {{Candidate’s name, don’t change}},</p><p>感謝完成我們的視像面試。你的面試影片之分析已完成。 隨郵件附上一份能力發展報告，協助你確認自身的發展需要。</p><p></p><p>祝好,</p><p>人事經理</p>",
  "Recruiter_Upload_Large_File_Warning_Title": '偵測到有大型檔案',
  "Recruiter_Upload_Large_File_Warning_Message": '上傳的檔案超過200MB. 這可能會造成面試不流暢。',
  "Recruiter_AccountSetting_Title": "帳戶設定",
  "Recruiter_AccountSetting_RecruiterProfile_Title": "雇主資料",
  "Recruiter_AccountSetting_CompanyProfile_Title": "公司資料",
  "Recruiter_AccountSetting_Functionality_Title": "功能",
  "Recruiter_AccountSetting_UsageHistory_Title": "使用量",
  "Recruiter_AccountSetting_Password_Title": "密碼",
  "Recruiter_AccountSetting_Add_Recruiter_Button": "Add Sub-recruiter",
  "Recruiter_AccountSetting_Register_Dialog_Title": "Sub-recruiter Registration",
  "Recruiter_AccountSetting_Register_Dialog_SubTitle_Login": "Login Information",
  "Recruiter_AccountSetting_Register_Dialog_SubTitle_Account": "Account Information",
  "Recruiter_AccountSetting_Register_Dialog_Email": "Email",
  "Recruiter_AccountSetting_Register_Dialog_Password": "Password",
  "Recruiter_AccountSetting_Register_Dialog_FirstName": "First Name",
  "Recruiter_AccountSetting_Register_Dialog_LastName": "Last Name",
  "Recruiter_AccountSetting_RecruiterProfile_Picture": "雇主照片:",
  "Recruiter_AccountSetting_RecruiterProfile_FirstName": "名字:",
  "Recruiter_AccountSetting_RecruiterProfile_LastName": "姓氏:",
  "Recruiter_AccountSetting_RecruiterProfile_Email": "電郵:",
  "Recruiter_AccountSetting_RecruiterProfile_JobTitle": "職位:",
  "Recruiter_AccountSetting_RecruiterProfile_Tel": "電話:",
  "Recruiter_AccountSetting_Functionality_RecruiterEvaluation": "招聘人員評分",
  "Recruiter_AccountSetting_Functionality_FacialAnnotation": "視像表情標註",
  "Recruiter_AccountSetting_UsageHistory_NumberInvitations": "面試數目",
  "Recruiter_AccountSetting_UsageHistory_NumberCompletedInterviews": "完成面試數目",
  "Recruiter_AccountSetting_UsageHistory_TimePeriod": "時期",
  "Recruiter_AccountSetting_UsageHistory_Number": "數目",
  "Recruiter_AccountSetting_Password_CurrentPassword": "現有密碼",
  "Recruiter_AccountSetting_Password_NewPassword": "新密碼",
  "Recruiter_AccountSetting_Password_PasswordConfirmation": "再輸入新密碼",
  "Recruiter_AccountSetting_PurchaseBalance_Title": "單據和餘額",
  "Recruiter_AccountSetting_DateOfPurchase": "購買日期",
  "Recruiter_AccountSetting_ValidUntil": "有效日期",
  "Recruiter_AccountSetting_Reference": "編碼",
  "Recruiter_AccountSetting_NumberOfInterviews": "面試數量",
  "Recruiter_AccountSetting_NumberOfExpiredInterviews": "過期數量",
  "Recruiter_AccountSetting_RecruiterAccount": "僱主帳戶",
  "Recruiter_AccountSetting_InterviewUsage": "面試用量",
  "Recruiter_AccountSetting_PurchasedInterviews": "單據",
  "Recruiter_AccountSetting_Usage": "用量",
  "Recruiter_AccountSetting_Balance": "餘額",
  "Recruiter_AccountSetting_AccountStatus": "帳戶狀態",
  "Recruiter_AccountSetting_TotalNumberOfInterviews": "面試總數量 (1)",
  "Recruiter_AccountSetting_TotalInterviewUsage": "面試總用量 (2)",
  "Recruiter_AccountSetting_TotalNumberOfExpiredInterviews": "過期總數量 (3)",
  "Recruiter_AccountSetting_TotalBalance": "餘額 = (1) - (2) - (3)",
  
  "Recruiter_CV_Upload_Message": "上載履歷",
  "Recruiter_CV_Extension": "檔案格式: JPG, PDF, DOC, DOCX",
  
  "Candidate_Common_Next": "繼續",
  "Candidate_Common_Start": "開始",
  "Candidate_Common_Step_Setting": "設備測試",
  "Candidate_Common_Step_Practice": "練習",
  "Candidate_Common_Step_Real": "面試",
  "Candidate_Common_Step_Finished": "結束",
  "Candidate_Common_HideCamera": "隱藏攝像頭",
  "Candidate_Common_TimeRemaining": "剩餘時間",
  "Candidate_Common_Video_Recording": "錄製...",
  "Candidate_Common_Video_Stop": "結束",
  "Candidate_Common_Video_Uploading": "上傳...",
  "Candidate_Interview_LoadingMessage": "請稍候，正在加載評核...",
  "Candidate_Interview_LoadingMessage_old": "請稍候，正在加載視像面試...",
  "Candidate_Interview_ValidationHandler_Title": "檢測到重複的登錄",
  "Candidate_Interview_ValidationHandler_Content": "登出中...",
  "Candidate_Browser_Msg": "<p> 不好意思，你的浏览器不支持视频面试。 </p> <p>请用最新版本的谷歌 Google Chrome 浏览器. 你能在以下网址下载:</p><p><a href=\"https://www.google.com/chrome/\">https://www.google.com/chrome/</a></p><p> 另一方法, 是用Android手机的谷歌 Google Chrome 浏览器。 谢谢! </p>",
  "Candidate_Browser_Warning_IOS": "蘋果手機的瀏覽器暫不支持視像面試。請使用Neufast Interview App或者 Mac/Android/Windows的Chrome 瀏覽器",
  "Candidate_Browser_Warning_Edge": "你的Edge瀏覽器版本不支持視像面試。請更新使用最新版Edge瀏覽器",
  "Candidate_Browser_Warning_Generic": "你的瀏覽器不支持視像面試。請使用Chrome瀏覽器",
  "Candidate_Browser_Warning_CriOS": "iOS上的Chrome與我們的應用程序不兼容。請切換到野生動物園",
  "Candidate_Interview_WelcomeTitle": "歡迎你，{name}！ 請為以下職位完成一次評核。",
  "Candidate_Interview_WelcomeTitle_old": "歡迎你，{name}！ 請為以下職位完成一次視像面試。",
  "Candidate_Interview_WelcomeTitle_ongrad": "歡迎, {name}! 請為以下計劃進行視像面試.",
  "Candidate_Interview_AutoLogin_ImportByAccessKey_Fail_starttime_not_reached": "訪談系列尚未開始。請在電子郵件中讀取面試時間。",
  "Candidate_Interview_AutoLogin_ImportByAccessKey_Fail_incorrect_password": "密碼 / 帳號錯誤",
  "Candidate_Interview_AutoLogin_ImportByAccessKey_Fail_expired_bad": "登錄令牌已過期。請檢查您的網絡連接，然後重試。",
  "Candidate_Interview_AutoLogin_ImportByAccessKey_Fail_deadline_passsed": "您的面試截止日期已經過去。",
  "Candidate_Interview_AutoLogin_ImportByAccessKey_Fail_interview_completed": "您的面試完成並進行了審查。",
  "Candidate_Interview_AutoLogin_ImportByAccessKey_Fail_frozen": "您的帳戶已關閉/過期，請聯繫您的介紹人以進行進一步查詢。",
  "Candidate_Interview_Welcome_Company": "<b>公司:</b> {companyName}",
  "Candidate_Interview_Welcome_JobTitle": "<b>職位:</b> {jobTitle}",
  "Candidate_Interview_Welcome_CompanyWebsite": "<b>網站:</b> {companyWebsite}",
  "Candidate_Interview_Welcome_Deadline": "<b>最後期限:</b> {deadline}",
  "Candidate_Interview_Language": "<b>評核語言：</b> {interviewLanguage}",
  "Candidate_Interview_Language_old": "<b>視像面試語言：</b> {interviewLanguage}",
  "Candidate_Introduction_Title": "曾經想過AIA精英學院到底發生了什麼嗎？",
  "Candidate_Instruction_Title": "操作說明",
  "Candidate_Instruction_Tips": "(<b>提示：</b>觀看此影片能幫助你認識公司和這應徵的職位)",
  "Candidate_Instruction_Details": ['找一個安靜的地方進行面試。', '將設備放在支架上或用平穩的手握住。', '請關閉其他網頁和應用程式。', '為了錄製高質量的影像以進行公平的評核，請不要在視像面試進行期間配戴口罩。'],
  "Candidate_Instruction_Details_old": ['找一個安靜的地方進行面試。', '將設備放在支架上或用平穩的手握住。', '請關閉其他網頁和應用程式。', '為了錄製高質量的影像以進行公平的視像面試，請不要在視像面試進行期間配戴口罩。'],
  "Candidate_Instruction_Details2": ['請在帶有網絡攝像頭和麥克風的座檯電腦/手提電腦上使用更新了的 Chrome/Firefox 瀏覽器來執行評核。', '使用智能手機/移動設備進行視像面試是 <b>不建議。</b>', '<b>視像面試不要戴口罩。</b>', '一次完成視像面試。', '完成後，請等待你的影片完成上傳，然後再關閉瀏覽器。', '讓你的背景設置不受干擾。'],
  
  "Candidate_Instruction_Details_last": "準備好後, 按 \"繼續\". 然後，我們將測試網絡，攝錄機和麥克風等設備",
  
  "Candidate_Instruction_RecordedInterview_Message": "這是一個自動評核，因此你不會被真人面試！",
  "Candidate_Instruction_RecordedInterview_Message_old": "這是一個自動視像面試，因此你不會被真人面試！",
  "Candidate_Settings_Title": "設備測試",
  "Candidate_Settings_Caption": "在進行評核之前，請確保你設備的網絡攝像頭、麥克風和揚聲器已打開並正常工作。",
  "Candidate_Settings_Caption_old": "在進行視像面試之前，請確保你設備的網絡攝像頭、麥克風和揚聲器已打開並正常工作。",
  "Candidate_Settings_Browser_Compatibility": "瀏覽器兼容性",
  "Candidate_Settings_Browser_Compatibility_Caption": "您的瀏覽器是",
  "Candidate_Settings_Browser_Compatibility_Text_True": "兼容的",
  "Candidate_Settings_Browser_Compatibility_Text_False": "不兼容",
  "Candidate_Settings_Browser_Compatibility_Warning": "警告：瀏覽器已過時和/或不受支持",
  "Candidate_Settings_Browser_Compatibility_Warning_Message": "請將瀏覽器更新至最新版本或使用其他瀏覽器。如果您選擇繼續，面試過程可能會失敗。",
  "Candidate_Settings_Browser_Compatibility_Warning_Message_Button": "確認",
  "Candidate_Settings_Browser_Compatibility_Browser": "支持的瀏覽器：",
  "Candidate_Settings_Browser_Compatibility_Handling": "如果問題仍然存在，請嘗試使用不同的設備",
  "Candidate_Settings_Browser_Compatibility_Handling_iOS": "偵測到 iOS/MacOS 版本。 {version}。請更新至ver.14.3或更新版本",
  "Candidate_Settings_Browser_Compatibility_Handling_CriOS": "您正在 iOS/iPad 上使用 Chrome。請改用Safari瀏覽器",
  "Candidate_Settings_Browser_Compatibility_Handling_Unknown": "iOS/iPadOS/MacOS 偵測到未知錯誤。 {version}。",
  "Candidate_Settings_Webcam": "攝錄機",
  "Candidate_Settings_Webcam_Caption": "請授權使用你的攝錄機，並確保你的臉顯示在畫面中",
  "Candidate_Settings_Microphone": "麥克風",
  "Candidate_Settings_Microphone_Caption": "請授權使用你的麥克風，並對著麥克風說話確保聲量顯示在以下的偵測器中",
  "Candidate_Switch_Off_Camera": "視頻已關閉。您將被引導至設備檢查頁面。請確保網絡攝像頭已打開，然後您可以從當前問題重新開始視頻採訪。",
  "Candidate_Settings_MicrophoneVolume_TooLow": "太低",
  "Candidate_Settings_MicrophoneVolume_Low": "低",
  "Candidate_Settings_MicrophoneVolume_Recommended": "推薦",
  "Candidate_Settings_MicrophoneVolume_Loud": "大",
  "Candidate_Settings_MicrophoneVolume_TooLoud": "太大",
  "Candidate_Settings_Lighting": "亮度和位置",
  "Candidate_Settings_Speaker": "揚聲器聲量",
  "Candidate_Settings_Speaker_Caption": "請測試揚聲器並確保你聽到音樂",
  "Candidate_Settings_TestAudio": "測試揚聲器",
  'Candidate_Settings_PauseAudio': "停止測試",
  "Candidate_Settings_LightCheckPrefix": "按",
  "Candidate_Settings_LightCheckSuffix": "看照明和位置是否合適。",
  "Candidate_Settings_LightCheckPrefixButton": "此處",
  "Candidate_Settings_NetworkCondition": "網絡狀況",
  "Candidate_Settings_NetworkCondition_UploadSpeed": "上載速度: {speed}",
  "Candidate_Settings_NetworkCondition_DownloadSpeed": "下載速度: {speed}",
  "Candidate_Settings_NetworkCondition_Estimating": "估計中...",
  "Candidate_Settings_NetworkCondition_Recommendation": "(建議使用穩定的Wi-Fi網絡)",
  "Candidate_Settings_NetworkCondition_NASpeed": "--- KB/秒",
  "Candidate_Settings_NetworkCondition_B": "{speed} B/秒",
  "Candidate_Settings_NetworkCondition_KB": "{speed} KB/秒",
  "Candidate_Settings_NetworkCondition_MB": "{speed} MB/秒",
  "Candidate_Settings_NetworkCondition_GB": "{speed} GB/秒",
  "Candidate_Settings_Error_Msg": "無法取用錄影/錄音設備。請確保已啟用它們，並且沒有其他應用程序正在使用它們。",
  "Candidate_Settings_Microphone_No_Voice_Error_Msg": "偵測不到麥克風的錄音。請關掉此對話框並對著麥克風說話以作測試。如果情況持續，請檢查你的麥克風以確保運作正常。",
  "Candidate_Detail_Greeting": "你好, {name}!",
  "Candidate_Detail_Greeting_In_Mobile_View": "你好, {name}",
  "Candidate_Detail_QuestionAndTimeLimit": "本次面試包含 <span style=\"font-size: 150%\">{totalQuestion}</span> 問題以及需要 <span style=\"font-size: 150%\">{timeLimit}</span> 分鐘",
  "Candidate_Detail_Deadline": "截止時間:",
  "Candidate_Detail_InterviewPractice": "面試練習",
  "Candidate_Detail_Multiple_Choices_Practice": "多項選擇題練習",
  "Candidate_Detail_Short_Question_Practice": "短答題練習",
  "Candidate_Detail_Question": "題目",
  "Candidate_Detail_Interview": "面試",
  "Candidate_Detail_Duration": "總長度:",
  "Candidate_Detail_Format": "格式:",
  "Candidate_Detail_Interview_Reminder": "提醒",
  "Candidate_Detail_Language_Text_Suffix": '{language}',
  "Candidate_Detail_Paragraph_1": "在進行此測試之前，我們建議你進行練習測試以幫助你熟悉其格式。",
  "Candidate_Detail_Paragraph_2": '此面試包括 <span style=\"font-weight: bold;font-size: 200%\">{noOfQuestion}</span> {measureWord}.',
  "Candidate_Detail_Paragraph_2_Retake": '重做的面試包括 <span style=\"font-weight: bold;font-size: 200%\">{noOfQuestion}</span> {measureWord}.',
  "Candidate_Detail_Language_Text_Suffix_2": '<span style=\"font-weight: bold;font-size: 200%;color: red\">{noOfQuestion}</span> {measureWord}{language}',
  "Candidate_Detail_Paragraph_3": "每條問題，你有 <span style=\"background-color: #e3f2fd\">{preparationTime} 思考你的答案</span>, 然後有不超過 <span style=\"background-color: #e3f2fd\">{timeForEachQuestion} 回答時間。</span>",
  "Candidate_Detail_Paragraph_3_No_Preparation_Time": "每條問題，你有 <span style=\"background-color: #e3f2fd\">{timeForEachQuestion} 回答時間。</span>",
  "Candidate_Detail_Paragraph_4": "<b>總共需時:</b> {totalTime}",
  "Candidate_Detail_Video_Interview": "視像面試",
  "Candidate_Detail_Short_Question": "短答題",
  "Candidate_Detail_Multiple_Choices": "多項選擇題",
  "Candidate_Detail_Video_Interview_Paragraph_1_normal": "你的視像面試測試包括 {noOfQuestion} {measureWord}。",
  "Candidate_Detail_Video_Interview_Paragraph_1_normal_Retake": "你對面試的部分重拍包括 {noOfQuestion} {measureWord}：",
  "Candidate_Detail_Video_Interview_Paragraph_2_normal": "對於每個問題，你有 {preparationTime} 時間來考慮你的回答，然後最多 {timeForEachQuestion} 來回答。",
  "Candidate_Detail_Video_Interview_Paragraph_2_normal_No_Preparation_Time": "對於每個問題，你最多可以回答 {timeForEachQuestion} 。",
  "Candidate_Detail_Number_Of_Attempts_Each_Question": "您有 {numberofattempts} 次嘗試記錄每個問題的答案",
  "Candidate_Detail_Multiple_Choices_Paragraph_1_normal": "你的多項選擇題測試包括 {noOfQuestion} {measureWord}。",
  "Candidate_Detail_Short_Question_Paragraph_1_normal": "你的短答題測試由 {noOfQuestion} {measureWord} 組成。",
  "Candidate_Detail_Multiple_Choices_Paragraph_1": "對於每個問題，你大約有 {timeForEachQuestion} 來回答。",
  "Candidate_Detail_Multiple_Choices_Text_Suffix": "<span style=\"font-weight: bold;font-size: 200%;color: black\">{noOfQuestion}</span>",
  "Candidate_Detail_Short_Question_Paragraph_1": "對於每個問題，你大約有 {timeForEachQuestion} 來回答。",
  "Candidate_Detail_Short_Question_Text_Suffix": "<span style=\"font-weight: bold;font-size: 200%;color: black\">{noOfQuestion}</span>",
  "Candidate_Detail_Start_Practice": "開始練習",
  "Candidate_Detail_Sec_to_Prepare": "分鐘準備",
  "Candidate_Detail_Min_To_Answer": "分鐘回答",
  "Candidate_Detail_Start_Interview": "開始面試",
  "Candidate_Detail_Start_Test": "開始測驗",
  "Candidate_Detail_Interview_Info_Heading": "你的評核信息如下：",
  "Candidate_Detail_Compay": "公司",
  "Candidate_Detail_Position_Requested": "職位",
  "Candidate_Detail_Website": "網頁",
  "Candidate_Detail_Interview_Date_And_Time": "評核日期和時間",
  "Candidate_Detail_Help_Center": "疑問回答",
  "Candidate_Detail_Video_Interview_Information": "視像面試信息",
  "Candidate_Detail_Multiple_Choices_Information": "多項選擇題測試信息",
  "Candidate_Detail_Short_Question_Information": "短答題測試信息",
  
  "Candidate_Interview_Time_Remaining": "剩餘時間 :",
  "Candidate_Interview_Question_Of": "{totalQuestion} 的問題 {question}",
  
  "Candidate_Practice_Title": "面試練習",
  "Candidate_Practice_PracticeAgain": "再次練習",
  "Candidate_Practice_Question": "問題",
  "Candidate_Practice_Placeholder": "請在這裡填寫答案",
  "Candidate_Practice_Answer_In": "回答語言 {language}",
  
  "Candidate_Practice_Answer_In_pu_en": "回答語言 普通話/英語",
  "Candidate_Practice_Answer_In_cn_en": "回答語言 廣東話/英語",
  
  "Candidate_Practice_Answer_Time": "回答時間",
  "Candidate_Practice_You_have": "你有",
  "Candidate_Practice_To_Think": "去準備你的答案。",
  "Candidate_Practice_Skip_Message": '你可以略過此部分並立即按 "錄影" 制開始。',
  "Candidate_Practice_Web_Skip_Message": '你可以略過此部分並立即按 "開始錄影" 制開始。',
  "Candidate_Practice_Record": "錄影",
  "Candidate_Practice_Start_Recording": "開始錄影",
  "Candidate_Practice_Hide_Self_View": "隱藏自我影像",
  "Candidate_Practice_Tip": "提示",
  "Candidate_Practice_Tip_Message": "請利用準備時間想一個好的答案",
  "Candidate_Practice_Enable_Self_View": "隱藏自我影像",
  "Candidate_Practice_Done": "完成",
  
  
  "Candidate_Practice_Check_Title": '這是你的練習錄影',
  "Candidate_Practice_Check_Content": '這錄影的收音和影像是否清晰?',
  "Candidate_Practice_Check_YES": '是',
  "Candidate_Practice_Check_NO": '否',
  "Candidate_Practice_Check_FAIL": '請再覆核你的麥克風和攝影機是否運作正常。你可能需要更換這些設備。',
  "Candidate_Practice_Check_Redirect": '設備測試',
  
  "Candidate_RealInterview_Finish_Title": "這是您錄製的視頻",
  "Candidate_RealInterview_Finish_Attempt_Question_Content": "您想再次回答一次這個問題嗎？",
  "Candidate_RealInterview_Finish_Max_Number_Attempt_Question":"( 這道題還有{numberOfAttempts}次嘗試機會 )",
  
  "Candidate_Practice_NextStagePopup_Title": "你好! 我是 {recruiterFirstname}, 今天我會為你進行面試",
  "Candidate_Practice_NextStagePopup_Start_Interview": "開始面試!",
  
  "Candidate_Practice_Welcome_Title": '歡迎使用面試練習',
  "Candidate_Practice_Welcome_Content": '每條題目將有 <span class=\"{spanClass}\">準備時間 {preparationTimeString}</span>, 你可以在錄製答案前先思考答案。',
  "Candidate_Practice_Welcome_Content_No_Preparation": '每條題目前沒有任何準備時間，錄影將在倒數3秒後開始。',
  "Candidate_Practice_Welcome_Checkbox_Label": '隱藏自我錄像 (你的答案會記錄被錄影)',
  "Candidate_Practice_Welcome_Confirm": '明白',
  "Candidate_Practice_Welcome_Start": "開始",
  
  "Candidate_Multiple_Choices_Practice_Welcome_Title": "歡迎來到 {testName} 練習",
  "Candidate_Multiple_Choices_Practice_Content": "此練習可幫助你熟悉測驗格式。 題目與正式測驗不同。",
  
  "Candidate_Short_Question_Practice_Welcome_Title": "歡迎來到 {testName} 練習",
  "Candidate_Short_Question_Practice_Content": "此練習可幫助你熟悉測驗格式。 題目與正式測驗不同。",
  
  "Candidate_Interview_Submit_Confirm": "提交",
  "Candidate_Interview_Submit_Not_Confirm": "返回",
  "Candidate_Interview_Submit_Content": "你確定要提交答案嗎？",
  "Candidate_Interview_Face_Detection_Warning": "未檢測到你的臉部。 如果你的相機位於你面前，請檢查你的設置。",
  
  "Candidate_Interview_Upload_Header_Progressing": "檢測到錯誤！ 請稍等。 上傳視像....",
  "Candidate_Interview_Upload_Header_Completed": "上一題的視像錄製失敗。",
  "Candidate_Interview_Upload_Body_Progressing": "上一題的視像錄製失敗。 這可能是瀏覽器或設備問題。 請等待之前問題的視像上傳完成。",
  "Candidate_Interview_Upload_Body_Completed": "這可能是瀏覽器或設備問題。 請重新啟動瀏覽器或使用其他設備繼續測試。 如果此問題仍然存在，請通過 'customer-service@neufast.com' 聯繫我們。 對造成的不便深表歉意。",
  
  "Candidate_Practice_Finish_Title": '這是你的練習錄影',
  "Candidate_Multiple_Choices_Practice_Finish_Title": "你已完成多項選擇題練習",
  "Candidate_Short_Question_Practice_Finish_Title": "你已經完成了短答題練習",
  "Candidate_Practice_Finish_Content": "測驗與練習的格式是一樣的",
  "Candidate_Practice_Finish_Content_old": "面試與練習的格式是一樣的",
  "Candidate_Practice_Finish_Button_Practice": '重新練習',
  "Candidate_Practice_Finish_Button_Back": '返回目錄',
  "Candidate_Practice_Finish_Button_Start": "開始面試",
  "Candidate_Practice_Finish_Button_Start_old": "開始面試",
  
  "Candidate_Logout_Confirm": "你的評核尚未完成，但你可以在截止日期前再次登錄。你現在要退出嗎？",
  
  
  "Candidate_RealInterview_Welcome_Title": '歡迎來進行面試!',
  "Candidate_RealInterview_Welcome_Content": '<div>請注意你 <span style=\"font-weight: bold;font-size: 110%\">不能</span> 在整個面試完成前離開。你只有 <span style=\"font-weight: bold;font-size: 110%\">一次</span> 作答機會，請不要有任何打擾或中斷。</div><br/><div>此外，請不要按瀏覽器上的"返回"，"刷新頁面"等按鈕，否則會流失你上傳的錄像。</div>',
  "Candidate_RealInterview_Welcome_Content_Number_Of_Attempt": '<div>除非您彻底完成面试，否则您必须<span style=\"font-weight: bold;font-size: 110%\">不要</span>离开面试。您有<span style=\"font-weight: bold;font-size: 110%\">{numberofattempts}</span> 尝试回答每个问题，应避免任何中断。</div><br/><div>此外，请不要按浏览器上的“后退”或“刷新”按钮，因为这会影响您的视频上传。</div>',
  "Candidate_RealInterview_Placeholder": '請在這裡填寫答案',
  "Candidate_RealInterview_Welcome_Checkbox_Label": '隱藏自我錄像 (你的答案會繼續被錄影)',
  "Candidate_RealInterview_Welcome_Confirm": '明白',
  
  "Candidate_Multiple_Choices_Welcome_Title": "歡迎你來到選擇題 {testName}！",
  "Candidate_Multiple_Choices_Welcome_Content": "<div>你在測驗完成前<span style=\"font-weight: bold;font-size: 110%\">不</span>應該離開。 你<span style=\"font-weight: bold;font-size: 110%\">只有一次</span>機會進行多項選擇測試，應避免任何中斷。</div><br/> <div>一旦你開始測驗，計時器就會開始計時，直到時間到或點擊\"提交\"按鈕。</div>",
  
  "Candidate_Short_Question_Welcome_Title": "歡迎你來到短答題 {testName}！",
  "Candidate_Short_Question_Welcome_Content": "<div>你在測驗完成前<span style=\"font-weight: bold;font-size: 110%\">不</span>應該離開。 你<span style=\"font-weight: bold;font-size: 110%\">只有一次</span>機會進行多項選擇測試，應避免任何中斷。</div><br/> <div>一旦你開始測驗，計時器就會開始計時，直到時間到或點擊\"提交\"按鈕。</div>",
  
  "Candidate_RealInterview_Finish_Title": "這是您錄製的視頻",
  "Candidate_RealInterview_Finish_Attempt_Question_Content": "您想再次回答這個問題嗎？",
  "Candidate_RealInterview_Finish_Max_Number_Attempt_Question":"( {numberOfAttempts} 此問題仍在嘗試)",

  "Candidate_RealInterview_Title": "視像面試",
  "Candidate_RealInterview_Question": "問題",
  "Candidate_RealInterview_Video": "請觀看上面的影片，然後回答問題",
  "Candidate_RealInterview_TotalQuestion": "面試題目:",
  "Candidate_RealInterview_NextQuestion": "下一條問題",
  "Candidate_RealInterview_Finish": "結束",
  "Candidate_RealInterview_Finish_Button_Answer_Again": "再次回答",
  "Candidate_RealInterview_BackButton": "你已按下返回按鈕離開了視像面試.",
  "Candidate_RealInterview_Reject": "抱歉，你的視像面試無法重新開始，以確保面試的公平性。 如果你遇到技術困難，請發送電子郵件至customer-service@neufast.com",
  'Candidate_RealInterview_CheckWebcam_Message': '抱歉!你的攝錄機在錄影時發生錯誤。正在嘗試解決此錯誤。',
  "Candidate_RealInterview_Warning": "警告",
  "Candidate_RealInterview_noVoiceWarning":"超過 10 秒未檢測到您的聲音。請提高聲線或檢查您的麥克風。",
  
  "Candidate_Interview_Part": "部分{number}",
  "Candidate_Interview_Proctoring": "監考",
  "Candidate_Interview_Question_List": "問題列表",
  "Candidate_Interview_Question": "問題 {questionNo}: {question}",
  "Candidate_Interview_Question_Previous": "上一頁",
  "Candidate_Interview_Question_Next": "繼續",
  "Candidate_Interview_Question_Submit": "提交",
  "Candidate_Interview_Multiple_Choices_Reminder": "* 你可以選擇多個答案",
  
  "Candidate_Multiple_Choices_Title": "多項選擇題",
  "Candidate_Short_Question_Title": "短答題",
  
  
  "Candidate_RealInterview_english_Section": "英語部分",
  "Candidate_RealInterview_cantonese_Section": "粤語部分",
  "Candidate_RealInterview_mandarin_Section": "普通話部分",
  "Candidate_RealInterview_thai_Section": "泰文部分",
  "Candidate_RealInterview_japanese_Section": "日語部分",
  "Candidate_RealInterview_indonesian_Section": "印尼語部分",
  "Candidate_RealInterview_vietnamese_Section": "越南語部分",
  "Candidate_RealInterview_khmer_Section": "柬埔寨语部分",
  "Candidate_RealInterview_malay_Section": "馬來語部分",
  "Candidate_RealInterview_german_Section": "德語部分",
  "Candidate_RealInterview_french_Section": "法語部分",
  "Candidate_RealInterview_korean_Section": "韓語部分",
  
  "Candidate_RealInterview_cn_en_Section": "廣東話/英語 Section",
  "Candidate_RealInterview_pu_en_Section": "普通話/英語 Section",
  "Candidate_RealInterview_th_en_Section": "泰文/英語 Section",
  
  "Candidate_RealInterview_english": "英文",
  "Candidate_RealInterview_cantonese": "粤語",
  "Candidate_RealInterview_mandarin": "普通話",
  "Candidate_RealInterview_thai": "泰文",
  "Candidate_RealInterview_putonghua": "普通話",
  "Candidate_RealInterview_japanese": "日語",
  "Candidate_RealInterview_indonesian": "印尼語",
  "Candidate_RealInterview_vietnamese": "越南語",
  "Candidate_RealInterview_khmer": "柬埔寨語",
  "Candidate_RealInterview_malay": "馬來語",
  "Candidate_RealInterview_german": "德語",
  "Candidate_RealInterview_french": "法語",
  "Candidate_RealInterview_korean": "韓語",
  
  "Candidate_RealInterview_pu_en": "普通話/英語",
  "Candidate_RealInterview_cn_en": "廣東話/英語",
  
  
  "Candidate_Language_Change_Dialog": '下 {noOfQuestion} 條問題用 {language}回答。',
  "Candidate_Language_Gotit": "明白!",
  
  "Candidate_Upload_Completed": "% 上載完成",
  "Candidate_Upload_Thankyou": "謝謝回答所有問題!",
  "Candidate_Upload_Wait": "請耐心等待錄像上載，不要關閉瀏覽器。",
  "Candidate_upload_Complete_Wait": "請不要在上傳達到100%前關閉瀏覽器。",
  "Candidate_Finish_Continue": "繼續",
  "Candidate_Finish_Logout": "關閉窗口",
  "Candidate_Finish_Uploading": "正在上載已完成的影片，請稍為等候 ....",
  'Candidate_Finish_Redo': '抱歉!你其中{numberOfErrors}個答案未被正確錄影。請按"繼續"再次錄影這{numberOfErrors}個答案,謝謝。',
  
  "Candidate_Support_Button": "求職者支援",
  "Candidate_Support_Title": "視像面試和評核的求職者支援",
  "Candidate_Support_Walkthrough": "視像面試和評核演練",
  "Candidate_Support_TroubleShooting": "故障排除",
  "Candidate_Support_Contact": "如有任何疑問，請透過電子郵件<u>customer-service@neufast.com</u> 與我們聯絡",
  "Candidate_Support_Back": "返回",
  "Candidate_Support_Login_Subtitle": "登錄評核",
  "Candidate_Support_Login_Msg": "<p>第 1 步：訪問應聘者的登錄頁面，網址為 apisit.neufast.com/candidate。 可以通過最新的 Chrome/Firefox 網絡瀏覽器進行面試和評核。 請更新你的 chrome 或 firefox 瀏覽器為新版本。 建議使用帶 WI-FI 連接的手提電腦或座檯電腦，以確保獲得最佳錄製性能。</p> <p>第 2 步：輸入電子郵件地址和麵試邀請電子郵件中的訪問代碼。 僅在指定的面試期間可登錄。</p>",
  "Candidate_Support_Check_Subtitle": "檢查視像鏡頭和聲音",
  "Candidate_Support_Check_Msg": "系統將打開設備設置頁面並檢查網絡攝像頭、互聯網連接、照明、麥克風和揚聲器設置。請確保網絡攝像頭和麥克風已打開，而且互聯網連接流暢快速。",
  "Candidate_Support_Practice_Subtitle": "視像面試和評核的練習",
  "Candidate_Support_Practice_Msg": "對於每種類型的評核（視像面試/多項選擇題/短答題），在實際評核之前都會提供隨機練習題。 在練習中，為回答問題提供的佈局和時間與實際評核相同。 建議你利用這個機會練習和熟悉系統。 這種練習評核可以根據需要進行多次。",
  "Candidate_Support_Record_Subtitle": "面試和評核進行中",
  "Candidate_Support_Record_Msg": "通過練習部分後，評核即將開始。 具體回答時間由招聘人員規定。 為確保對所有求職者的公平性，所有評核只能進行一次。 因此，建議求職者在評核前多做練習測試。",
  "Candidate_Support_Tips_Subtitle": "獲得更好影片錄製效果的提示（僅適用於視像面試）",
  "Candidate_Support_Tips_Msg": "接著我們有一些提示以協助你呈現高質素的影片給招聘者。<ul><li>找一個安靜的環境</li><li>在光線充足且無背光的情況下錄製影片，類似於正常拍照的要求</li><li>把你的鏡頭水平調節到接近你視覺的水平。這做法有助於給面試官表現自信及接近於正常對話的感覺。</li></ul>",
  "Candidate_Support_Help_Subtitle": "需要更多面試技巧方面的幫助",
  "Candidate_Support_Help_Msg": "你是否需要更多的求職和面试的建議？我們一直與世界各地的認證職業教練合作，幫助求職者準備面試和選擇職業道路。如果需要幫助，請隨時通過 customer-service@neufast.com 聯繫我們。 免費查詢及瀏覽我們的職業發展網站 <a href='http://www.neucareers.com'> www.neucareers.com </a>。",
  
  "Candidate_Support_SystemRequirement_Subtitle": "視像面試和評核的系統要求",
  "Candidate_Support_SystemRequirement_Msg": "<p>對於求職者，座檯電腦/手提電腦支持最新的 Google Chrome（90 或更高版本）、Firefox（88 或更高版本）、Safari（14 或更高版本）和 Chromium Edge（76 或更高版本）。 還支持 Android 上的 Google Chrome（92 或更高版本）以及 iOS 14 或更高版本上的 Safari 和 Chrome。 其他瀏覽器推薦安裝谷歌Chrome瀏覽器。 </p><p>為確保獲得最佳視像面試效果，強烈建議使用裝有 Windows 或 MacOS 的座檯電腦/手提電腦，使用最新的 Google Chrome 或 Firefox 瀏覽器進行視像面試。 只要建立了良好的互聯網連接並且沒有中斷（例如來電），也可以使用手機。</p>",
  "Candidate_Support_AllowAccess_Subtitle": "允許連接你的攝錄機、麥克風",
  "Candidate_Support_AllowAccess_Msg": "<p>該網站需要使用網絡攝像頭和麥克風才能進行面試和評核。 在視像和音頻設置頁面，如果你使用支持的瀏覽器，系統將提示你授權使用麥克風和攝像頭。 兩者都單擊允許。 （你只需執行一次）。</p><p>如果你不小心拒絕了對攝像頭或麥克風的授權，你可以重新啟動瀏覽器，一旦你重新登入，瀏覽器會再次於視像和音頻設置頁面提示你授權。 </p>",
  "Candidate_Support_Speaker_Subtitle": "打開揚聲器",
  "Candidate_Support_Speaker_Msg": "雖然不是強制性的，但啟用揚聲器可以讓系統讀出面試問題，以創造更具吸引力的面試體驗。它可以在視像和音頻設置期間進行測試。",
  "Candidate_Support_NetworkQuality_Subtitle": "解決網絡質素",
  "Candidate_Support_NetworkQuality_Msg": "<p>為確保視像面試錄音的最佳質量，請確保你的設備在開始前具有良好的互聯網連接。</p><p>至少有 1Mbps 的穩定上傳速度，可實現流暢的影片上傳，如果你使用固定電話或 WIFI 網絡，通常可以實現。</p><p>請使用 SpeedTest.net 檢查用戶連接速度。</p><p>如果你在手機上使用蜂窩網絡，我們會降低錄製分辨率以提高數據傳輸的平滑度。但是你在錄製時可能仍會遇到困難。強烈建議你嘗試使用以下提示獲得更高質量的連接：</p><ul><li>對於 WiFi 用戶，請確保你的設備信號強且路由器已連接到互聯網。嘗試將你的設備重新放置在靠近 WiFi 路由器的位置，或嘗試重新啟動路由器。</li><li>對於手機用戶，請嘗試尋找信號較強的位置。</li><li>有關信號問題，請聯繫你的互聯網服務提供商。</li></ul>",
  "Candidate_Support_CameraIssues_Subtitle": "解決攝錄機問題",
  "Candidate_Support_CameraIssues_Msg": "<p>嘗試以下方法來解決攝錄機問題：</p><ul><li>確保你已允許訪問攝錄機。</li><li>確保你使用的是 Chrome 瀏覽器並且瀏覽器是最新的。</li><li>使用更新後的瀏覽器重新啟動設備。</li><li>檢查你的系統設置，確保攝錄機安裝正確並且可以訪問。</li><li>如果按照上述步驟操作後問題仍然存在，請聯繫網絡攝像頭製造商。</li></ul>",
  "Candidate_Support_MicrophoneIssues_Subtitle": "解決麥克風問題",
  "Candidate_Support_MicrophoneIssues_Msg": "<p>如果你的麥克風無法正常運作，請嘗試以下修復：</p><ul><li>檢查你是否允許使用麥克風。</li><li>確保你的麥克風沒有靜音並檢查開關（如果有）。</li><li>檢查你的系統設置，確保你的麥克風是默認錄音設備並且有正確的錄音電平。</li><li>重啟設備。</li><li>如果你在嘗試上述修復後仍然遇到問題，請聯繫你的麥克風製造商。</li></ul>",
  "Candidate_Support_AboutNeufast_Subtitle": "關於Neufast",
  "Candidate_Support_AboutNeufast_Msg": "Neufast是視像面試的領導者和專家，幫助招聘人員及時找到合適的人選，並幫助人才快速地獲得工作機會。 視像面試還允許求職者展示他們的能力，基於文字或基於文本。招聘人員還可以有效地全面評核候選人。",
  "Candidate_Support_FAQ_Subtitle": "常見問題",
  "Candidate_Support_FAQ_Msg": "<ul><li><p>什麼是單向視像面試評核？</p><p>視像面試是一種單向在線面試。一旦招聘人員邀請你參加面試，你就可以在線訪問系統並自動進行面試。面試被錄音 這讓更多的候選人有機會向潛在雇主展示他們的才能和抱負，而不是純粹通過簡歷來評判。</p></li><br/><li><p>面試系統可以使用什麼設備？</p><p>你需要帶有攝錄機、麥克風和良好的互聯網連接的座檯或手提電腦。 也可以使用Android/iPhone手機。 系統支援最新的 Google Chrome（90 或以上）、Firefox（88 或以上）和 Chromium Edge（76 或以上）的筆記本電腦/桌上電腦。 亦支援 Android 上的 Google Chrome（92 或更高版本）。 建議使用 IE 或 Safari 等瀏覽器的用戶安裝 Google Chrome 瀏覽器。 iPhone/iPad 用戶需要從 App Store 下載 Neufast 面試 App 進行面試。</p><p>為確保最佳視像面試效果，強烈建議使用Windows或MacOS的座檯/手提電腦，並使用最新的Chrome瀏覽器或Firefox瀏覽器進行視像面試。使用手機進行面試也是可以的，但需要在面試前確保網絡連接良好。</p></li><br/><li><p>我沒有筆記本電腦。我可以用我的手機嗎？</p><p>是的，但手機的互聯網連接不太穩定。建議找一個WIFI連接好的地方。此外，僅支持安卓手機。通常建議 iOS 手機使用筆記本電腦。</p></li><br/><li><p>我的手機剛剛連接了 3G，會不會有問題？</p><p>我們建議使用良好的 WiFi/4G 服務。使用 3G 會導致更長的影片上傳時間和更低的影片質量。如果這是唯一的選擇，我們建議你嘗試找到上傳速度最高的位置，然後在影片和音頻設置頁面測試網絡情況。</p></li><br/><li><p>這個面試我可以參加多少次？</p><p>你只能參加一次面試。話雖如此，你可以根據需要多次練習以適應系統。</p></li><br/><li><p>這個視像面試需要多長時間？</p><p>這取決於招聘人員為你設置的問題數量。通常在 30 分鐘以下。</p></li></ul>",
  
  "Candidate_AppSupport_PP_Title": "個人隱私政策 (PPS)",
  "Candidate_AppSupport_TC_Title": "條款和條件 (T&C)",
  
  "Button_Yes": '確定',
  "Button_No": '取消',
  "Department": "部門",
  "Job": "職位",
  "Candidate": "求職者",
  "Understand": "了解",
  "Name": "Name",
  "Email": "Email",
  "Current_Deadline": "當前截止日期",
  "Interview_Status": "面試狀態",
  "Close": "關閉",
  "Minutes": "分鐘",
  "Minute": "分鐘",
  "Seconds": '秒',
  "Second": '秒',
  'Questions': '條問題',
  'Question': '條',
  "Or": "或",
  'Back': '返回',
  'Start': '開始',
  
  'Record_Control_Error_Msg': "無法連接相機/音頻設備。請確保已啟用它們，並且沒有其他應用程序正在使用它們。",
  
  
  "Shortlisted": "入圍",
  "Rejected": "不錄用",
  "Waiting_Listed": "在候補名單",
  "Pending": "待發邀請...",
  "Waiting_Invitation": "邀請已發, 等待進行面試評核",
  "Processing": "處理影像中...",
  "Completed": "完成",
  "Partially_Completed": "部分完成",
  "No_Quota": "面試額度用完",
  
  "Login_HiAdmin": "歡迎使用 Neufast CMS",
  
  "Recruiter_Review_Title": "求職者評核列表",
  "Recruiter_Dashboard_TableColumn_ProgrammeName": "部門",
  "Recruiter_Dashboard_TableColumn_JobName": "職位名稱",
  "Recruiter_Dashboard_TableColumn_InterviewLanguage": "面試語言",
  "Recruiter_Dashboard_TableColumn_Last_Video": "最後影片上傳時間",
  "Recruiter_Dashboard_TableColumn_First_Video": "最初影片上傳時間",
  "Recruiter_Dashboard_TableColumn_Num_Of_Video": '已上傳影片數目',
  "Recruiter_Dashboard_TableColumn_Export": "輸出",
  "Review_Evaluation_Title": "審核",
  "Recruiter_Skills_Openness": "經驗開放性",
  "Recruiter_Skills_Conscientiousness": "盡責性",
  "Recruiter_Skills_Extraversion": "外向性",
  "Recruiter_Skills_Agreeableness": "親和性",
  "Recruiter_Skills_Neuroticism": "情緒不穩定性",
  "Recruiter_Review_Instruction": "這頁列出需審核求職者的名單",
  'Recruiter_Review_List_Files_Failure_Msg': '檢索文件失敗',
  'Recruiter_Review_Transfer_S3_Files_Dialog_Title': '從S3傳輸文件',
  'Recruiter_Review_Transfer_S3_Files_Dialog_LocalFiles': '本地文件存儲庫',
  'Recruiter_Review_Transfer_S3_Files_Dialog_S3Files': 'S3',
  'Recruiter_Review_Transfer_S3_Files_Dialog_Success_Msg': '已成功複製所選文件',
  'Recruiter_Review_Transfer_S3_Files_Dialog_Failure_Msg': '複製所選文件失敗',
  'Question_Number': '問題編號',
  'Filename': '文檔名稱',
  'Filesize': '文件大小',
  "Candidate_Interview_Finish_Message": "感謝你完成 {interview_name} ({interview_type})。",
  "Candidate_Continue_Message": "請繼續進行 {interview_name} ({interview_type})。",
  "interview": "面試",
  "TextField_Required": "* 必須填寫",
  'Happy': '高興',
  'Sad': '悲傷',
  'Neutral': '中性',
  'Fear': '擔憂',
  'Surprise': '驚訝',
  'Grimace': '厭惡',
  'Pouty': '不悅',
  
  
  "Recruiter_Interview_Monitor_Title": "正在進行的面試中的職位",
  "Recruiter_Interview_Monitor_Hintbox_Message": "此頁面顯示在面試截止日期之前有求職者處於\"待定邀請\"和\"已邀請待面試\"的職位。",
  "Recruiter_Interview_Monitor_TableColumn_RecruiterName": "招聘人員姓名",
  "Recruiter_Interview_Monitor_TableColumn_RecruiterEmail": "招聘人員電郵",
  "Recruiter_Interview_Monitor_TableColumn_JobTitle": "職位Id",
  "Recruiter_Interview_Monitor_TableColumn_InterviewDeadline": "面試截止日期",
  "Recruiter_Interview_Monitor_TableColumn_Total_Num_Of_Candidates": "求職者總數",
  "Recruiter_Interview_Monitor_TableColumn_Completion_Rate": "完成率",
  "Recruiter_Interview_Monitor_TableColumn_Num_Of_Invited_Candidates": "獲邀求職者人數",
  "Recruiter_Interview_Monitor_TableColumn_Num_Of_Pending_Invitations": "待邀請的求職者人數",
  "Recruiter_Interview_Monitor_Job": "{count} 職位",
  
  
  
  "TC_Header": "條款及細則",
  "TC_Top_Section": "Neufast Limited（\"公司\"）提供對 neufast.com 網站（\"網站\"）上內容的訪問和使用，並受以下條款和條件的約束。 你同意使用本網站構成你接受這些條款和條件，這些條款和條件自你首次使用本網站之日起生效。 本公司保留隨時通過在線發布更改來更改這些條款和條件的權利，建議你定期訪問此頁面以查看條款和條件，因為它們適用於你。 在發布更改後，你繼續使用本網站即構成接受本協議（由發布的更改修改）。 本文中的術語\"你\"，\"用戶\"和\"用戶\"是指出於任何原因或目的在任何時間訪問和/或使用本網站的所有個人和/或實體。",
  "TC_Content_1": "網站使用",
  "TC_Content_1.1": "你同意僅出於合法目的使用本網站，並且以不侵犯任何第三方的權利或限製或禁止任何第三方使用和享用本網站的方式，包括但不限於違法或 可能騷擾或給任何人造成困擾或不便，以及淫穢或令人反感的內容的傳輸或網站內正常對話流程的中斷。",
  "TC_Content_1.2": "你不得使用本網站侵犯他人的知識產權。",
  "TC_Content_1.3": "你不得使用本網站傳輸，發布，上傳，張貼，散佈或存儲任何威脅，騷擾，誹謗，非法，有害，淫穢，誹謗或其他令人反感或令人反感的材料。",
  "TC_Content_1.4": "你不得使用任何軟件，工具或程序或以其他方法干擾網站服務器的正常運行。",
  "TC_Content_1.5": "你不得有意或有意地使網站系統超載。",
  "TC_Content_1.6": "你不得將任何計算機病毒或任何破壞性程序傳播到網站及其成員。",
  "TC_Content_1.7_Title": "特定用戶-求職者",
  "TC_Content_1.7_a": "在網站上尋找工作的用戶（\"求職者\"）同意保留其登錄名和密碼，並且不會透露給其他任何人。 求職者應全權負責維護登錄名和密碼的機密性以及任何（授權或未經授權的）登錄名和密碼的使用。 求職者同意在未經授權的情況下立即將其通知公司。",
  "TC_Content_1.7_b": "求職者不得將任何不完整，虛假或不准確的簡歷資料發佈到網站或公司。",
  "TC_Content_1.7_c": "求職者向網站提交的所有資料必須合法，體面，非歧視和真實。 求職者應對提交給網站或公司的內容和材料負全部責任。",
  "TC_Content_1.7_d": "求職者不得以任何理由對任何就業機會作出回應，除非是為了申請廣告招聘的職位。",
  "TC_Content_1.7_e": "求職者提交的簡歷旨在為在尋找僱員時向用戶或廣告商（\"僱主\"）提供相關資料。",
  "TC_Content_1.7_f": "求職者提交的個人數據將用於協助求職者與網站或公司的僱主和招聘人員一起尋找合適的工作。 求職者在申請職位空缺或將其個人簡歷存儲在公司的簡歷數據庫中時，確實會將其個人數據披露給網站和公司的僱主和/或招聘人員。 對求職者的認可。",
  "TC_Content_1.7_g": "求職者提交給網站或公司的任何資料均應遵守公司的隱私政策聲明。",
  "TC_Content_1.7_h": "求職者接受向僱主提供的個人數據或資料完全由自己承擔風險。 如果任何僱主將求職者的個人數據用於除尋找僱員以外的任何用途，則公司在任何情況下均不承擔任何責任。",
  "TC_Content_1.7_i": "求職者可將其簡歷直接發送給在網站上或通過網站登廣告的任何僱主。或者，求職者可以通過網站將其簡歷發送給公司，以回復任何招聘廣告。在這種情況下，在遵守法律要求的情況下，求職者的履歷將在網站上保留預定的時間，即使在此停用了服務，除非求職者要求刪除或刪除它。此後，它將被存儲在公司的數據庫中，求職者自負風險。",
  "TC_Content_1.7_j": "求職者可以將自己的簡歷存儲在公司的數據庫中，但不允許僱主搜索。在這種情況下，求職者可以使用自己的簡歷在線申請工作，但是僱主和招聘者將無法通過公司的數據庫訪問它。",
  "TC_Content_1.7_k": "如果求職者加入\"求職者匹配\"功能並同意將其簡歷透露給潛在僱主，那麼所有在公司刊登廣告或訂閱公司服務的僱主和招聘者都可以訪問他/她的 她的簡歷。公司將不會向無法確定身份的僱主和招聘者透露有關求職者的信息。求職者提供的個人數據將嚴格按照公司的《個人信息收集聲明》和《隱私政策聲明》使用。",
  "TC_Content_1.7_l": "求職者提供的個人數據和簡歷是旨在為僱主提供相關資料，以尋找僱員。",
  "TC_Content_1.7_m": "求職者提交的個人數據將用於協助求職者與網站或公司的僱主和招聘人員一起尋找合適的工作。求職者在申請職位空缺或將其個人簡歷存儲在公司的簡歷數據庫中時，向網站和公司的招聘人員披露其個人數據，所有這些均由求職者確認 。",
  "TC_Content_1.7_n": "儘管公司將盡最大努力僅向公司的僱主，招聘經理，獵頭，人力資源專業人員和內部授權人員授予對數據庫的訪問權限，但公司不保證也不保證其他方不會在沒有授權的情況下公司的同意，獲得對數據庫的訪問。任何求職者都可以隨時禁止僱主查看自己的簡歷。但是，求職者承認，僱主和其他本來可以訪問數據庫的各方，可能已經在自己的​​文件或數據庫中保留了求職者簡歷的副本。在這些情況下，公司對簡歷的保留，使用或隱私，或將這些簡歷保存在數據庫中時，任何此類人士對簡歷的使用或隱私，本公司概不負責。",
  "TC_Content_1.7_o": "如果求職者加入\"求職者匹配\"功能並同意將其簡歷透露給潛在僱主，那麼所有在公司刊登廣告或訂閱公司服務的僱主和招聘者都可以訪問他/她的 她的簡歷。公司將不會向無法確定身份的僱主和招聘者透露有關求職者的信息。求職者提供的個人數據將嚴格按照公司的《個人信息收集聲明》和《隱私政策聲明》使用。",
  "TC_Content_1.7_p": "求職者可以將網站上的工作資料發送給他們認識的人，這些人在尋求工作時需要這些資料，但不得將這些資料用於其他目的，並且不得濫用此功能。",
  "TC_Content_1.7_q": "根據《個人資料（私隱）條例》，求職者有權訪問他/她在公司保存的個人資料（須事先獲得身份證明），他/她可隨時編輯或修改此類個人資料。任何訪問或更正的請求都可以通過將書面請求發送給公司來提出。有關詳細信息，請參閱個人信息收集聲明和隱私政策聲明。進一步地或替代地，求職者（取決於身份的事先確認）可以隨時在網站上直接編輯或修改他/她的個人數據。",
  "TC_Content_1.8": "具體用途-僱主",
  "TC_Content_1.8_a": "在向公司支付服務費和/或根據公司不時規定的其他條款和條件（如果有）後，僱主將有權使用該網站在特定時期內刊登廣告。僱主應對其廣告中包含的內容和材料承擔全部責任。本公司保留根據需要編輯任何廣告的權利。",
  "TC_Content_1.8_b": "根據公司不時規定的有關求職者資料訪問的條件或要求，僱主有權訪問公司維護的求職者數據庫，但同意所有資料僅用於未經相關求職者事先同意，不得將尋找潛在僱員的目的和此類資料透露給任何其他方。",
  "TC_Content_1.9": "具體用途-應屆畢業生",
  "TC_Content_1.9_a": "用戶將對發佈到網站的\"開放論壇\"的任何演講，消息和附件（如果適用）及其後果承擔任何責任。",
  "TC_Content_1.9_b": "用戶發佈到網站的\"開放論壇\"上的文章，評論和/或內容的主題必須具有討論，研究或表達自己觀點的性質。嚴禁誹謗，粗俗和淫穢的語言。任何文章的內容本質上都不可以是向他人索取商品和服務，廣告或誹謗。本公司保留編輯或刪除違反這些條款的\"開放論壇\"中任何材料和內容的權利，對於由此造成的任何損失或損害，本公司概不負責。",
  "TC_Content_2_Title": "未成年人",
  "TC_Content_2": "如果你未滿18歲，或者你被視為未成年人或無法承擔法律責任，則不允許你使用該網站。如果你希望查看和訪問本網站，則應就這些條款和條件的含義和後果向父母或監護人尋求建議。公司假定該網站的每個用戶都已達到法定年齡。公司沒有義務核實你的年齡，但是如果發現本網站的任何用戶都不合法，則本公司保留針對此類用戶或其父母或監護人的權利。 ，包括終止訪問網站的權利。",
  "TC_Content_3": "保證和責任",
  "TC_Content_3.1": "網站及其中提供的資料均按\"原樣\"提供，沒有法律允許的最大範圍的明示或暗示保證。",
  "TC_Content_3.2": "無論是針對任何特定目的的產品的適用性或服務的明示或免責聲明，包括對所有產品的適用性或非特定目的的免責聲明。",
  "TC_Content_3.3": "本公司對本網站上的資料，內容或資料的準確性，可靠性，完整性和及時性不做任何保證。",
  "TC_Content_3.4": "對於網站內容中的任何錯誤或遺漏，或刪除，傳送錯誤或未能存儲任何用戶通訊或個性化設定，本公司概不負責。",
  "TC_Content_3.5": "本公司不保證本網站在任何時間都不會出錯，該網站及其服務器在任何時間都不會電腦病毒或其他有害機制，不會糾正任何缺陷， 或網站的運行將不間斷，及時或安全。 如果你對網站，商品或材料的使用導致需要維修或更換設備或數據，則本公司不承擔這些費用。",
  "TC_Content_3.6": "所有用戶使用公司的網站和通過它訪問的任何其他網站，後果自負。 你應對自己的通信負責，並對其發布的後果負責。 本公司不代表或保證其他用戶發布的任何通信的真實性，準確性或可靠性，也不認可用戶表達的任何觀點。 用戶對其他用戶發布的材料的任何依賴將自擔風險。 本公司保留權利在任何時候違反本協議或違反法律驅逐任何用戶並阻止其進一步訪問該網站的權利，並且保留從其唯一的網站上刪除任何消息或材料的權利。 公司認為不可接受，有辱人格，違法或破壞性行為。",
  "TC_Content_3.7": "該網站可能包含指向第三方網站的鏈接。 提供這些資料僅是為了給用戶提供方便，而不是以任何方式由公司認可此類第三方網站上的內容。 如果任何用戶訪問任何鏈接的第三方網站，則完全由自己承擔風險。 本公司對鏈接到其網站的任何第三方網站的內容概不負責，也不對此類第三方網站上內容的準確性或準確性作任何陳述或保證。 此外，鏈接到該網站的其他網站的用戶可能會查看任何用戶在該網站上發布的任何材料或詳細信息，並且本公司對鏈接的第三方對任何用戶或第三方的任何不當使用不承擔任何責任。 網站上發布的任何數據或材料。",
  "TC_Content_3.8": "公司或網站上提及的任何第三方在任何情況下均不對任何損害或傷害（包括但不限於偶然的和間接的損害，利潤損失或任何損失）承擔責任（在法律允許的範圍內）。由於數據丟失或業務中斷而造成的損失）由於使用或無法使用網站，商品和材料或任何性能故障，錯誤，遺漏，中斷，刪除，缺陷，操作或傳輸延遲，計算機病毒，通信線路故障，在線通信被攔截，軟件或硬件問題（包括但不限於數據丟失或兼容性問題），網站的失竊，破壞或變更，無論是由於違反合同，違法行為，疏忽或任何由於使用本網站或任何上載，下載或發布數據，文本，圖像或內容而直接或間接導致的任何其他原因網站上的其他材料或信息，以及是否告知本公司可能造成此類損害。",
  "TC_Content_3.9_i": "本公司也不代表或保證，對於與你訪問和使用本網站有關的以下任何情況，本公司也不承擔任何責任。",
  "TC_Content_3.9_ii": "•無病毒、惡意軟件或其他有害成分",
  "TC_Content_3.9_iii": "•無科技缺陷",
  "TC_Content_3.9_iv": "•在香港以及其他任何地區和司法管轄區的可用性和訪問權限",
  "TC_Content_3.9_v": "你有責任在使用本網站，其內容和工具時遵守你所在轄區的任何適用法律。",
  "TC_Content_4_Title": "賠償",
  "TC_Content_4": "所有用戶均同意賠償因使用本網站或違反本條款而引起或引起的任何索賠，訴訟，要求，損失或損害，並使本公司，其管理人員，董事，僱員和代理商免受損害。 本協議。 公司應將有關此類索賠，訴訟或訴訟的及時通知相關用戶。",
  "TC_Content_5_Title": "與廣告商交易",
  "TC_Content_5": "你與在網站上或通過網站找到的廣告商的往來信件或業務往來，或參與促銷活動，包括相關商品或服務的付款和交付，以及與此類交易有關的任何其他條款，條件，保證或陳述，僅在 你和廣告客戶。 你同意，對於因此類交易或網站上廣告商的存在而引起的任何形式的任何損失或損害，公司概不負責。",
  "TC_Content_6": "與其他用戶交易",
  "TC_Content_6.1": "儘管公司盡最大努力提供公正的求職和招聘服務，並且代表了僱主和僱員之間交換資料的媒介，但公司不會參與求職者與僱主之間的交易，並且公司將 對招聘服務的質量，安全性和合法性不承擔任何責任。",
  "TC_Content_6.2": "本公司不保證或擔保求職者提供的資料和/或簡歷以及僱主提供的招聘廣告的準確性。",
  "TC_Content_6.3": "公司對僱主是否有能力支付相關工資或求職者勝任這項工作概不負責。",
  "TC_Content_6.4": "如果僱主和員工發生任何爭執，他們應該自行解決，本公司概不負責。",
  "TC_Content_7": "終止",
  "TC_Content_7.1": "如果用戶提供的任何資料不准確，違反法律或包含不正當因素，公司將立即取消用戶的帳戶，恕不另行通知，並且公司保留採取公司認為適當，可取或必要的行動的權利，包括但不限於： 不限於對此類用戶採取法律行動。",
  "TC_Content_7.2": "公司保留在任何時候立即終止或暫停用戶帳戶或用戶對網站或公司提供的服務的訪問權，恕不另行通知，如果公司認為用戶違反了本協議中包含的任何條款 同意或採取公司認為適當，可取或必要的進一步行動。",
  "TC_Content_7.3": "公司保留決定用戶和/或求職者和/或僱主是否違反本協議任何條款的最終權利和絕對酌處權。",
  "TC_Content_8": "知識產權",
  "TC_Content_8.1": "網站中包含的所有資料，圖形，文本，圖像內容和設計均為公司的財產，並受版權和/或其他知識產權的保護。 在訪問該網站時，用戶同意僅可以出於個人非商業目的下載內容。",
  "TC_Content_8.2": "未經事先書面許可，用戶不得以任何其他方式複制，抄襲，傳播，散佈，出售，分發，發布，廣播，散佈，存儲（以任何媒介），以任何其他方式修改或更改本網站下的內容 該公司的。",
  "TC_Content_9": "一般",
  "TC_Content_9.1": "如果由於任何原因使這些條款和條件中的任何一項或多項或其在任何情況下的應用被視為無效，非法或不可執行，則該條款或條件在任何其他方面的有效性，合法性和可執行性以及其餘 條款和條件不得以任何方式受到損害。",
  "TC_Content_9.2": "我方未能或延遲行使本條款和條件下的任何權利或救濟不得解釋為或被視為棄權，我方單獨或部分行使任何權利或救濟也不妨礙我方進一步行使該權利或救濟。",
  "TC_Content_9.3": "我們可以隨時將這些條款和條件中包含的任何或全部權利和義務轉讓給任何一方。",
  "TC_Content_9.4": "如果這些通用條款和條件與規則和/或本網站上出現的與特定材料有關的特定使用條款之間有任何衝突，則應以後者為準。",
  "TC_Content_9.5": "本條款和條件以及因你使用本公司網站而產生或附帶的任何爭議或事項應受香港特別行政區法律管轄，你和本公司均同意接受香港特別行政區法院的管轄。",
  
  "PPS_Header": "私隱條例說明",
  "PPS_Top_Section": "Neufast Limited（\"公司\"）尊重個人數據，並承諾遵守數據保護原則和《個人數據（隱私）條例》（\"條例\"）的所有相關規定。 數據由公司的網站服務Neucareers.com（以下簡稱\"網站\"）收集。 公司的PPS是有關數據用戶與其處理的個人數據有關的隱私政策和慣例的一般性聲明。",
  "PPS_Content_1_i": "政策聲明",
  "PPS_Content_1_ii": "公司在保護向公司提供個人資訊的個人隱私利益方面的總體承諾。",
  "PPS_Content_1_iii": "我們尊重個人資料私隱，並遵守個人資料私隱專員（PCPD）不時頒佈的個人資料（私隱）條例（PDPO）及相關實務守則。",
  "PPS_Content_2_i": "慣例聲明",
  "PPS_Content_2_ii": "在使用本網站的過程中，用戶可能會披露或被要求提供個人資料和/或數據。 為了受益於本網站並享受本網站提供的各種服務，用戶可能有必要向公司提供其個人信息和/或數據。 儘管用戶沒有義務按照網站上的要求提供信息和/或數據，但如果用戶未能提供服務，公司將無法在網站上提供某些服務。",
  "PPS_Content_2_iii": "用戶在此同意，用戶提供給公司的任何資料都是自願的，並且是準確，真實，最新和完整的。 如果不是這種情況，或者公司有合理的理由懷疑，則公司有權取消和/或拒絕向用戶提供服務。",
  "PPS_Content_2_iv": "公司收集和使用本網站上的資料和數據的目的包括但不限於以下目的：",
  "PPS_Content_2_v": "•提供給用戶的服務的日常運行；",
  "PPS_Content_2_vi": "•協助求職者在僱主找到適當的工作，並協助僱主評核求職者是否適合擔任各種工作和行業的空缺職位；",
  "PPS_Content_2_vii": "•與附屬公司分享，以便他們向用戶提供推廣和行銷資料；",
  "PPS_Content_2_vii": "• to share with Affiliates so that they may provide Users with promotion and marketing materials;",
  "PPS_Content_2_ix": "•處理和跟進用戶的詢問、請求和投訴；",
  "PPS_Content_2_x": "•就與用戶使用本網站有關的行政通知和通訊聯繫用戶，並回應用戶的詢問或要求；",
  "PPS_Content_2_xi": "•協助公司發展以用於將來的營銷和促銷目的或其他內部目的；",
  "PPS_Content_2_xii": "•驗證已在網站上張貼廣告，材料，表示，消息，視圖或評論或其他資料（統稱為\"資料\"）的用戶的身份；",
  "PPS_Content_2_xiii": "•確定查看過網站上發布的資料的用戶；",
  "PPS_Content_2_xiv": "•通過註冊公司和/或其關聯公司和/或合作夥伴公司舉辦的特別活動和促銷活動，使用戶能夠享受作為網站成員的利益；",
  "PPS_Content_2_xv": "•通過接收和使用行銷文宣資料，確定作為網站成員享受其利益的用戶；",
  "PPS_Content_2_xvi": "•協助本公司和/或附屬公司將用戶的個人資料用於與本公司提供的服務以及本公司和/或其附屬公司的行銷服務和/或特別活動有關的目的；",
  "PPS_Content_2_xvii": "•獲取有關用戶的統計資料以分析網站的使用情況，以幫助其進一步開發以供內部使用； 和",
  "PPS_Content_2_xviii": "•除上述目的外，與附屬公司提供和/或行銷其產品和/或服務有關的目的，視公司認為合適。",
  "PPS_Content_2_xix": "•幫助改善網站為所述相關目的提供的服務。",
  "PPS_Content_2_xx": "如果用戶未滿13歲，則公司強烈建議他/她事先徵求對此有父母責任的人的同意。父母或監護人，他們可以聯繫負責的客戶支持主管，其聯繫方式在\"查詢\"部分列出，以將用戶註冊為網站成員。",
  "PPS_Content_2_xxi": "本公司力求只收集與上述目的相關的必要且充分但不過分的個人資料。",
  "PPS_Content_2_xxii": "如果公司要求出於上述目的以外的目的使用你的個人數據，我們將徵求你的同意。如果你未成年人，則應由你的父母或監護人給予規定的同意。",
  "PPS_Content_3_i": "安全",
  "PPS_Content_3_ii": "用戶個人資料和數據的安全性對於Neufast Group至關重要。我們將始終努力確保保護用戶的個人資料和數據免遭未經授權的訪問。我們已採取適當的電子和管理措施，以保護，保護和保護用戶的個人信息和數據。",
  "PPS_Content_3_iii": "用戶提供的所有個人信息和數據只能由公司或其授權的第三方的授權人員訪問，並且應指示這些人員在訪問此類個人資料和數據時遵守本隱私聲明的條款。用戶可以放心，他們的個人信息和數據將僅保留達到實現收集目的所必需的時間。註冊用戶應通過保密對其進行保密，以保護其唯一的用戶名和密碼，並且切勿與任何人共享這些詳細信息。",
  "PPS_Content_3_iv": "公司使用第三方服務提供商來促進網站上的電子支付交易。",
  "PPS_Content_3_v": "本公司遵循公認的行業標準，以保護用戶在傳輸過程中以及我們收到後向網站提交的個人資料和數據。但是，互聯網上的傳輸方法或電子存儲方法都不是100％安全的。因此，儘管我們努力保護用戶的個人信息和數據免遭未經授權的訪問，但公司不能保證其絕對安全。",
  "PPS_Content_4_i": "保存用戶的個人資料和簡歷",
  "PPS_Content_4_ii": "為了向僱主和廣告商提供有關用戶的最相關資料（並取決於用戶在網站上的個人資料隱私設定），該網站還將掃描與該用戶的個人資料相關的主要簡歷。內容可以在廣告商數據庫中顯示給廣告商。如果你不希望將簡歷中的內容顯示給廣告商，請不要附加簡歷。",
  "PPS_Content_5_i": "保留個人資料",
  "PPS_Content_5_ii": "一旦Neufast Limited 獲得用戶的個人資訊和/或數據，將在公司系統中安全保存一段時間，以實現\"實踐聲明\"一節中規定的收集數據的目的。注册後，用戶可通過聯系公司的數據隱私專員（其聯繫方式見\"査詢\"部分）終止其網站會員資格。本公司可保留用戶的個人資訊，即使用戶已關閉其帳戶，但前提是保留是為了遵守我們的法律義務、滿足監管要求、解决用戶之間的糾紛、防止欺詐和濫用、或執行本隱私權聲明和條款和條件而合理需要的。",
  "PPS_Content_6_i": "隱私聲明的變更",
  "PPS_Content_6_ii": "公司保留在公司認為必要時隨時更新，修訂，修改或修改本隱私聲明的權利，因此強烈建議用戶經常閱讀本隱私聲明。如果公司決定更新，修訂，修改或修改本隱私聲明，則公司會將這些更改發佈到本公司認為適當的網站和/或其他地方，以便用戶知道公司收集的信息，我們如何使用以及在什麼情況下（如有），公司會予以披露。",
  "PPS_Content_6_iii": "如果公司對本隱私聲明進行了重大更改，我們將通過電子郵件或網站首頁上的通知的方式在此網頁上通知用戶。本隱私聲明的此類更改應自公司在網站上發布之日起適用。用戶繼續使用本網站和本網站上的服務即構成接受本隱私聲明的更改。",
  "PPS_Content_7_i": "Cookies的使用",
  "PPS_Content_7_ii": "Cookies是網站在網站上傳輸到個人硬盤上以進行記錄保存的資料項。 Cookies可以通過保存密碼，購買交易和使用偏好來簡化網上沖浪。 Cookies的使用是行業標準，你可以在大多數主要網站上找到Cookies。",
  "PPS_Content_7_iii": "Cookie本身不包含任何個人識別資料，儘管它可以使公司將用戶對服務的使用與用戶先前已提交的個人識別資料（如果有）相關聯。",
  "PPS_Content_7_iv": "你可能偶爾會從我們的廣告客戶那裡獲得Cookie。這些Cookie是從第三方計算機發送的，並且受此類第三方政策的約束。該網站上已安裝了Google Analytics（分析），以進一步了解訪問者的行為。如果你希望退出分析性廣告功能，則可以訪問相關的Google服務頁面。",
  "PPS_Content_7_v": "大多數瀏覽器最初都設定為接受Cookie。如果你不希望透露以上資料，則應將其設定為拒絕cookie。但是，如果這樣做，站點的大多數區域可能無法正常運行。",
  "PPS_Content_8_i": "外包安排",
  "PPS_Content_8_ii": "該公司一直在使用其內部資源來開發和維護其IT系統。當公司聘請第三方供應商提供與其IT系統相關的某些服務時，在通常情況下，供應商將無權訪問IT系統中存儲的個人數據。",
  "PPS_Content_8_iii": "在此類供應商具有此類訪問權限的特殊情況下，公司將採取合理措施以確保：（i）此類供應商在合同上有義務對此類個人數據保密，並採取適當措施防止任何未經授權的訪問，使用，丟失，保留，修改，轉讓或其他方式。",
  "PPS_Content_9_i": "查詢，數據訪問請求和數據更正",
  "PPS_Content_9_ii": "根據PDPO，任何人都有權進行查詢，請求訪問並更正我們持有的其個人數據。根據POPO的條款，我們有權就處理任何數據訪問請求收取合理的費用。",
  "PPS_Content_9_iii": "如果你想查詢，訪問或更正我們持有的個人數據，請發送請求至：",
  "PPS_Content_9_iv": "數據隱私專員",
  "PPS_Content_9_v": "訊維有限公司",
  "PPS_Content_9_vi": "香港沙田香港科技園西區19號19W10樓1032室",
  "PPS_Content_9_vii": "電話：(+852)59876904",
  "PPS_Content_9_viii": "郵箱：customer-service@neufast.com",
  "PPS_Content_10_i": "無權利限制",
  "PPS_Content_10_ii": "本聲明中的任何內容均不會限制根據《個人數據（隱私）條例》（PDPO）對數據主體的任何權利",
  
  "Africa/Cote_d'Ivoire": "非洲/科特迪瓦",
  "Africa/Ghana": "非洲/加納",
  "Africa/Addis_Ethiopia": "非洲/亞的斯埃塞俄比亞",
  "Africa/Algeria": "非洲/阿爾及利亞",
  "Africa/Eritrea": "非洲/厄立特里亞",
  "Africa/Mali": "非洲/馬里",
  "Africa/Central_African_Republic": "非洲/中非共和國",
  "Africa/Gambia": "非洲/岡比亞",
  "Africa/Guinea-Bissau": "非洲/幾內亞比紹",
  "Africa/Malawi": "非洲/馬拉維",
  "Africa/Republic_of_Congo": "非洲/剛果共和國",
  "Africa/Democratic Republic of Congo/West Time": "非洲/剛果民主共和國/西部時間",
  "Africa/Democratic Republic of Congo/Eastern Time": "非洲/剛果民主共和國/東部時間",
  "Africa/Burundi": "非洲/布隆迪",
  "Africa/Egypt": "非洲/埃及",
  "Africa/Morocco": "非洲/摩洛哥",
  "Atlantic/Canary_Islands": "大西洋/加那利群島",
  "Africa/Guinea": "非洲/幾內亞",
  "Africa/Senegal": "非洲/塞內加爾",
  "Africa/United_Republic_of_Tanzania": "非洲/坦桑尼亞聯合共和國",
  "Africa/Djibouti": "非洲/吉布提",
  "Africa/Cameroon": "非洲/喀麥隆",
  "Africa/Western_Sahara": "非洲/西撒哈拉",
  "Africa/Sierra_Leone": "非洲/塞拉利昂",
  "Africa/Botswana": "非洲/博茨瓦納",
  "Africa/Zimbabwe": "非洲/津巴布韋",
  "Africa/South_Africa": "非洲/南非",
  "Africa/South_Sudan": "非洲/南蘇丹",
  "Africa/Uganda": "非洲/烏干達",
  "Africa/Sudan": "非洲/蘇丹",
  "Africa/Rwanda": "非洲/盧旺達",
  "Africa/Nigeria": "非洲/尼日利亞",
  "Africa/Gabon": "非洲/加蓬",
  "Africa/Togo": "非洲/多哥",
  "Africa/Angola": "非洲/安哥拉",
  "Africa/Zambia": "非洲/贊比亞",
  "Africa/Equatorial_Guinea": "非洲/赤道幾內亞",
  "Africa/Mozambique": "非洲/莫桑比克",
  "Africa/Lesotho": "非洲/萊索托",
  "Africa/Swaziland": "非洲/斯威士蘭",
  "Africa/Somalia": "非洲/索馬里",
  "Africa/Liberia": "非洲/利比里亞",
  "Africa/Kenya": "非洲/肯尼亞",
  "Africa/Chad": "非洲/乍得",
  "Africa/Niger": "非洲/尼日爾",
  "Africa/Mauritania": "非洲/毛里塔尼亞",
  "Africa/Burkina_Faso": "非洲/布基納法索",
  "Africa/Benin": "非洲/貝寧",
  "Africa/Sao_Tome_and_Principe": "非洲/聖多美和普林西比",
  "Africa/Libya": "非洲/利比亞",
  "Africa/Tunisia": "非洲/突尼斯",
  "Africa/Namibia": "非洲/納米比亞",
  "America/Hawaii-Aleutian Standard Time": "美洲/夏威夷-阿留申標準時間",
  "America/Hawaii-Aleutian Daylight Time": "美洲/夏威夷-阿留申夏令時間",
  "America/Alaska Standard Time": "美洲/阿拉斯加標準時間",
  "America/Alaska Daylight Time": "美洲/阿拉斯加夏令時間",
  "America/Mountain Standard Time": "美洲/山地標準時間",
  "America/Mountain Daylight Time": "美洲/山夏令時間",
  "America/Central Standard Time": "美洲/中部標準時間",
  "America/Central Daylight Time": "美洲/中部夏令時間",
  "America/Pacific Standard Time": "美洲/太平洋標準時間",
  "America/Pacific Daylight Time": "美洲/太平洋夏令時間",
  "America/Eastern Standard Time": "美洲/東部標準時間",
  "America/Eastern Daylight Time": "美洲/東部夏令時間",
  "America/Newfoundland Standard Time": "美洲/紐芬蘭標準時間",
  "America/Newfoundland Daylight Time": "美洲/紐芬蘭夏令時間",
  "America/Atlantic Standard Time": "美洲/大西洋標準時間",
  "America/Atlantic Daylight Time": "美洲/大西洋夏令時間",
  "America/Brazil/Acre Standard Time": "美洲/巴西/英畝標準時間",
  "America/Brazil/Amazon Standard Time": "美洲/巴西/亞馬遜標準時間",
  "America/Brazil/Brasilia Standard Time": "美洲/巴西/巴西利亞標準時間",
  "America/Brazil/Fernando de Noronha Standard Time": "美洲/巴西/費爾南多·迪諾羅尼亞標準時間",
  "America/West Greenland Time": "美洲/西格陵蘭時間",
  "America/East Greenland Time": "美洲/東部格陵蘭時間",
  "America/Anguilla": "美洲/安圭拉",
  "America/Antigua_and_Barbuda": "美洲/安提瓜和巴布達",
  "America/Argentina": "美洲/阿根廷",
  "America/Aruba": "美洲/阿魯巴",
  "America/Paraguay": "美洲/巴拉圭",
  "America/Barbados": "美洲/巴巴多斯",
  "America/Belize": "美洲/伯利茲",
  "America/Colombia": "美洲/哥倫比亞",
  "America/Bolivarian_Republic_of_Venezuela": "美洲/委內瑞拉",
  "America/French_Guiana": "美洲/法屬圭亞那",
  "America/Cayman_Islands": "美洲/開曼群島",
  "America/Costa_Rica": "美洲/哥斯達黎加",
  "America/Curacao": "美洲/庫拉索島",
  "America/Dominica": "美洲/多米尼加",
  "America/El_Salvador": "美洲/薩爾瓦多",
  "America/Turks_and_Caicos_Islands": "美洲/特克斯和凱科斯群島",
  "America/Grenada": "美洲/格林納達",
  "America/Guadeloupe": "美洲/瓜德羅普島",
  "America/Guatemala": "美洲/危地馬拉",
  "America/Ecuador/Galapagos Time": "美洲/厄瓜多爾/加拉帕戈斯時間",
  "America/Ecuador Time": "美洲/厄瓜多爾時間",
  "America/Guyana": "美洲/圭亞那",
  "America/Cuba": "美洲/古巴",
  "America/Jamaica": "美洲/牙買加",
  "America/Sint_Eustatius_and_Saba_Bonaire": "美洲/荷蘭加勒比區",
  "America/Bolivia": "美洲/玻利維亞",
  "America/Peru": "美洲/秘魯",
  "America/Sint_Maarten": "美洲/聖馬丁",
  "America/Nicaragua": "美洲/尼加拉瓜",
  "America/Saint_Martin": "美洲/聖馬丁",
  "America/Martinique": "美洲/馬提尼克島",
  "America/Saint_Pierre_and_Miquelon": "美洲/聖皮埃爾和密克隆群島",
  "America/Uruguay": "美洲/烏拉圭",
  "America/Montserrat": "美洲/蒙特塞拉特",
  "America/Bahamas": "美洲/巴哈馬",
  "America/Panama": "美洲/巴拿馬",
  "America/Suriname": "美洲/蘇里南",
  "America/Haiti": "美洲/海地",
  "America/Trinidad_and_Tobago": "美洲/特立尼達和多巴哥",
  "America/Puerto_Rico": "美洲/波多黎各",
  "America/Easter Island Standard Time": "美洲/復活節島標準時間",
  "America/Chile Standard Time": "美洲/智利標準時間",
  "America/Chile Summer Time": "美洲/智利夏令時間",
  "America/Dominican_Republic": "美洲/多米尼加共和國",
  "America/St_Barthelemy": "美洲/聖巴托洛繆島",
  "America/St_Kitts_and_Nevis": "美洲/聖基茨和尼維斯",
  "America/St_Lucia": "美洲/聖盧西亞",
  "America/US_Virgin_Islands": "美洲/美屬維爾京群島",
  "America/St_Vincent_and_Grenadines": "美洲/聖文森特和格林納丁斯",
  "America/Honduras": "美洲/洪都拉斯",
  "America/British_Virgin_Islands": "美洲/英屬維爾京群島",
  "Asia/Yemen": "亞洲/也門",
  "Asia/Kazakhstan/East Time": "亞洲/哈薩克斯坦/東部時間",
  "Asia/Kazakhstan/West Time": "亞洲/哈薩克斯坦/西部時間",
  "Asia/Jordan": "亞洲/約旦",
  "Asia/Turkmenistan": "亞洲/土庫曼斯坦",
  "Asia/Iraq": "亞洲/伊拉克",
  "Asia/Bahrain": "亞洲/巴林",
  "Asia/Azerbaijan": "亞洲/阿塞拜疆",
  "Asia/Thailand": "亞洲/泰國",
  "Asia/Lebanon": "亞洲/黎巴嫩",
  "Asia/Kyrgyzstan": "亞洲/吉爾吉斯斯坦",
  "Asia/Brunei_Darussalam": "亞洲/汶萊",
  "Asia/Mongolia/Choibalsan Time": "亞洲/蒙古/喬瓦山時間",
  "Asia/Mongolia/Ulaanbaatar Time": "亞洲/蒙古/烏蘭巴托時間",
  "Asia/Mongolia/Hovd Time": "亞洲/蒙古/科布多城時間",
  "Asia/China Standard Time": "亞洲/中國標準時間",
  "Asia/Sri_Lanka": "亞洲/斯里蘭卡",
  "Asia/Syrian_Arab_Republic": "亞洲/敘利亞",
  "Asia/Bangladesh": "亞洲/孟加拉國",
  "Asia/Timor-Leste": "亞洲/東帝汶",
  "Asia/UAE": "亞洲/阿聯酋",
  "Asia/Tajikistan": "亞洲/塔吉克斯坦",
  "Asia/Cyprus": "亞洲/塞浦路斯",
  "Asia/Palestine": "亞洲/巴勒斯坦",
  "Asia/Vietnam": "亞洲/越南",
  "Asia/Hong_Kong": "亞洲/香港",
  "Asia/Russia/Irkutsk_Time": "亞洲/俄羅斯/伊爾庫茨克時間",
  "Asia/Russia/Kamchatka_Time": "亞洲/俄羅斯/堪察加時間",
  "Asia/Russia/Krasnoyarsk_Time": "亞洲/俄羅斯/克拉斯諾亞爾斯克時間",
  "Asia/Russia/Magadan_Time": "亞洲/俄羅斯/馬達加丹時間",
  "Asia/Russia/Omsk_Time": "亞洲/俄羅斯/鄂木斯克時間",
  "Asia/Russia/Vladivostok_Time": "亞洲/俄羅斯/符拉迪沃斯托克時間",
  "Asia/Russia/Yakutsk_Time": "亞洲/俄羅斯/雅庫茨克時間",
  "Asia/Russia/Yekaterinburg_Time": "亞洲/俄羅斯/葉卡捷琳堡時間",
  "Asia/Turkey": "亞洲/土耳其",
  "Asia/Indonesian/Western Time": "亞洲/印尼/西方時間",
  "Asia/Indonesian/Central Time": "亞洲/印尼/中部時間",
  "Asia/Indonesian/Eastern Time": "亞洲/印尼/東部時間",
  "Asia/Israel": "亞洲/以色列",
  "Asia/Afghanistan": "亞洲/阿富汗",
  "Asia/Pakistan": "亞洲/巴基斯坦",
  "Asia/Nepal": "亞洲/尼泊爾",
  "Asia/India": "亞洲/印度",
  "Asia/Malaysia": "亞洲/馬來西亞",
  "Asia/Kuwait": "亞洲/科威特",
  "Asia/Macau": "亞洲/澳門",
  "Asia/Philippines": "亞洲/菲律賓",
  "Asia/Oman": "亞洲/阿曼",
  "Asia/Cambodia": "亞洲/柬埔寨",
  "Asia/North_Korea": "亞洲/北朝鮮",
  "Asia/Qatar": "亞洲/卡塔爾",
  "Asia/Saudi_Arabia": "亞洲/沙特阿拉伯",
  "Asia/Uzbekistan": "亞洲/烏茲別克斯坦",
  "Asia/South_Korea": "亞洲/韓國",
  "Asia/Singapore": "亞洲/新加坡",
  "Asia/Taiwan": "亞洲/台灣",
  "Asia/Georgia": "亞洲/格魯吉亞",
  "Asia/Iran": "亞洲/伊朗",
  "Asia/Bhutan": "亞洲/不丹",
  "Asia/Japan": "亞洲/日本",
  "Asia/Laos": "亞洲/老撾",
  "Asia/Myanmar": "亞洲/緬甸",
  "Asia/Armenia": "亞洲/亞美尼亞",
  "Europe/Netherlands": "歐洲/荷蘭",
  "Europe/Andorra": "歐洲/安道爾",
  "Europe/Greece": "歐洲/希臘",
  "Europe/Serbia": "歐洲/塞爾維亞",
  "Europe/Germany": "歐洲/德國",
  "Europe/Slovakia": "歐洲/斯洛伐克",
  "Europe/Belgium": "歐洲/比利時",
  "Europe/Romania": "歐洲/羅馬尼亞",
  "Europe/Hungary": "歐洲/匈牙利",
  "Europe/Moldova": "歐洲/摩爾多瓦",
  "Europe/Denmark": "歐洲/丹麥",
  "Europe/Ireland": "歐洲/愛爾蘭",
  "Europe/Gibraltar": "歐洲/直布羅陀",
  "Europe/Guernsey": "歐洲/根西島",
  "Europe/Finland": "歐洲/芬蘭",
  "Europe/Isle_of_Man": "歐洲/馬恩島",
  "Europe/Turkey": "歐洲/土耳其",
  "Europe/Jersey": "歐洲/澤西島",
  "Europe/Russia/Kaliningrad_Time": "歐洲/俄羅斯/加里寧格勒時間",
  "Europe/Russia/Moscow_Time": "歐洲/俄羅斯/莫斯科_時間",
  "Europe/Russia/Samara_Time": "歐洲/俄羅斯/薩馬拉時間",
  "Europe/Ukraine": "歐洲/烏克蘭",
  "Europe/Portugal": "歐洲/葡萄牙",
  "Atlantic/Portugal/Azores": "大西洋/葡萄牙/亞速爾群島",
  "Europe/Slovenia": "歐洲/斯洛文尼亞",
  "Europe/United_Kingdom": "歐洲/英國",
  "Europe/Luxembourg": "歐洲/盧森堡",
  "Europe/Spain": "歐洲/西班牙",
  "Europe/Malta": "歐洲/馬耳他",
  "Europe/Åland_Islands": "歐洲/奧蘭群島",
  "Europe/Belarus": "歐洲/白俄羅斯",
  "Europe/France": "歐洲/法國",
  "Europe/Cyprus": "歐洲/塞浦路斯",
  "Europe/Norway": "歐洲/挪威",
  "Europe/Montenegro": "歐洲/黑山",
  "Europe/Czech_Republic": "歐洲/捷克共和國",
  "Europe/Latvia": "歐洲/拉脫維亞",
  "Europe/Italy": "歐洲/意大利",
  "Europe/San_Marino": "歐洲/聖馬力諾",
  "Europe/Bosnia_and_Herzegovina": "歐洲/波斯尼亞和黑塞哥維那",
  "Europe/Macedonia": "歐洲/馬其頓",
  "Europe/Bulgaria": "歐洲/保加利亞",
  "Europe/Sweden": "歐洲/瑞典",
  "Europe/Estonia": "歐洲/愛沙尼亞",
  "Europe/Albania": "歐洲/阿爾巴尼亞",
  "Europe/Moldova": "歐洲/摩爾多瓦",
  "Europe/Liechtenstein": "歐洲/列支敦士登",
  "Europe/Holy_See_Vatican": "歐洲/梵蒂岡",
  "Europe/Austria": "歐洲/奧地利",
  "Europe/Lithuania": "歐洲/立陶宛",
  "Europe/Poland": "歐洲/波蘭",
  "Europe/Croatia": "歐洲/克羅地亞",
  "Europe/Switzerland": "歐洲/瑞士",
  "Europe/Iceland": "歐洲/冰島",
  "Oceania/Australia/Western Standard Time": "大洋洲/澳大利亞/西部標準時間",
  "Oceania/Australia/Central Western Standard Time": "大洋洲/澳大利亞/中西部標準時間",
  "Oceania/Australia/Central Standard Time": "大洋洲/澳大利亞/中部標準時間",
  "Oceania/Australia/Eastern Standard Time": "大洋洲/澳大利亞/東部標準時間",
  "Oceania/Australia/Lord Howe Standard Time": "大洋洲/澳大利亞/豪勳爵標準時間",
  "Oceania/New_Zealand": "大洋洲/新西蘭",
  "Oceania/New_Zealand/Chatham Island": "大洋洲/新西蘭/查塔姆島",
  "Admin_Auto_Email_opening_title": "迅維招聘人員賬戶開設",
  "Admin_Auto_Email_add_quota_title": "增加迅維面試配額",
  "Admin_Auto_Email_suspension_title": "迅維招聘人員帳戶暫停",
  "Admin_Auto_Email_reactivation_title": "迅維招聘人員帳戶重新激活",
  "Admin_Auto_Email_out_of_quota_title": "迅維招聘人員帳戶超出配額警告",
  "Admin_Auto_Email_low_quota_title": "迅維招聘人員帳戶 - 配額不足警告",
  "Admin_Auto_Email_return_quota_title": "迅維面試配額歸還",
  "Admin_Auto_Email_opening_content": '<p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">你好 {{Recruiter’s name, don’t change}},</span></p><p style="text-align:start;">&nbsp;</p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">請在下方找到你的迅維招聘人員帳戶的登錄詳細信息，如下所示：</span></p><p style="text-align:start;">&nbsp;</p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">網站:</span> <a href="https://apisit.neufast.com/" target="_blank"><span style="color: blue;font-size: medium;font-family: Times New Roman", serif;">apisit.neufast.com</span></a></p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">用戶名: {{Login email, don’t change}}</span>&nbsp;</p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">密碼: {{Login password, don’t change}}</span></p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">數量面試配額: {{Number of interview quota}}</span></p><p style="text-align:start;">&nbsp;</p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">請使用最新的 Chrome 瀏覽器（89 或 90 版）或 Firefox 訪問。此處附上用戶指南供你參考。</span></p><p style="text-align:start;">&nbsp;</p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">如有任何疑問，請隨時聯繫我們。非常感謝！</span></p><p style="text-align:start;">&nbsp;</p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">祝好，</span></p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">迅維客戶服務團隊</span></p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">電郵: customer-service@neufast.com</span></p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">電話: (+852) 59876904</span></p>',
  "Admin_Auto_Email_add_quota_content": '<p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">你好 {{Recruiter’s name, don’t change}},</span></p><p style="text-align:start;">&nbsp;</p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">請注意，以下數量的面試配額已添加到你的招聘人員帳戶中。</span>&nbsp;</p><p style="text-align:start;">&nbsp;</p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">新增面試配額數量: {{Number of interview quota added}}</span></p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">面試配額餘額: {{Number of interview quota balance}}</span></p><p style="text-align:start;">&nbsp;</p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">如有任何疑問，請隨時聯繫我們。 謝謝非常喜歡！</span></p><p style="text-align:start;">&nbsp;</p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">祝好,</span></p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">迅維客戶服務團隊</span></p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">電郵: customer-service@neufast.com</span></p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">電話: (+852) 59876904</span></p>',
  "Admin_Auto_Email_suspension_content": '<p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">你好 {{Recruiter’s name, don’t change}},</span></p><p style="text-align:start;">&nbsp;</p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">請注意，你的招聘人員帳戶已被暫停。</span>&nbsp;</p><p style="text-align:start;">&nbsp;</p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">如果你有任何疑問，請隨時與我們聯繫。非常感謝！</span></p><p style="text-align:start;">&nbsp;</p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">祝好,</span></p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">迅維客戶服務團隊</span></p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">電郵: customer-service@neufast.com</span></p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">電話: (+852) 59876904</span></p>',
  "Admin_Auto_Email_reactivation_content": '<p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">你好 {{Recruiter’s name, don’t change}},</span></p><p style="text-align:start;">&nbsp;</p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">請注意你的招聘人員帳戶已重新激活。</span>&nbsp;</p><p style="text-align:start;">&nbsp;</p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">如果你有任何疑問，請隨時與我們聯繫。非常感謝！</span></p><p style="text-align:start;">&nbsp;</p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">祝好,</span></p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">迅維客戶服務團隊</span></p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">電郵: customer-service@neufast.com</span></p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">電話: (+852) 59876904</span></p>',
  "Admin_Auto_Email_out_of_quota_content": '<p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">你好 {{Recruiter’s name, don’t change}},</span></p><p style="text-align:start;">&nbsp;</p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">請注意，你的招聘賬戶餘額已降至零。請聯繫我們購買更多面試名額，以確保不間斷的面試服務。</span></p><p style="text-align:start;">&nbsp;</p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">如有任何疑問，請隨時聯繫我們。非常感謝！</span></p><p style="text-align:start;">&nbsp;</p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">祝好,</span></p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">迅維客戶服務團隊</span></p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">電郵: customer-service@neufast.com</span></p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">電話: (+852) 59876904</span></p>',
  "Admin_Auto_Email_low_quota_content": '<p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">你好 {{Recruiter’s name, don’t change}},</span></p><p style="text-align:start;">&nbsp;</p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">請注意，你的招聘賬戶餘額已降至僅 5。請聯繫我們購買更多面試名額，以確保不間斷的面試服務。</span></p><p style="text-align:start;">&nbsp;</p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">如有任何疑問，請隨時聯繫我們。非常感謝！</span></p><p style="text-align:start;">&nbsp;</p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">祝好,</span></p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">迅維客戶服務團隊</span></p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">電郵: customer-service@neufast.com</span></p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">電話: (+852) 59876904</span></p>',
  "Admin_Auto_Email_return_quota_content": '<p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">你好 {{Recruiter’s name, don’t change}},</span></p><p style="text-align:start;">&nbsp;</p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">請注意，以下數量的面試配額已添加到你的招聘人員帳戶中。</span>&nbsp;</p><p style="text-align:start;">&nbsp;</p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">減少的面試配額數量: {{Number of interview quota added}}</span></p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">面試配額餘額: {{Number of interview quota balance}}</span></p><p style="text-align:start;">&nbsp;</p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">如有任何疑問，請隨時聯繫我們。 謝謝你你非常喜歡！</span></p><p style="text-align:start;">&nbsp;</p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">祝好,</span></p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">迅維客戶服務團隊</span></p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">電郵: customer-service@neufast.com</span></p><p style="text-align:start;"><span style="font-size: medium;font-family: Times New Roman", serif;">電話: (+852) 59876904</span></p>',
  "Sap_status_update_fail": "Success Factor連線失敗",
  "Recruiter_Candidate_Result_Invalid_Identity": "招聘人員帳戶無權查看此求職者的信息。 請使用正確的帳戶。",
  "Sap_videolink_welcome_message": "請輸入你的登錄詳細信息以打開求職者之面試分析",
  "Candidate_Interview_WelcomeTitle_jc": "歡迎您，{name}！\n 請參與視像錄影，讓我們多認識你。",
  "Candidate_Instruction_Details_jc": ['找一個安靜的地方進行錄影。', '將設備放在支架上或用平穩的手握住。', '請關閉其他網頁和應用程式。', '為了錄製高質量的影像以進行公平的評估，請不要在錄影進行期間配戴口罩。'],
  "Candidate_Settings_Caption_jc": "在進行錄影之前，請確保您設備的網絡攝像頭、麥克風和揚聲器已打開並正常工作。",
  "Candidate_Detail_Video_Interview_Paragraph_1_normal_jc": "您的錄影包括 {noOfQuestion} {measureWord} 問題。",
  "Candidate_Practice_Title_jc": "練習錄影",
  "Candidate_Practice_Welcome_Title_jc": '歡迎使用練習錄影',
  "Candidate_RealInterview_Welcome_Title_jc": '歡迎來進行錄影!',
  "Candidate_RealInterview_Title_jc": "視像錄影",
  "Candidate_Finish_Logout_jc": "返回到JC PROcruit C",
  "PDF_Bulk_download_title":"PDF批量下載狀態",
  "PDF_Bulk_download_content":"以下求職者的報告無法下載",
  "PDF_Bulk_download_status":"狀態",
  "PDF_Bulk_download_fail":"失敗",
  "PDF_Bulk_download_reason":"報告未被準備好",
  "Recruiter_Settings_Export_Column_Candidate_Answer": "求職者答案",
  "Candidate_CandidateProfile_With_CV_OPTION" : "I have a resume",
  "Candidate_CandidateProfile_Without_CV_OPTION" : "I don't have a resume",
  "Candidate_CandidateProfile_WorkExperience_SubTitle" : "Work Experience",
  "Candidate_CandidateProfile_Education_SubTitle" : "Education",
  "Candidate_CandidateProfile_Confirm_Title" : "Resume Upload Confirmation", 
  "Candidate_CandidateProfile_Confirm_Content" : "Please make sure all filled information is correct, you will not be allowed to modify once you click the CONFIRM button below.", 
  "Candidate_CandidateProfile_Validation_Error_Msg" : "there are some errors in the filled fields, please check again.",
  "Recruiter_CandidateProfile_Languages_Title": "Languages",
  "Recruiter_CandidateProfile_Upload_Title" : "Before the interview, please upload your resume",
  "Candidate_CandidateProfile_Action_Upload" : "Submit",
  "Recruiter_Layout_ShowConsent" : "添加自定義用戶協議",
  "Recruiter_Layout_ShowConsent_Tooltip" : "這為候選人啟用了定制的用戶協議",
  "Recruiter_Layout_ShowConsent_Default_Message" : "<p>這是一份用戶協議</p>",
  "Recruiter_Layout_ShowConsent_Title" : "協議內容",
  "Candidate_Consent_Form_Title" : "用戶協議",
  "Candidate_Consent_Form_Checkbox_Content" : "我已閱讀並同意用戶協議",
  "Candidate_Consent_Form_Confirmation_Title" : "確認",
  "Candidate_Consent_Form_Confirmation_Content" : "點擊確認後，您需要聯繫我們進行提現，請務必確認同意。",
  "Candidate_Consent_Form_Non_Latest_Message" : "您正在檢查舊版本的用戶協議，請刷新並重試。",
  "Candidate_Consent_Form_No_Consent_ID" : "此用戶協議不在數據庫中，請刷新並重試。",
  "Do_you_confirm_your_interview_language": "您確認您的面試語言嗎？",
  "You_selected": "您選擇：",
  "You_can_not_change_it_once_you_click_confirm": "*單擊確認後，您將無法更改它",
  "Cancel": "取消",
  "Confirm": "確認",
  "Candidate_Consent_Form_Non_Latest_Message" : "您正在檢查舊版本的同意書，請刷新並重試。",
  "Candidate_Consent_Form_No_Consent_ID" : "此同意不在數據庫中，請刷新並重試。",
  "SESSION_TIMEOUT_TITLE" : "Session Timeout",
  "SESSION_TIMEOUT_CONTENT": "You're being timed out due to inactivity. Please choose to stay signed in or to logoff. Otherwise, you will be logged out automatically in {remaining} seconds.",
  "SESSION_STAY_LOGGED_IN": "Stay Logged In",
  "SESSION_LOGOUT": "Logout",
  "Session_Management_Title" : "Session Management",
  "Preview": "Preview"
}
